{
  "common": {
    "address": "Adress",
    "id": "ID",
    "yes": "Ja",
    "no": "Nej",
    "all": "Alla",
    "mixed": "Blandat",
    "unknown": "Okänt",
    "read_more_button": "Läs mer",
    "click_to_learn_more": "Klicka för att läsa mer",
    "none": "Ingen",
    "other": "Övrig",
    "edit": "Redigera",
    "date": "Datum: {date}",
    "kw": "kW",
    "kwh": "kWh",
    "mwh": "MWh",
    "gwh": "GWh",
    "eur": "€",
    "months_abbrev": {
      "1": "Jan",
      "2": "Feb",
      "3": "Mar",
      "4": "Apr",
      "5": "Maj",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Okt",
      "11": "Nov",
      "12": "Dec"
    },
    "next": "Nästa",
    "back": "Tillbaka",
    "save": "Spara",
    "saving": "Sparar",
    "cancel": "Avbryt",
    "confirm": "Bekräfta",
    "continue": "Fortsätt",
    "step": "Steg",
    "optional": "Valfritt",
    "saved_successfully": "Sparad framgångsrikt",
    "unsaved_changes_confirm": "Du har osparade ändringar. Lämna sidan och kasta dem?",
    "clear": "Rensa",
    "filter": "Filtrera",
    "search": "Sök",
    "select": "Välj",
    "select_all": "Välj alla",
    "clear_all": "Rensa val",
    "pricing_loading_messages": {
      "retrieving_market_levels": "Hämtar marknadsnivåer...",
      "applying_sourcing_criteria": "Tillämpar anskaffningskriterier...",
      "calculating_fees": "Beräknar avgifter..."
    },
    "selected": "valda",
    "total_volume": "Total volym",
    "last_updated": "Senast uppdaterad",
    "certificate": "Certifikat",
    "volume": "Volym",
    "technology_label": "Teknik",
    "uploaded": "Uppladdad",
    "not_uploaded": "Inte uppladdad",
    "any_file_format": "Alla filformat",
    "pdf_file_format": "Accepterar filer i .pdf-format",
    "invalid_file_error": "Ogiltig fil tillhandahållen, vänligen ladda upp en giltig fil.",
    "invalid_file_contact_support": "Om du tror att detta är ett misstag och att detta dokument faktiskt är giltigt, vänligen kontakta vår kundtjänst. För att göra detta, klicka på chattbubblan i det nedre högra hörnet av skärmen eller välj 'Kontakta oss' i toppmenyn.",
    "coming_soon": "Kommer snart",
    "hide_admin_options": "Dölj administratörsalternativ",
    "show_admin_options": "Visa administratörsalternativ",
    "contactSupport": "Kontakta support",
    "loading": "Laddar",
    "uploading": "Laddar upp...",
    "pending": "Väntande",
    "rejected": "Avvisad",
    "active": "Aktiv",
    "status": "Status:",
    "add": "Lägg till",
    "creating": "Skapar...",
    "create_device": "Skapa enhet",
    "not_specified": "Ej specificerat",
    "page_navigation": "Sidnavigering",
    "previous_page": "Föregående sida",
    "next_page": "Nästa sida",
    "remove": "Ta bort",
    "delete": "Ta bort",
    "deleted": "(raderad)",
    "download": "Ladda ner",
    "close": "Stäng",
    "open_pdf": "Öppna PDF",
    "success": "Framgång",
    "add_another_unit": "Lägg till en annan enhet",
    "saved": "Sparad",
    "retry": "Försök igen",
    "unexpected_error": "Oväntat fel, försök igen senare!",
    "select_option": "Välj alternativ",
    "year": "År",
    "years": "År",
    "month": "Månad",
    "months": "Månader",
    "day": "Dag",
    "select_month": "Välj månad",
    "select_day": "Välj dag",
    "full_name": "Fullständigt namn",
    "name": "Namn",
    "start_date": "Startdatum",
    "end_date": "Slutdatum",
    "email": "E-post",
    "company_search": {
      "label": "Företagssökning",
      "description": "Sök efter företag via namn, organisationsnummer eller momsregistreringsnummer",
      "placeholder": "Ange företagsnamn, organisationsnummer eller momsregistreringsnummer",
      "ai_extracted": "AI-extraherad",
      "custom_entry": "Anpassad post",
      "unavailable": "Företagssökningen är inte tillgänglig, ange företagets uppgifter manuellt"
    },
    "counterparty_picker": {
      "company_label": "Företagsnamn",
      "account_label": "Registerkontonummer",
      "account_invalid": "Kontonumret får endast innehålla bokstäver och siffror",
      "account_invalid_aib": "Måste vara en giltig EECS-identifierare (2 siffror, X och 7 alfanumeriska tecken)",
      "account_invalid_rego": "Måste vara ett Ofgem-kontonummer (GEN, PAR, SUP eller AGE följt av 7 siffror)",
      "account_invalid_rgp": "Måste vara en TGE-medlemskod (bokstäver och siffror, t.ex. RESENENC)",
      "account_unrecognized_warning": "Inte ett känt kontonummerformat - registerlandet kan inte identifieras automatiskt.",
      "internal_account_label": "Registrets interna kontonummer",
      "internal_account_help": "Valfritt. Krävs endast för register som använder underkonton.",
      "internal_account_placeholder": "Valfritt underkonto-ID"
    },
    "eecs_name_mismatch": {
      "both": "Företagsnamnet och EECS stämmer inte. {name} matchar EECS: {expectedEecs} och {eecs} matchar {expectedName}",
      "eecs_only": "Företagsnamnet och EECS stämmer inte. Ingen matchande EECS för {name} och {eecs} matchar {expectedName}",
      "name_only": "Företagsnamnet och EECS stämmer inte. {name} matchar EECS: {expectedEecs} och {eecs} matchar inget företag",
      "unknown_counterparty": "Kontrollera företagsnamn och kontonummer i avtalet."
    },
    "no_results": "Inga resultat hittades",
    "partial_results": "Visar de första {shown} av {total} träffarna — förfina sökningen",
    "technology": {
      "solar": "Solenergi",
      "wind": "Vindkraft",
      "hydro": "Vattenkraft",
      "biomass": "Biomassa",
      "nuclear": "Kärnkraft",
      "mixed": "Blandat"
    },
    "country": {
      "AD": "Andorra",
      "AE": "Förenade Arabemiraten",
      "AF": "Afghanistan",
      "AG": "Antigua och Barbuda",
      "AI": "Anguilla",
      "AL": "Albanien",
      "AM": "Armenien",
      "AO": "Angola",
      "AQ": "Antarktis",
      "AR": "Argentina",
      "AS": "Amerikanska Samoa",
      "AT": "Österrike",
      "AU": "Australien",
      "AW": "Aruba",
      "AX": "Åland",
      "AZ": "Azerbajdzjan",
      "BA": "Bosnien och Hercegovina",
      "BB": "Barbados",
      "BD": "Bangladesh",
      "BE": "Belgien",
      "BF": "Burkina Faso",
      "BG": "Bulgarien",
      "BH": "Bahrain",
      "BI": "Burundi",
      "BJ": "Benin",
      "BL": "S:t Barthélemy",
      "BM": "Bermuda",
      "BN": "Brunei",
      "BO": "Bolivia",
      "BQ": "Karibiska Nederländerna",
      "BR": "Brasilien",
      "BS": "Bahamas",
      "BT": "Bhutan",
      "BV": "Bouvetön",
      "BW": "Botswana",
      "BY": "Belarus",
      "BZ": "Belize",
      "CA": "Kanada",
      "CC": "Kokosöarna",
      "CD": "Kongo-Kinshasa",
      "CF": "Centralafrikanska republiken",
      "CG": "Kongo-Brazzaville",
      "CH": "Schweiz",
      "CI": "Elfenbenskusten",
      "CK": "Cooköarna",
      "CL": "Chile",
      "CM": "Kamerun",
      "CN": "Kina",
      "CO": "Colombia",
      "CR": "Costa Rica",
      "CU": "Kuba",
      "CV": "Kap Verde",
      "CW": "Curaçao",
      "CX": "Julön",
      "CY": "Cypern",
      "CZ": "Tjeckien",
      "DE": "Tyskland",
      "DJ": "Djibouti",
      "DK": "Danmark",
      "DM": "Dominica",
      "DO": "Dominikanska republiken",
      "DZ": "Algeriet",
      "EC": "Ecuador",
      "EE": "Estland",
      "EG": "Egypten",
      "EH": "Västsahara",
      "ER": "Eritrea",
      "ES": "Spanien",
      "ET": "Etiopien",
      "FI": "Finland",
      "FJ": "Fiji",
      "FK": "Falklandsöarna",
      "FM": "Mikronesien",
      "FO": "Färöarna",
      "FR": "Frankrike",
      "GA": "Gabon",
      "GB": "Storbritannien",
      "GD": "Grenada",
      "GE": "Georgien",
      "GF": "Franska Guyana",
      "GG": "Guernsey",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GL": "Grönland",
      "GM": "Gambia",
      "GN": "Guinea",
      "GP": "Guadeloupe",
      "GQ": "Ekvatorialguinea",
      "GR": "Grekland",
      "GS": "Sydgeorgien och Sydsandwichöarna",
      "GT": "Guatemala",
      "GU": "Guam",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HK": "Hongkong SAR",
      "HM": "Heardön och McDonaldöarna",
      "HN": "Honduras",
      "HR": "Kroatien",
      "HT": "Haiti",
      "HU": "Ungern",
      "ID": "Indonesien",
      "IE": "Irland",
      "IL": "Israel",
      "IM": "Isle of Man",
      "IN": "Indien",
      "IO": "Brittiska territoriet i Indiska oceanen",
      "IQ": "Irak",
      "IR": "Iran",
      "IS": "Island",
      "IT": "Italien",
      "JE": "Jersey",
      "JM": "Jamaica",
      "JO": "Jordanien",
      "JP": "Japan",
      "KE": "Kenya",
      "KG": "Kirgizistan",
      "KH": "Kambodja",
      "KI": "Kiribati",
      "KM": "Komorerna",
      "KN": "S:t Kitts och Nevis",
      "KP": "Nordkorea",
      "KR": "Sydkorea",
      "KW": "Kuwait",
      "KY": "Caymanöarna",
      "KZ": "Kazakstan",
      "LA": "Laos",
      "LB": "Libanon",
      "LC": "S:t Lucia",
      "LI": "Liechtenstein",
      "LK": "Sri Lanka",
      "LR": "Liberia",
      "LS": "Lesotho",
      "LT": "Litauen",
      "LU": "Luxemburg",
      "LV": "Lettland",
      "LY": "Libyen",
      "MA": "Marocko",
      "MC": "Monaco",
      "MD": "Moldavien",
      "ME": "Montenegro",
      "MF": "Saint-Martin",
      "MG": "Madagaskar",
      "MH": "Marshallöarna",
      "MK": "Nordmakedonien",
      "ML": "Mali",
      "MM": "Myanmar (Burma)",
      "MN": "Mongoliet",
      "MO": "Macao SAR",
      "MP": "Nordmarianerna",
      "MQ": "Martinique",
      "MR": "Mauretanien",
      "MS": "Montserrat",
      "MT": "Malta",
      "MU": "Mauritius",
      "MV": "Maldiverna",
      "MW": "Malawi",
      "MX": "Mexiko",
      "MY": "Malaysia",
      "MZ": "Moçambique",
      "NA": "Namibia",
      "NC": "Nya Kaledonien",
      "NE": "Niger",
      "NF": "Norfolkön",
      "NG": "Nigeria",
      "NI": "Nicaragua",
      "NL": "Nederländerna",
      "NO": "Norge",
      "NP": "Nepal",
      "NR": "Nauru",
      "NU": "Niue",
      "NZ": "Nya Zeeland",
      "OM": "Oman",
      "PA": "Panama",
      "PE": "Peru",
      "PF": "Franska Polynesien",
      "PG": "Papua Nya Guinea",
      "PH": "Filippinerna",
      "PK": "Pakistan",
      "PL": "Polen",
      "PM": "S:t Pierre och Miquelon",
      "PN": "Pitcairnöarna",
      "PR": "Puerto Rico",
      "PS": "Palestinska territorierna",
      "PT": "Portugal",
      "PW": "Palau",
      "PY": "Paraguay",
      "QA": "Qatar",
      "RE": "Réunion",
      "RO": "Rumänien",
      "RS": "Serbien",
      "RU": "Ryssland",
      "RW": "Rwanda",
      "SA": "Saudiarabien",
      "SB": "Salomonöarna",
      "SC": "Seychellerna",
      "SD": "Sudan",
      "SE": "Sverige",
      "SG": "Singapore",
      "SH": "S:t Helena",
      "SI": "Slovenien",
      "SJ": "Svalbard och Jan Mayen",
      "SK": "Slovakien",
      "SL": "Sierra Leone",
      "SM": "San Marino",
      "SN": "Senegal",
      "SO": "Somalia",
      "SR": "Surinam",
      "SS": "Sydsudan",
      "ST": "São Tomé och Príncipe",
      "SV": "El Salvador",
      "SX": "Sint Maarten",
      "SY": "Syrien",
      "SZ": "Eswatini",
      "TC": "Turks- och Caicosöarna",
      "TD": "Tchad",
      "TF": "Franska sydterritorierna",
      "TG": "Togo",
      "TH": "Thailand",
      "TJ": "Tadzjikistan",
      "TK": "Tokelauöarna",
      "TL": "Östtimor",
      "TM": "Turkmenistan",
      "TN": "Tunisien",
      "TO": "Tonga",
      "TR": "Turkiet",
      "TT": "Trinidad och Tobago",
      "TV": "Tuvalu",
      "TW": "Taiwan",
      "TZ": "Tanzania",
      "UA": "Ukraina",
      "UG": "Uganda",
      "UM": "USA:s yttre öar",
      "US": "USA",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VA": "Vatikanstaten",
      "VC": "S:t Vincent och Grenadinerna",
      "VE": "Venezuela",
      "VG": "Brittiska Jungfruöarna",
      "VI": "Amerikanska Jungfruöarna",
      "VN": "Vietnam",
      "VU": "Vanuatu",
      "WF": "Wallis- och Futunaöarna",
      "WS": "Samoa",
      "XK": "Kosovo",
      "YE": "Jemen",
      "YT": "Mayotte",
      "ZA": "Sydafrika",
      "ZM": "Zambia",
      "ZW": "Zimbabwe",
      "BE_BRU": "Belgien (Bryssel)",
      "BE_FED": "Belgien (Federal)",
      "BE_FLA": "Belgien (Flandern)",
      "BE_WAL": "Belgien (Vallonien)",
      "other": "Övriga"
    },
    "done": "Klar",
    "company": "Företag",
    "companies": "Företag",
    "search_companies": "Sök företag",
    "select_companies": "Välj företag",
    "documents": "Dokument",
    "contracts": "Kontrakt",
    "devices": "Enheter",
    "actions": {
      "title": "Åtgärder",
      "send": "Skicka",
      "receive": "Ta emot",
      "portfolios": "Portföljer",
      "buy": "Köp",
      "buy_and_cancel": "Köp och annullera",
      "sell": "Sälj",
      "cancel": "@:common.cancel",
      "confirm_send": "Bekräfta sändningsorder",
      "confirm_sell": "Bekräfta försäljningsinställning",
      "accept": "Acceptera"
    },
    "eacs_in_inventory": "ursprungsgarantier i lager",
    "settings": "Inställningar",
    "action_items": "Åtgärd krävs",
    "type_here": "Skriv ditt meddelande här...",
    "placeholderText": "Platshållartext - ange mer specifik kontext om möjligt.",
    "production_period": "Produktionsperiod",
    "production_year": "Produktionsår"
  },
  "primevue": {
    "startsWith": "Börjar med",
    "contains": "Innehåller",
    "notContains": "Innehåller inte",
    "endsWith": "Slutar med",
    "equals": "Är lika med",
    "notEquals": "Är inte lika med",
    "noFilter": "Ingen filtrering",
    "lt": "Mindre än",
    "lte": "Mindre än eller lika med",
    "gt": "Större än",
    "gte": "Större än eller lika med",
    "dateIs": "Datum är",
    "dateIsNot": "Datum är inte",
    "dateBefore": "Datum före",
    "dateAfter": "Datum efter",
    "clear": "Rensa",
    "apply": "Använd",
    "matchAll": "Matcha alla",
    "matchAny": "Matcha någon",
    "addRule": "Lägg till regel",
    "removeRule": "Ta bort regel",
    "today": "Idag"
  },
  "language": {
    "en": "Engelska",
    "et": "Estniska",
    "lv": "Lettiska",
    "lt": "Litauiska",
    "sv": "Svenska"
  },
  "settings": {
    "title": "Inställningar",
    "select_language": "Välj språk",
    "name": "Namn",
    "email": "E-post",
    "phone": "Telefonnummer",
    "email_cannot_be_changed": "För att ändra kontots e-post, bjud in en ny teammedlem från Företagsinställningar-sidan",
    "receive_transaction_emails": "Ta emot försäljningsmeddelanden via e-post",
    "receive_transaction_emails_hint": "E-postmeddelanden om dina försäljningar av ursprungsgarantier, med avgiftsfakturorna bifogade. Ange en faktura-e-postadress i företagsinställningarna så att din revisor fortfarande får fakturorna även när detta är avstängt."
  },
  "app": {
    "development_environment": "Detta är utvecklingsmiljön",
    "staging_environment": "Detta är staging-miljön",
    "managing_client_account": "Hanterar kundens konto: {email}",
    "stop_managing": "Sluta hantera",
    "log_in": "Logga in",
    "log_out": "Logga ut",
    "error_occurred": "Ett fel har inträffat",
    "error_message_code": "Felkod: {errorCode}",
    "contact_support": "Vänligen kontakta support för att lösa detta problem. Klicka på chattbubblan i det nedre högra hörnet av skärmen eller välj 'Kontakta oss' i toppmenyn."
  },
  "signup": {
    "choose_company_country": "Det land ni producerar energi i",
    "select_country_placeholder": "Välj ett land",
    "legal": {
      "byJoining": "Genom att registrera dig godkänner du",
      "membershipAgreement": "Solderas plattformsavtal.",
      "personalDataNote": "Dina personuppgifter kommer att behandlas i enlighet med vår",
      "privacyPolicy": "Integritetspolicy."
    },
    "modal": {
      "hello_button": "Starta registrering",
      "hello": "👋 Välkommen!",
      "soldera_faq": "i Soldera FAQ",
      "lv": {
        "section1": "Härligt att ni har beslutat er för att gå med i Soldera. Om ni har några frågor kan ni hitta svar på de viktigaste frågorna här",
        "section2": "Genom att fylla i informationen nedan ger du Soldera tillgång till att hantera era ursprungsgarantier i ert konto hos Energimyndigheten. Vi kommer också att be er att signera en uppsättning dokument i Dokobit. Dessa dokument genereras automatiskt baserat på de uppgifter du anger. Om du stöter på några problem, vänligen skriv till oss i Chattbubblan det nedre högra hörnet eller välj 'Kontakta oss' från toppmenyn."
      },
      "ee": {
        "section1": "Välkommen!",
        "section2": "Härligt att se att ni beslutat er för att ansluta till Soldera. Om ni har några frågor kan ni hitta svar på vanliga frågor här:",
        "section3": "Om ni ännu inte säljer ursprungsgarantier",
        "section4": "Vi hjälper er att förbereda och skicka in alla nödvändiga dokument för att kunna sälja ursprungsgarantier. Det första steget är att ladda upp elnätsavtalet. Detta dokument, som krävs av Energimyndigheten, innehåller de flesta uppgifter som behövs för ursprungsgarantierna.",
        "section5": "Efter att ha laddat upp elnätsavtalet kommer vi att ge en översikt över dina uppgifter och be om komplettering av eventuell information som saknas. När du har bekräftat alla uppgifter kommer vi att förbereda de nödvändiga dokumenten (inklusive avtalet med oss), be dig signera dem och sedan skicka dem till Energimyndigheten.",
        "section6": "Om du redan får ursprungsgarantier",
        "section7": "Om du vill att vi ska hantera försäljningen av dina ursprungsgarantier, klicka här eller på länken på sidan för elnätsavtal. Vi behöver uppgifter på anläggningens ägare och dess firmatecknare. Baserat på dessa uppgifter kommer vi att förbereda relevanta fullmakter och ingå ett avtal med dig."
      }
    },
    "message_rate_limited_title": "För många meddelanden",
    "message_rate_limited": "Du har skickat flera meddelanden på kort tid. Vänta en timme innan du skickar ett nytt, eller kontakta support@soldera.org.",
    "new_country": {
      "ask_for_message": "Vi planerar att expandera till detta land.",
      "ask_for_message_2": "Effektivisera er hantering av ursprungsgarantier, från utfärdande och rapportering till försäljning. Kontakta oss med en kort beskrivning av din anläggning, så ska vi kika på hur vi kan hjälpa dig.",
      "send_message": "Skicka meddelande",
      "message_sent": "Meddelande skickat",
      "success_message": "Ditt meddelande har skickats",
      "error_message": "Ditt meddelande gick inte att skicka, var vänlig försök igen senare",
      "placeholder": "Skriv ditt meddelande här"
    },
    "grid_contract_upload": {
      "title": "Uppladdning av elnätsavtal",
      "description": "Vi behöver ditt giltiga elnätsavtal för anläggningen för att fylla i och skicka in de nödvändiga dokumenten för registrering.",
      "link_text": "Om din anläggning redan får ursprungsgarantier från Energimyndigheten, vänligen klicka här.",
      "upload_prompt": "Klicka här för att ladda upp elnätsavtalet.",
      "supported_formats": "För närvarande stöder vi endast dokument i .pdf-format.",
      "existing_contract_error": "Enheten {eic} är redan registrerad. {link}",
      "manage_devices_link": "Hantera anläggningar här.",
      "wrong_file_error": "Det verkar som att du har laddat upp en fil som inte är ett elnätsavtal. Mer information om att hitta ert elnätsavtal finns nedan.",
      "contact_support": "Om du tror att detta är ett misstag och det uppladdade dokumentet verkligen är ett elnätsavtal, vänligen kontakta vår kundtjänst. För att göra detta, klicka på chattbubblan i det nedre högra hörnet av skärmen eller välj 'Kontakta oss' i toppmenyn.",
      "finding_contract_title": "Var hittar man elnätsavtalet?",
      "elektrilevi_contract_info": "För att hitta elnätsavtalet med Elektrilevi",
      "elektrilevi_contract_link_text": "klicka här för att komma till deras e-tjänst.",
      "vkg_contract_info": "För att hitta elnätsavtalet med VKG Elektrivõrgud",
      "vkg_contract_link_text": "klicka här för att komma till deras e-tjänst."
    },
    "multiple_upload": {
      "title": "Dokumentuppladdning",
      "description": "Vänligen ladda upp följande dokument för att fortsätta med registreringen.",
      "lt_inspection_report": "Senaste tekniska inspektionsrapporten",
      "lt_inspection_report_where_to_find": "Vänligen hitta detta dokument i <a href=\"https://www.epaslaugos.lt/portal/service/92420/16020\" target=\"_blank\"> statlig e-tjänstportal </a>",
      "lt_property_limit_scheme": "anläggningens planritning",
      "lt_property_limit_scheme_where_to_find": "Vänligen leta efter detta dokument i installationsavtalet för anläggningen",
      "lt_power_of_attorney": "Fullmakt (ex: JAR ESI)",
      "lt_power_of_attorney_where_to_find": "Alla dokument som styrker din behörighet att representera det berörda företaget. Om anläggningen har flera ägare måste fullmakten inkludera signaturer från alla ägare.",
      "where_to_find_this_document": "Vart hittar man detta dokument?",
      "lt_invalid_power_of_attorney": "Vänligen ladda upp en giltig fullmakt",
      "UF_lv_grid_connection_scheme": "Nätanslutningsplan",
      "UF_lv_grid_connection_scheme_where_to_find": "Detta dokument bör erhållas från din nätägare. Det visar hur din produktionsenhet är ansluten till nätet och inkluderar relevanta mätpunkter.",
      "UF_lv_document_of_device_auxiliaries": "Dokument över hjälpsystem",
      "UF_lv_document_of_device_auxiliaries_where_to_find": "Detta dokument bör innehålla information om eventuella hjälpsystem eller utrustning som stödjer din anläggnings drift.",
      "UF_lv_power_of_attorney": "Fullmakt",
      "UF_lv_power_of_attorney_where_to_find": "Fullmakt signerad av ägaren/ägarna till produktionsanläggningen (i fall där kontohavaren inte är ägaren eller inte är den enda ägaren av produktionsanläggningen)"
    },
    "add_generator_component": {
      "title": "Anläggningsinformation(Generator?)",
      "subsidy_title": "Statliga subventioner för anläggning",
      "subsidy_question": "Har denna anläggning fått statligt stöd?",
      "elering_support": "Produktionsbidrag från Energimyndigheten",
      "battery_section_title": "Lagringsenhet (Batteri)",
      "battery_question": "Är generatorn (anläggningen?) kopplad till en lagringsenhet?",
      "battery_details": "Ange information för lagringsenheten",
      "unit_power": "Enhetseffekt (kW)",
      "capacity": "Kapacitet (kWh)",
      "ppa_section_title": "Elköpsavtal (PPA)",
      "ppa_question": "Säljs generatorns el under ett långsiktigt elköpsavtal (PPA)?",
      "ppa_include_certificates_question": "Inkluderar detta PPA försäljning av ursprungsgarantier?",
      "ppa_details": "Ange information om ert PPA",
      "ppa_start_date": "Startdatum",
      "ppa_mwh": "@:common.mwh",
      "ppa_client_name": "Kundens företagsnamn",
      "ppa_country": "Land",
      "enter_subsidies": "Ange subventioner",
      "add_subsidy": "Lägg till subvention",
      "device_technology_title": "Energislag",
      "device_technology_description": "Vänligen välj energislag",
      "device_technology_solar": "Solenergi",
      "device_technology_wind": "Vindenergi",
      "device_technology_hydro": "Vattenkraft",
      "device_technology_mixed": "Blandad energiproduktion bakom en mätpunkt"
    },
    "add_subsidy_component": {
      "subsidy_provider": "Subventionsgivare",
      "decision_date": "Beslutsdatum",
      "subsidy_plan": "Subventionsplan",
      "amount": "Belopp",
      "placeholder_provider": "T.ex.: Kredex, PRIA",
      "placeholder_plan": "T.ex.: Diversifieringsstöd",
      "subsidy_type": "Typ av stödordning",
      "subsidy_number": "Stödordningsnummer",
      "placeholder_number": "T.ex.: 1234567890",
      "investment": "Investeringsstöd",
      "production": "Produktionsstöd",
      "select_type": "Välj stödtyp",
      "objective": "Syfte med statligt stöd",
      "placeholder_objective": "T.ex.: Förnybar energi"
    },
    "contact_review_component": {
      "signer_title": "Firmatecknarens uppgifter",
      "generator_owner_title": "Ägaruppgifter för produktionsanläggningen",
      "generator_owner_subtext": "Vänligen ange ägaruppgifter för produktionsanläggningen.",
      "select_company": "Välj ägare",
      "add_new_company": "Ny ägare"
    },
    "role_selection": {
      "title": "Välj din roll",
      "subtitle": "För att komma igång, välj den väg som bäst beskriver dina behov",
      "corporate_title": "Jag är ett företag",
      "corporate_perfect_if": "Perfekt om du:",
      "corporate_benefit1": "Behöver AI-driven ESG/CBAM/CSRD- och SBTi-rapportering",
      "corporate_benefit2": "Vill köpa förnybar energi (EAC) direkt från producenter till bästa priser",
      "corporate_benefit3": "Vill minska efterlevnadskostnader med mer än 50%",
      "corporate_benefit4": "Behöver centraliserade multinationella revisonsrapporter",
      "producer_title": "Jag är en energiproducent",
      "producer_perfect_if": "Perfekt om du:",
      "producer_benefit1": "Äger eller driver vind-, sol-, vatten- eller biobränsleanläggningar",
      "producer_benefit2": "Vill maximera intäkterna från ursprungsgarantier (UG)",
      "producer_benefit3": "Behöver automatiserad registerhantering och handel",
      "producer_benefit4": "Vill stabilisera intäkter med forward-försäljning",
      "help_title": "Osäker på vilken väg som passar dig?",
      "help_description": "Har du ett blandat fall? Företag med viss produktion? Berätta bara om ditt företag så hjälper vi dig välja rätt väg.",
      "help_button": "Hjälp mig besluta",
      "help_form_label": "Berätta om ditt företag",
      "help_form_placeholder": "Till exempel: 'Vi är ett tillverkningsföretag med 2 MW taksolpaneler. Vi behöver främst hjälp med compliance men vill också hantera vår lilla produktion.'",
      "help_submit": "Skicka förfrågan",
      "help_success": "Tack! Vi återkommer till dig snart för att hjälpa dig välja rätt väg."
    },
    "corporate": {
      "title": "Företagsregistrering",
      "rate_limit_error": "Gränsen för skapande av företag har nåtts. Kontakta {supportEmail} om du ska ansluta en stor portfölj.",
      "description": "Automatisera ESG/CBAM/CSRD-efterlevnad med AI och köp EAC direkt från förnybara energiproducenter",
      "form_title": "Företagsinformation",
      "company_name": "Företagsnamn",
      "registry_code": "Organisationsnummer",
      "address": "Adress",
      "phone_number": "Telefonnummer",
      "vat": "Momsregistreringsnummer",
      "vat_optional": "Valfritt",
      "country": "Land",
      "select_country": "Välj ett land",
      "submit": "Slutför registrering",
      "platform_agreement_checkbox_label": "Genom att klicka på Acceptera godkänner du {link}."
    },
    "international": {
      "submit": "Skicka",
      "confirmation_title": "Tack för att du registrerade dig!",
      "confirmation_message": "Vårt team kontaktar dig snart för att slutföra konfigurationen av ditt konto.",
      "duplicate_company_error": "Ett företag med denna registreringskod finns redan för detta land. Vårt team kontaktar dig för att slutföra registreringen."
    },
    "generator_license_review": {
      "title": "produktionsanläggningens licensnummer (Anläggnings-ID?)",
      "description": "Vänligen hitta licensnumret kopplat till din produktionsenhets produktions- eller utvecklingstillstånd.",
      "directions": "För att hitta licensnumret, sök i <a href=\"https://www.licencijavimas.lt/lis-epp-app/public/licenceSearch\" target=\"_blank\">Litauens licensinformationssystem.</a>.",
      "licenseHints": "Möjliga licensnummer från Litgrid"
    },
    "user_type": {
      "select_title": "Välj ägartyp",
      "select_description": "Vänligen välj om du registrerar enhetsägaren som privatperson eller företag.",
      "private": {
        "button": "Registrera dig som privatperson",
        "description": "Välj detta om du registrerar din privata produktionsanläggning."
      },
      "company": {
        "button": "Registrera er som företag",
        "description": "Välj detta om du registrerar för ett företag eller en organisation som äger produktionsanläggningar."
      },
      "selection_prefix": "Du har valt:",
      "selected_private": "Registrera dig som privatperson",
      "selected_company": "Registrera er som företag"
    },
    "contract_review_component": {
      "data_review_title": "Översikt",
      "data_review_subtext": "Vänligen granska era uppgifter en sista gång för att säkerställa att allt är korrekt",
      "data_signer_title": "Firmatecknarens personuppgifter",
      "data_company_title": "Ägaruppgifter för produktionsanläggningen",
      "data_generator_title": "Produktionsanläggningens data",
      "documents_review_title": "Dokumentöversikt",
      "documents_review_subtext": "På nästa sida ber vi er att signera ett antal dokument i Dokobit. Dokumenten genereras automatiskt baserat på dina uppgifter. Här är en översikt över vilka dokument som väntar på signering:",
      "self_uploaded_file_text": "Detta är ett dokument som du tidigare har laddat upp. Det kommer att läggas till för signering.",
      "documents_signed": "Dokument signerat",
      "documents_remaining": "{count} dokument kvar att signera",
      "ee": {
        "origin_certificate_account_application_title": "Ansökan om öppning av konto för ursprungsgarantier",
        "origin_certificate_account_application_description": "Ett dokument som uttrycker önskan att öppna ett ursprungsgarantikonto hos Energimyndigheten. Detta dokument ger också Soldera att hantera ursprungsgarantierna.",
        "type_conditions_title": "Standardvillkor för hantering av ursprungsgarantier",
        "type_conditions_description": "Standardvillkor och regler fastställda av Energimyndigheten för verksamhet på ursprungsgarantimarknaden.",
        "authorization_application_title": "Ansökan om behörighet till kontot för ursprungsgarantier",
        "authorization_application_description": "Ett dokument som uttrycker önskan att bemyndiga Soldera att hantera ursprungsgarantierna i kontot hos Energimyndigheten.",
        "investment_support_confirmation_title": "Bekräftelsebrev för mottagande/avslag av investeringsstöd",
        "investment_support_confirmation_description": "Ett dokument som bekräftar till Energimyndigheten de subventioner som tillhandahållits till din produktionsenhet.",
        "network_contract_title": "elnätsavtal",
        "network_contract_description": "Ditt uppladdade elnätsavtal som krävs av Energimyndigheten för att registrera din produktionsenhet.",
        "device_registration_form_title": "Enhetsregistreringsformulär",
        "device_registration_form_description": "Ett formulär som krävs av Energimyndigheten för att skicka in dina anläggningsdata.",
        "soldera_membership_agreement_title": "Solderas plattformsavtal",
        "soldera_membership_agreement_description": "Avtalet som stipulerar villkoren er och Soldera.",
        "elering_data_title": "Energimyndigheten-data",
        "elering_data_description": "Ett dokument för att skicka in dina uppgifter till Energimyndigheten för att underlätta registreringen av er anläggning."
      },
      "lv": {
        "lv_account_authorization_form_title": "Ansökan om behörighte till er konto för ursprungsgarantier",
        "lv_account_authorization_form_text": "Ett dokument som uttrycker önskan att ge Soldera behörighet att hantera ursprungsgarantier. Detta dokument ger Soldera tillgång till dina ursprungsgarantier i ditt konto hos Energimyndigheten.",
        "lv_soldera_account_holder_registration_form_title": "Formulär för kontoregistrering",
        "lv_soldera_account_holder_registration_form_text": "Ett dokument som uttrycker önskan att registrera sig som kontoinnehavare hos Grexel. Detta dokument ger Soldera tillgång till dina ursprungsgarantier i ditt konto hos Energimyndigheten.",
        "lv_soldera_membership_agreement_title": "Solderas plattformsavtal",
        "lv_soldera_membership_agreement_text": "Avtalet som stipulerar villkoren mellan dig och Soldera. Detta krävs om inget tidigare avtal har gjorts. , vilket inkluderar hänvisningar till Solderas integritetspolicy, handelsregler och grundläggande villkor, som finns tillgängliga på Solderas webbplats.",
        "lv_new_device_application_title": "Formulär för registrering av anläggning",
        "lv_new_device_application_text": "Produktionsenhetsregistreringsformulär, med inlämnad information verifierad av oberoende ackrediterad produktionsrevisor",
        "lv_ast_terms_and_service_title": "AST villkor och tjänster",
        "lv_ast_terms_and_service_text": "Villkor och regler för AST informationssystem."
      },
      "lt": {
        "lt_request_for_go_contract_title": "Ansökan om tjänsteavtal för ursprungsgarantier",
        "lt_request_for_go_contract_description": "Ett dokument som uttrycker önskan att ingå ett avtal med Litgrid för att öppna ett ursprungsgarantikonto.",
        "lt_soldera_membership_agreement_title": "Solderas plattformsavtal",
        "lt_soldera_membership_agreement_text": "Ett avtal mellan dig och Soldera som fastställer avtalsvillkoren. Krävs om inget tidigare avtal har gjorts. Inkluderar hänvisningar till Solderas integritetspolicy, handelsregler och grundläggande villkor, som finns tillgängliga på Solderas webbplats.",
        "lt_authotization_application_title": "Ansökan om auktorisation av ursprungsgarantikonto",
        "lt_authorization_application_text": "Ett dokument som uttrycker önskan att bemyndiga Soldera att hantera ursprungsgarantier inom Litgrids informationssystem.",
        "lt_litgrid_terms_service_title": "Litgrids användarvillkor",
        "lt_litgrid_terms_service_description": "Användarvillkoren för Litgrids informationssystem.",
        "lt_device_registration_title": "Litgrids enhetsregistreringsformulär",
        "lt_device_registration_description": "Ett dokument som Litgrid kräver för att registrera en ny enhet."
      },
      "pl": {
        "pl_authorization_application_title": "Auktorisationsansökan",
        "pl_authorization_application_text": "Detta dokument auktoriserar Soldera att hantera dina ursprungsgarantier i Polen.",
        "pl_soldera_membership_agreement_title": "Soldera plattformsavtal",
        "pl_soldera_membership_agreement_text": "Detta avtal fastställer ditt medlemskap med Soldera och beskriver villkoren för att använda vår plattform och tjänster i Polen."
      },
      "se": {
        "se_account_authorization_form_title": "Formulär för fullmakter till Energimyndigheten",
        "se_account_authorization_form_text": "Detta formulär ger Soldera behörighet att registrera ert konto hos Energimyndigheten för att hantera era ursprungsgarantier.",
        "se_access_cesar_freja_eid_authorization_application_title": "Ansökan om behörighet till Cesar-konto",
        "se_access_cesar_freja_eid_authorization_application_text": "Signering av detta formulär ger Soldera behörighet till ert Cesar-konto, för att kunna hantera era ursprungsgarantier.",
        "se_soldera_membership_agreement_title": "Solderas plattformsavtal",
        "se_soldera_membership_agreement_text": "Detta avtal stipulerar villkoren för användning av Solderas plattform och tjänster.",
        "se_application_for_go_title": "Ansökan om allokering av ursprungsgarantier",
        "se_application_for_go_text": "Ansökningsformulär för registrering av din anläggning hos Energimyndigheten.",
        "se_appendix_production_units_title": "Bilaga för anläggningar",
        "se_appendix_production_units_text": "Detaljerad information om dina produktionsanläggningar som kommer att registreras för ursprungsgarantier.",
        "se_application_for_eecs_go_title": "Ansökan om utfärdande av ursprungsgarantier",
        "se_application_for_eecs_go_text": "Ansökan om utfärdande av ursprungsgarantier, både för inrikes och utrikes handel.",
        "se_application_for_special_account_title": "Ansökan om EECS-konto",
        "se_application_for_special_account_text": "Ansökan om ett EECS-konto i Energimyndighetens system för hantering av ursprungsgarantier för både inrikes och utrikes handel.",
        "se_application_for_cesar_access_title": "Ansökan om CESAR-konto",
        "se_application_for_cesar_access_text": "Ansökan om CESAR-konto, vilket används för att hantering av ursprungsgarantier."
      },
      "fi": {
        "fi_soldera_membership_agreement_title": "Solderas plattformsavtal",
        "fi_soldera_membership_agreement_text": "Detta avtal stipulerar villkoren för användning av Solderas plattform och tjänster.",
        "fi_authorization_application_title": "Ansökan om auktorisation av ursprungsgarantikonto",
        "fi_authorization_application_text": "Detta dokument bemyndigar Soldera att hantera dina ursprungsgarantier.",
        "fi_transfer_application_title": "Ansökan om överföring av ursprungsgarantikonto",
        "fi_transfer_application_text": "Detta dokument överför dina produktionsenheter till Solderas konto, för att hantera dina ursprungsgarantier och spara på registreringen av kontot."
      },
      "generic": {
        "soldera_membership_agreement_title": "Solderas plattformsavtal",
        "soldera_membership_agreement_text": "Detta avtal stipulerar villkoren för användning av Solderas plattform och tjänster.",
        "authorization_application_title": "Ansökan om auktorisation av ursprungsgarantikonto",
        "authorization_application_text": "Detta dokument bemyndigar Soldera att hantera dina ursprungsgarantier."
      },
      "es": {
        "es_soldera_membership_agreement_title": "Soldera Plattformsavtal",
        "es_soldera_membership_agreement_text": "Detta avtal fastställer ditt medlemskap i Soldera och beskriver villkoren för användning av vår plattform och våra tjänster.",
        "es_account_authorization_form_title": "Auktoriseringsansökan",
        "es_account_authorization_form_text": "Detta dokument bemyndigar Soldera att hantera dina ursprungsgarantier."
      }
    },
    "navsteps": {
      "next": "Nästa",
      "back": "Tillbaka",
      "to_signature_page": "Gå till signering",
      "ee": {
        "authorization": {
          "1": "Start",
          "2": "Ägaruppgifter",
          "3": "Dokumentöversikt"
        },
        "new_device": {
          "1": "Elnätsavtal",
          "2": "Anläggning",
          "3": "Kontaktuppgifter",
          "4": "Dokumentöversikt"
        }
      },
      "lv": {
        "step1": "Välkommen",
        "step2": "Kontaktuppgifter",
        "new_device": {
          "1": "Start",
          "2": "Kontouppgifter",
          "3": "Enhetsdokument",
          "4": "Enhetsdata",
          "5": "Företagsinformation",
          "6": "Signering"
        },
        "authorization": {
          "1": "Start",
          "2": "Kontouppgifter",
          "3": "Signering"
        }
      },
      "lt": {
        "choose_onboarding": "Onboardingtyp",
        "contact_review": "Kontouppgifter",
        "multiple_upload": "@:common.documents",
        "generator_license": "Licensnummer",
        "contract_review": "Signering"
      },
      "pl": {
        "step1": "Välkommen",
        "step2": "Kontaktuppgifter",
        "step3": "Kontraktsgranskning",
        "authorization": {
          "1": "Starta",
          "2": "Kontouppgifter",
          "3": "Signering"
        }
      },
      "se": {
        "step1": "Start",
        "authorization": {
          "contact_review": "Kontaktuppgifter",
          "contract_review": "Dokumentöversikt"
        },
        "new_device": {
          "contact_review": "Ägaruppgifter",
          "generator_review": "Anläggningsinformation",
          "contract_review": "Dokumentöversikt",
          "grid_review": "Nätägare"
        },
        "contract_review": "Dokumentöversikt"
      },
      "fi": {
        "flow_selection": "Välj flöde",
        "contact_details": "Kontaktuppgifter",
        "contract_review": "Signering"
      },
      "default": {
        "contact_review": "Kontaktuppgifter",
        "contract_review": "Signering"
      },
      "es": {
        "step1": "Start",
        "step2": "Kontaktuppgifter",
        "step3": "Avtalsgranskning",
        "authorization": {
          "1": "Start",
          "2": "Kontouppgifter",
          "3": "Signering"
        }
      }
    },
    "lv": {
      "authorization": {
        "title": "Har du sålt ursprungsgarantier förut?",
        "description": "Soldera är en säljagent för automatiserad hantering och  försäljning av ursprungsgarantier. Välj något av de två alternativen nedan för att maximera dina intäkter från ursprungsgarantier med hjälp av Soldera.",
        "add_authorization": "Jag har tidigare sålt ursprungsgarantier",
        "create_new_account": "Öppna ett nytt konto för ursprungsgarantier hos Energimyndigheten",
        "create_new_account_description": "Välj detta alternativ om ni inte säljer ursprungsgarantier och vill registrera en ny enhet hos Energimyndigheten.",
        "add_authorization_description": "Välj detta alternativ om ni redan säljer ursprungsgarantier och vill ge Soldera behörighet att hantera dem. Ni kan välja att registrera ytterligare anläggningar via ert Solder-konto.",
        "not_sure": "Behöver du hjälp?",
        "contact_support": "Kontakta vår kundtjänst för support",
        "existing_account_title": "Registrera en ny anläggning för en befintlig ägare",
        "alternative_instructions": "Om du vill öppna ett nytt konto för en enhetsägare som du ännu inte har registrerat hos Soldera, följ instruktionerna nedan."
      },
      "generator_review": {
        "device_name": {
          "title": "produktionsanläggningens namn"
        },
        "device_power": {
          "title": "Installerad kapacitet (kW)"
        },
        "device_power_in_permit": {
          "title": "Kapacitet (i kW) enligt nätavtalet för anläggningen"
        },
        "device_eic": {
          "title": "Mätar-ID (EIC-kod)"
        },
        "device_address": {
          "title": "Anläggningens adress"
        },
        "device_technology": {
          "title": "Energislag",
          "options": {
            "device_technology_solar": "Sol",
            "device_technology_wind": "Vind",
            "device_technology_hydro": "Vattenkraft"
          }
        },
        "grid_contract_start_date": {
          "title": "Datum för idrifttagning"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "only_device_output": {
          "title": "Mätaren anger nettoproduktion"
        },
        "device_grid_operator": {
          "title": "Nätanslutning",
          "options": {
            "grid_operator_tso": "Transmissionsnätet",
            "grid_operator_dso": "Distributionsnätet"
          }
        }
      },
      "do_you_have_subsidy": "Har du fått eller får du statligt stöd?"
    },
    "lt": {
      "authorization": {
        "title": "Säljer du redan ursprungsgarantier?",
        "description": "För att anpassa din upplevelse behöver vi veta om du redan får ursprungsgarantier. Detta hjälper oss att avgöra de bästa nästa stegen för dig.",
        "add_authorization": "Ja, jag har ursprungsgarantier.",
        "add_authorization_description": "Välj detta alternativ om du redan får ursprungsgarantier och vill ge Soldera behörighet att hantera dem. Vi kan hjälpa dig att registrera fler anläggningar i Litgrid senare.",
        "create_new_account": "Nej, jag har inte ursprungsgarantier.",
        "create_new_account_description": "Välj detta alternativ om du inte får ursprungsgarantier och vill registrera en ny anläggning i Litgrids informationssystem.",
        "not_sure": "Osäker?",
        "contact_support": "Kontakta vårt supportteam för hjälp",
        "existing_account_title": "Registrera ny anläggning för befintlig ägare",
        "alternative_instructions": "Om du vill öppna ett nytt konto för en anläggningsägare som du inte tidigare har registrerat hos Soldera, följ instruktionerna nedan."
      },
      "extra_info": {
        "title": "Ytterligare information om företaget",
        "description": "Vänligen ange följande information som krävs av Litgrid."
      }
    },
    "se": {
      "authorization": {
        "title": "Har du sålt ursprungsgarantier förut?",
        "description": "Soldera är en säljagent för automatiserad hantering och försäljning av ursprungsgarantier. Välj ett av alternativen nedan för att maximera dina intäkter från ursprungsgarantier med hjälp av Soldera.",
        "add_authorization": "Jag får redan EECS-ursprungsgarantier",
        "create_new_account": "Öppna ett nytt konto för ursprungsgarantier hos Energimyndigheten",
        "create_new_account_description": "Välj detta alternativ om du inte redan säljer ursprungsgarantier och vill registrera en ny anläggning hos Energimyndigheten.",
        "add_authorization_description": "Välj detta alternativ om du redan får EECS-ursprungsgarantier och vill ge Soldera behörighet att hantera dem. Vi kan hjälpa dig registrera fler anläggningar hos Energimyndigheten senare.",
        "not_sure": "Osäker?",
        "contact_support": "Kontakta vår kundtjänst för hjälp",
        "existing_account_title": "Registrera en ny anläggning",
        "alternative_instructions": "Om du vill öppna ett konto för en ny anläggningsägare (SPV) som du inte tidigare har registrerat hos Soldera, följ instruktionerna nedan.",
        "add_eecs_conversion": "Jag får nationella ursprungsgarantier",
        "add_eecs_conversion_description": "Välj detta alternativ om du får nationella ursprungsgarantier och vill börja få EECS-ursprungsgarantier (europeiska överförbara ursprungsgarantier) i stället."
      },
      "generator_review": {
        "basic_information": "Information om anläggningen",
        "metering_information": "Information relaterad till elmätning",
        "investment_support": "Investeringsstöd",
        "device_name": {
          "title": "Anläggningsnamn"
        },
        "device_power": {
          "title": "Produktionskapacitet (kW)",
          "description": "Ange anläggningens produktionskapacitet (kW)"
        },
        "device_power_in_permit": {
          "title": "Kapacitet enligt tillstånd (kW)"
        },
        "grid_area_id": {
          "title": "Nätområdes-ID",
          "description": "Ange nätområdes-ID (tre bokstäver eller 'IKN')"
        },
        "grid_production_device_id": {
          "title": "Anläggnings-ID",
          "description": "Ange anläggnings-ID (18-tecken)"
        },
        "grid_eidel_id": {
          "title": "Ediel-ID",
          "description": "Ange Ediel-ID för er nätägare"
        },
        "device_eic": {
          "title": "Anläggningens EIC-kod"
        },
        "only_device_output": {
          "title": "Endast elproduktion"
        },
        "device_address": {
          "title": "Anläggningens adress"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "device_grid_operator": {
          "title": "Nätägare",
          "grid_operator_tso": "TSO",
          "grid_operator_dso": "DSO"
        },
        "grid_contract_start_date": {
          "title": "Startdatum för nätavtal"
        },
        "postal_address": {
          "title": "Postadress",
          "description": "Ange fullständig gatuadress"
        },
        "postal_code": {
          "title": "Postnummer",
          "description": "Ange postnummer"
        },
        "city": {
          "title": "Ort",
          "description": "Ange ortsnamn"
        },
        "company_address": "Företagsadress",
        "invoice_address": "Fakturaadress",
        "same_as_company_address": "Fakturaadressen är samma som företagsadressen",
        "production_unit": "Anläggning",
        "cesar_application": "Ansökan om CESAR-konto",
        "go_application": "Ansökan om utfärdande av ursprungsgarantier",
        "investment_support_question": "Har denna anläggning fått investeringsstöd?",
        "investment_support_options": {
          "yes": "Ja",
          "no": "Nej",
          "do_not_know": "Vet ej"
        },
        "property_designation": {
          "title": "Fastighetsbeteckning",
          "description": "Ange fastighetsbeteckning"
        },
        "technology": {
          "title": "Energislag",
          "description": "Välj energislag",
          "options": {
            "BTN_Land based": "Landbaserad vindkraft",
            "BTN_Ocean based": "Havsbaserad vindkraft",
            "BTN_Sun": "Solkraft",
            "BTN_Water": "Vattenkraft",
            "BTN_Thermal": "Värmekraft"
          }
        },
        "thermal_subtype": {
          "title": "Typ av värmekraftsteknik",
          "description": "Välj specifik typ av värmekraftsteknik",
          "options": {
            "BTN_Industrial back pressure": "Industriellt mottryck",
            "BTN_Condensing power": "Kondensationskraft",
            "BTN_Gas engine": "Gasmotor"
          }
        },
        "thermal_is_chp": {
          "title": "Är detta en CHP-enhet?",
          "description": "Markera om detta är en kraftvärmeverksanläggning (CHP)"
        },
        "holding_percentage": {
          "title": "Ägarandel",
          "description": "Ange din ägarandel i procent"
        },
        "metering_location": {
          "title": "Mätpunkt",
          "description": "Välj var elmätningen sker",
          "options": {
            "Directly_after_generator": "Direkt efter generator",
            "After_auxiliary_equipment": "Efter hjälputrustning",
            "After_net_pumping_equipment": "Efter pumputrustning",
            "Directly_before_grid_connection": "Direkt före nätanslutning"
          }
        },
        "commissioning_date": {
          "title": "Datum för idrifttagning",
          "description": "Ange det datum då anläggningen togs i drift"
        },
        "correction_factor_info": {
          "title": "Korrektionsfaktor",
          "description": "Standardkorrektionsfaktorn kommer att redovisas. Om den installerade effekten överstiger 10 MW, kontakta support för att redovisa anpassad korrektionsfaktor"
        },
        "investment_support_amount": {
          "title": "Investeringsstöd",
          "description": "Ange mottagen summa i investeringsstöd"
        },
        "investment_support_date": {
          "title": "Datum för investeringsstöd",
          "description": "Ange datum då investeringsstödet mottogs"
        },
        "grid_metered_by_hour": {
          "title": "Elmätarens inställning",
          "description": "Välj om er elmätningen sker per timme"
        },
        "grid_concession": {
          "title": "Nätkoncession",
          "description": "Välj om anläggningen är ansluten till ett nät som innehar nätkoncession"
        },
        "grid_owner_name": {
          "title": "Nätägarens namn",
          "description": "Ange namn på nätägaren"
        },
        "grid_owner_corporate_id": {
          "title": "Nätägarens org.nr.",
          "description": "Ange nätägarens organisationsnummer"
        },
        "invoice_co_address": {
          "title": "C/o-adress för fakturan",
          "description": "Ange C/o-adress för fakturan (om tillämpligt)"
        },
        "invoice_contact_telephone": {
          "title": "Telefonnummer för specifik kontaktperson för faktura",
          "description": "Ange telefonnummer för specifika kontaktpersonen/referenspersonen för fakturering"
        },
        "invoice_email": {
          "title": "E-postadress för faktura",
          "description": "Ange e-postadress för fakturor"
        },
        "specific_name": {
          "title": "Namn på specifik kontaktperson för faktura",
          "description": "Ange namnet på den specifika kontaktpersonen/referenspersonen för fakturering"
        },
        "reference_number": {
          "title": "Referensnummer",
          "description": "Ange referensnummer"
        },
        "invoice_country": {
          "title": "Land",
          "description": "Ange land i fakturadress"
        }
      }
    },
    "pl": {
      "authorization": {
        "title": "Har du redan ursprungsgarantier?",
        "description": "För att anpassa din upplevelse och säkerställa bästa service, vänligen berätta om din nuvarande status med ursprungsgarantier.",
        "add_authorization": "Ja, jag har ursprungsgarantier.",
        "add_authorization_description": "Du har befintliga ursprungsgarantier och vill ge Soldera auktorisation att hantera dem.",
        "not_sure": "Jag är osäker på min status.",
        "contact_support": "Kontakta support"
      }
    },
    "fi": {
      "flow_selection": {
        "title": "Lägg till ett nytt företag",
        "choose_onboarding": "Välj onboarding",
        "description": "Välj överföringsalternativet om du redan har produktionsenheter i registret. Om du inte har några registrerade enheter kan du kontakta oss för att diskutera dina alternativ.",
        "not_sure": "Behöver du hjälp?",
        "contact_support": "Kontakta vårt supportteam",
        "transfer": {
          "title": "Överföring av produktionsutrustning till Soldera",
          "description": "Vi överför dina produktionsenheter till vårt registerkonto och hanterar dem åt dig."
        },
        "authorization": {
          "title": "Ge Soldera åtkomst till ditt konto i registret",
          "description": "Vi kommer att ha åtkomst till ditt konto i registret och hantera certifikat åt dig. Certifikaten stannar kvar på ditt konto."
        }
      },
      "quickfill": {
        "search": "Sök efter ett företag som redan är registrerat i Fingrid",
        "search_placeholder": "Sök efter ett företag i Fingrid",
        "error": "Misslyckades med att ladda företag",
        "quickfill_helper": "Quickfill med ett företag som redan är registrerat i Fingrid",
        "manual_entry": "Ange uppgifter manuellt"
      }
    },
    "fallback": {
      "flow_selection": {
        "title": "Lägg till ett nytt företag",
        "intro": "Soldera är den främsta plattformen för hantering av ursprungsgarantier. Optimera lönsamheten samtidigt som du minimerar den administrativa arbetsbelastningen. Vi betjänar branschledare och tusentals produktionsenheter för förnybar energi i hela Europa.",
        "description": "Välj auktoriseringsalternativet om du redan har produktionsenheter i registret. Om du inte har några registrerade enheter kan du kontakta oss för att diskutera dina alternativ.",
        "not_sure": "Behöver du hjälp?",
        "contact_support": "Kontakta vårt supportteam",
        "authorization": {
          "title": "Bemyndiga Soldera att hantera dina produktionsenheter",
          "description": "Vi kommer att hantera dina produktionsenheter åt dig."
        }
      }
    },
    "es": {
      "authorization": {
        "title": "Har du redan ursprungsgarantier?",
        "description": "För att skräddarsy din upplevelse behöver vi veta om du redan får ursprungsgarantier. Detta hjälper oss att bestämma de bästa nästa stegen för dig.",
        "add_authorization": "Ja, jag har ursprungsgarantier.",
        "add_authorization_description": "Välj det här alternativet om du redan får ursprungsgarantier och vill auktorisera Soldera att hantera dem.",
        "create_new_account": "Nej, jag har inga ursprungsgarantier.",
        "create_new_account_description": "Välj det här alternativet om du inte får ursprungsgarantier och vill registrera en ny enhet i registerinformationssystemet.",
        "not_sure": "Osäker?",
        "contact_support": "Kontakta vårt supportteam för hjälp",
        "existing_account_title": "Registrera ny enhet för befintlig ägare",
        "alternative_instructions": "Om du vill öppna ett nytt konto för en enhetsägare som du ännu inte har registrerat hos Soldera, följ instruktionerna nedan."
      },
      "extra_info": {
        "title": "Ytterligare information om företag",
        "description": "Vänligen ange följande information som krävs av registret."
      }
    }
  },
  "bulk_buy": {
    "upload_description": "Ladda upp dokument för att extrahera företagsdata och annulleringskrav",
    "upload_description_new": "Ladda upp din hållbarhetsrapport och förbrukningsdata. AI kommer att fylla i alla fält åt dig.",
    "quick_info": "Snabbinfo",
    "upload_hint": "Ladda upp ett eller flera dokument för att automatiskt extrahera företagsdata",
    "manual_add_hint": "Eller lägg till företag manuellt genom att fylla i den tomma raden längst ner",
    "purchase_settings": "Inköpsinställningar",
    "overview": "Översikt",
    "purchase_mode": {
      "CHEAPEST": "Billigast",
      "GHG": "GHG",
      "RE100": "RE100",
      "ADVANCED": "Premiumalternativ",
      "OTHER": "Annat"
    },
    "ghg_description": "SBTi, ERI, CDB",
    "re100_description": "Vind + Sol, COD ≤ 15 år",
    "cheapest_description": "Mest kostnadseffektiva alternativ",
    "premium_description": "Anpassade inköpskrav",
    "go_source": "EAC-källa",
    "technology": "Teknik",
    "ecolabel": "Miljömärkning",
    "vintage": "Årgång",
    "support": "Stödstatus",
    "cod_requirement": "COD-krav",
    "matching_mode": {
      "yearly": "Årlig matchning",
      "monthly": "Månadsvis matchning",
      "hourly": "24/7 timvis matchning (Premium)"
    },
    "destination_companies": "Förmånstagare",
    "destination_companies_description": "Varje rad representerar ett företag som kommer att ta emot UG-annulleringen å deras vägnar.",
    "companies": "@:common.companies",
    "no_companies": "Inga förmånstagare tillagda än. Ladda upp dokument eller lägg till manuellt.",
    "company_name": "Förmånstagare",
    "country": "Förmånstagarens land",
    "registry_code": "Företags-ID",
    "volume": "Förbrukning (MWh)",
    "match_origin": "Matcha ursprung",
    "price": "Indikativt pris",
    "tooltip_company_name": "Den juridiska person som kommer att anges som förmånstagare på annulleringsutlåtandet — parten som gör anspråk på förbrukning av förnybar energi.",
    "tooltip_country": "Landet där förmånstagaren finns och förbrukar el. Avgör var certifikaten behöver annulleras.",
    "tooltip_registry_code": "Företagets organisationsnummer — inte momsnumret. Visas på annulleringsutlåtandet.",
    "tooltip_address": "Förmånstagarens registrerade adress eller anläggningsadress. Används för identifiering på annulleringsutlåtandet.",
    "tooltip_volume": "Årlig elförbrukning att täcka med förnybar energi-certifikat, i megawattimmar (MWh). 1 MWh = 1 certifikat.",
    "tooltip_price": "Indikativt pris baserat på aktuella marknadsnivåer och dina valda inköpsalternativ — ett indikativt bud, inte ett bindande. Klicka 'Begär offert' för att beräkna.",
    "eac_type": "EAC-typ",
    "tooltip_eac_type": "Certifikatsystemet som används i mottagarens land. Bestäms automatiskt utifrån landet; välj själv för länder utanför våra register.",
    "pricing_idle": "Inte beräknat",
    "rfq_notice": "Soldera genomför en offertförfrågan (RFQ)",
    "global_cancellation_settings": "Globala annulleringsinställningar",
    "period_start": "Periodstart",
    "period_end": "Periodslut",
    "beneficiary_type": "Förmånstagartyp",
    "beneficiary_types": {
      "ELECTRICITY_SELLER": "Elhandlare",
      "CONSUMER": "Konsument",
      "CONVERSION_PLANT_OPERATOR": "Konverteringsanläggningsoperatör"
    },
    "summary": "Sammanfattning",
    "total_volume": "Total volym",
    "total_price": "Indikativt totalpris",
    "illiquid_companies": "inga företag prissätts via RFQ | 1 företag prissätts via RFQ | {count} företag prissätts via RFQ",
    "confirm_order": "Bekräfta beställning",
    "ask_for_quotes": "Be om offerter",
    "cancellation_details_title": "Annulleringsdetaljer",
    "beneficiary_name": "Förmånstagarens namn",
    "residency": "Hemvist",
    "company_address": "Företagets adress",
    "address": "@:common.address",
    "cancellation_purpose": "Annulleringssyfte",
    "cancellation_purpose_text": "Annulleringssyfte",
    "operation_notes_placeholder_consumer": "Förbrukningsbevis",
    "operation_notes_placeholder_seller": "Elleverans",
    "cancellation_purposes": {
      "DISCLOSURE": "Redovisning",
      "GRID_LOSSES": "Nätförluster",
      "SELF_CONSUMPTION": "Egenförbrukning",
      "SUPPORT_SCHEME": "Stödsystem",
      "OTHER": "Övrigt"
    },
    "operation_notes": "Operationsanteckningar",
    "confirm_title": "Bekräfta köp och annulleringsorder",
    "order_summary": "Ordersammanfattning",
    "illiquid_warning": "inga företag prissätts via offertförfrågan (RFQ) | 1 företag prissätts via offertförfrågan (RFQ) | {count} företag prissätts via offertförfrågan (RFQ)",
    "total_known_price": "Totalt känt pris",
    "cancellation_not_supported_title": "Annullering stöds inte direkt",
    "cancellation_not_supported_description": "Följande företag finns i register där vi inte kan utföra annullering direkt. Välj hur du vill gå vidare:",
    "cancellation_option_agent": "Soldera ordnar annullering i det lokala registret för full efterlevnad",
    "cancellation_option_any_registry": "Annullera i valfritt AIB-register (standardpris för annullering)",
    "companies_with_pricing": "Företag med känt pris ({count})",
    "confirm_and_submit": "Bekräfta och skicka beställningar",
    "quoted_pricing": "Angivet pris",
    "base_price": "Baspris",
    "price_per_mwh": "Pris per MWh",
    "no_pricing_info": "Ingen prisinformation tillgänglig för denna order",
    "cancellation_fee": "Annulleringsavgift",
    "minimum_cancellation_fee": "Minsta annulleringsavgift",
    "brokerage_fee": "Upphandlingsavgift",
    "incl_brokerage": "inkl. €{amount}/MWh upphandlingsavgift",
    "incl_cancellation": "inkl. €{amount}/MWh annulleringsavgift",
    "incl_min_cancellation": "inkl. €{amount} min. annulleringsavgift",
    "eac_source": "EAC-källa",
    "matching": "Matchning",
    "cancellation_settings": "Annulleringsinställningar",
    "purchase_settings_title": "Inköpsinställningar",
    "purchase_mode_label": "Inköpsläge",
    "pricing_error": "Det gick inte att beräkna priset. Försök igen eller kontakta support.",
    "volume_required": "Volymen måste vara minst 1 MWh",
    "country_required": "Land krävs för prisberäkning",
    "intro": "Köp certifikat för förnybar energi och annullera dem för dina förmånstagares räkning — i ett enda steg. Välj hur certifikaten ska anskaffas, lägg till varje förmånstagare nedan och bekräfta.",
    "accelerator_title": "Börja från ett dokument",
    "sourcing_preference_description": "Hur vi anskaffar certifikat för varje förmånstagare.",
    "sourcing_cheapest_title": "Billigast",
    "sourcing_cheapest_desc": "Mest kostnadseffektiva tillgängliga alternativ",
    "sourcing_ghg_title": "GHG",
    "sourcing_ghg_desc": "Uppfyller SBTi-, ERI- och CDP-rapporteringskriterier",
    "sourcing_re100_title": "RE100",
    "sourcing_re100_desc": "Vind + sol, COD ≤ 15 år",
    "sourcing_other_title": "Annat",
    "sourcing_other_desc": "Beskriv ditt eget anskaffningskrav",
    "custom_requirement_label": "Anpassat anskaffningskrav",
    "custom_requirement_placeholder": "Berätta vad du behöver — specifik teknik, land, årgång, miljömärkningar eller något annat anskaffningskrav. Vårt team återkommer med en skräddarsydd offert.",
    "custom_requirement_advisory": "Anpassade krav prissätts via offertförfrågan (RFQ) — vårt anskaffningsteam återkommer med en indikativ offert, vanligtvis inom en arbetsdag.",
    "shared_cancellation_settings": "Gemensamma annulleringsinställningar",
    "add_beneficiary": "Lägg till förmånstagare",
    "add_another_beneficiary": "Lägg till ytterligare en förmånstagare",
    "no_beneficiaries_title": "Inga förmånstagare tillagda ännu",
    "no_beneficiaries_description": "Ladda upp ett dokument ovan för att fylla i dem automatiskt, eller lägg till din första förmånstagare manuellt.",
    "total_consumption": "Total förbrukning",
    "estimated_cost": "Indikativ kostnad",
    "add_at_least_one_beneficiary": "Lägg till minst en förmånstagare",
    "ask_for_quote": "Begär offert",
    "fetching_quotes": "Hämtar offerter…",
    "review": "Granska",
    "request_custom_quote": "Begär anpassad offert",
    "custom_quote_reassurance": "Soldera genomför en offertförfrågan (RFQ) och svarar med en indikativ offert innan något köps.",
    "manual_quote": "Prissätts via RFQ",
    "by_quote": "Enligt RFQ",
    "priced_subline": "{known} av {total} MWh prissatta · {perMwh}/MWh",
    "rfq_reassurance": "De prissatta raderna skickas för genomförande till offererat pris. För resterande volymer genomför Soldera en offertförfrågan (RFQ) i vårt leverantörsnätverk och återkommer med en indikativ offert — vanligtvis inom en arbetsdag. Inget köps för RFQ-raderna förrän du godkänner offerten.",
    "review_order_title": "Granska köp- och annulleringsorder",
    "average_unit_price": "Genomsnittligt enhetspris",
    "indicative_bid_note": "Alla priser som visas är indikativa bud baserade på aktuella marknadsnivåer — inte bindande bud. Det slutliga priset bekräftas när din order verkställs.",
    "quotes_indicative_note": "Alla offerter är indikativa — det slutliga priset bekräftas vid genomförandet.",
    "market_levels_as_of": "Marknadsnivåer per {date}",
    "quote_reference": "Ref {id}",
    "quote_reference_label": "Offertreferens",
    "consumption_period": "Förbrukningsperiod",
    "cancellation_mode_selection_aria": "Val av annulleringsläge",
    "remove_beneficiary_row_aria": "Ta bort förmånstagarrad {index}"
  },
  "dashboard": {
    "issuance_chart": {
      "title": "Utfärdandediagram",
      "description": "Utfärdade MWh per produktionsanläggning de senaste 12 månaderna.",
      "y_axis": "Utfärdade MWh",
      "y_axis_log": "Utfärdade MWh (logaritmisk skala)",
      "scale_absolute": "Absolut",
      "scale_log": "Logaritmisk skala",
      "zero_marker_note": "En logaritmisk skala kan inte visa noll: månader utan utfärdanden markeras med ✕ på baslinjen.",
      "no_data": "Inga utfärdandedata för de senaste 12 månaderna",
      "load_failed": "Kunde inte ladda utfärdandediagrammet. Försök igen."
    },
    "devices_in_registry": "Anläggningar som hanteras i registret",
    "no_devices_in_registry": "Inga enheter i registret",
    "add_device_description": "Lägg till din första enhet för att börja hantera certifikat",
    "add_first_device": "Lägg till första enhet",
    "add_registry_device": "Lägg till registerenhet",
    "add_registry_device_description": "Lägg till en ny enhet manuellt i ditt register för certifikathantering",
    "select_company": "Välj ett företag",
    "action_required": "Åtgärd krävs",
    "consolidated_view": "Konsoliderad vy",
    "consolidated_view_description": "Visa alla företag tillsammans",
    "company_id_label": "ID: {id}",
    "market": {
      "base_price": "Baspris"
    },
    "consolidated": {
      "overview_for": "Översikt för {email}",
      "devices_overview": "{count} anläggningar med total effekt {power} kW",
      "back_to_dashboard": "Tillbaka till översikten",
      "pending_payouts": "Innestående summa",
      "paid_out_30d": "Utbetalt (30d)",
      "projected_production": "Prognostiserad produktion",
      "projected_production_description": "Produktionsprognos baserad på anläggningseffekt",
      "projected_production_by_company": "Prognostiserad produktion per företag",
      "projected_production_by_company_description": "Sorterad efter total prognostiserad produktion",
      "production_volume": "Produktionsvolym",
      "production_volume_description": "Belopp visas i MWh",
      "production_volume_table": {
        "quarter": "Kvartal",
        "month": "Månad",
        "monthly": "Månadsvis",
        "quarterly": "Kvartalsvis",
        "total": "Totalt",
        "current": "Aktuell"
      },
      "production_distribution": "Fördelning av prognostiserade produktionskällor",
      "production_distribution_description": "Senaste 12 månaderna",
      "production_devices": "Produktionsanläggningar",
      "production_devices_description": "{deviceCount} anläggningar i {companyCount} företag",
      "production_devices_table": {
        "company_name": "Företag",
        "total": "Totalt",
        "technology": "Energislag",
        "device_count": "Anläggningar",
        "device_name": "Namn",
        "device_id": "#",
        "capacity": "Kapacitet",
        "status": "Status",
        "no_devices": "Inga anläggningar att visa",
        "more_devices": "{count} anläggningar till",
        "view_projection": "Visa prognos",
        "view_breakdown": "Visa sammanställning",
        "scheduled_transactions_tooltip": "automatiska överföringar konfigurerade i registret"
      },
      "company_filter_hint": "Välj vilka företag du vill utforska i det konsoliderade läget",
      "selector_no_companies": "Inga företag",
      "selector_all_companies": "Alla företag",
      "selector_countries_companies": "{countries} länder · {companies} företag",
      "selector_company_count": "Inga företag | 1 företag | {count} företag",
      "selector_selected_count": "{selected} av {total} valda",
      "selector_only": "endast",
      "selector_show_only": "Visa endast {country}",
      "selector_remove_country": "Ta bort {country}",
      "no_companies_selected_title": "Inga företag valda",
      "no_companies_selected_hint": "Välj minst ett företag eller land ovan för att se data."
    },
    "buyer": {
      "consolidated_view": "Köparens konsoliderade vy",
      "go_cancelled": "Energiattributcertifikat annullerade",
      "certificates_this_year": "certifikat i år",
      "membership_agreement": "Plattformsavtal",
      "agree_to_terms": "Jag godkänner villkoren",
      "terms_accepted": "Villkor accepterade framgångsrikt",
      "manage_inventory": "Köp och avbryt",
      "platform_agreement_clickwrap_intro": "Genom att klicka på Acceptera godkänner du {link}",
      "platform_agreement_link_text": "Soldera Plattformsavtal"
    },
    "corporate": {
      "sections": {
        "energy_attribute_certificates": "Energiattributcertifikat"
      }
    },
    "companies": "@:common.companies",
    "sign_document": "Signera dokument",
    "continue_registration": "Fortsätt registrering",
    "add_company_or_device": "Lägg till företag eller anläggning",
    "add_company_access": "Lägg till användare",
    "company_id": "Företags-ID",
    "company_ids_placeholder": "Företags-ID - enstaka eller kommaseparerade",
    "add_company": "Lägg till företag",
    "internal_role": "Intern roll",
    "user": "Användare",
    "super_admin": "Superadministratör",
    "sales_admin": "Försäljningsadministratör",
    "fee_model": "Avgiftsmodell",
    "standard": "Standard",
    "special_free": "Särskild gratis",
    "special_5pct": "Särskild 5%",
    "special_1eur_per_mw": "Särskild 1€/MW",
    "registry_excluded_devices": "Registret exkluderade anläggningar (kommaseparerade)",
    "allowed_invite_domains_label": "Tillåtna inbjudningsdomäner (kommaseparerade)",
    "allowed_invite_domains_help": "Teaminbjudningar kan bara skickas till e-postadresser på dessa domäner. Lämna tomt för att tillåta alla domäner.",
    "is_test_company": "Är testföretag?",
    "hosted_account_regions_label": "Värdkontons regioner (ta emot UG)",
    "hosted_account_regions_help": "Välj vilka lands registerkonton företaget får använda för att ta emot UG till Soldera-värdkonton.",
    "save_changes": "Spara ändringar",
    "all_trackings": "Alla spårningar",
    "referrer_company_id": "Referent-ID",
    "utm_source": "UTM-källa",
    "utm_medium": "UTM-medium",
    "utm_term": "UTM-term",
    "utm_content": "UTM-innehåll",
    "utm_campaign": "UTM-kampanj",
    "created_at": "Skapad",
    "admin_only_transfer_and_delete_company": "ENDAST ADMIN: Överför alla tillgångar till ett annat företag och TA BORT företaget:",
    "transfer_to": "Överför till: {name} - {id}",
    "transfer": "Överför",
    "nda_signed_link": "Länken till sekretessavtalet vi signerade med kunden",
    "client_nda_signed_link_title": "Dokument för särskilda villkor",
    "client_nda_signed_link": "Klicka här för att komma åt särskilda villkor som signerats mellan Soldera och {name}.",
    "custom_percentage": "Anpassad procentsats",
    "custom_percentage_hint": "Anpassade procentsatser mellan 5 och 20 stöds",
    "sales_transactions": {
      "title": "Transaktionshistorik",
      "description": "Priserna på ursprungsgarantier fluktuerar och kan ändras dagligen. Nedan hittar du en översikt över alla dina transaktioner.",
      "description_link": "För en objektiv jämförelse mellan dina transaktioner och marknadspriser rekommenderar vi att du läser vår artikel om prissignaler för ursprungsgarantier.",
      "no_sales_transactions": "I framtiden kommer du att hitta din transaktionshistorik med budinformation här",
      "notificationInfo": "Vi kommer att meddela dig via e-post när försäljningstransaktioner har skett",
      "date": "Transaktionsdatum",
      "item": "Artikel",
      "final_unit_price": "Enhetspris",
      "amount": "Mängd",
      "offer_range": "Budintervall",
      "final_country": "Land med vinnande bud",
      "status": "Status",
      "processing_explanation": "Soldera väntar på att få pengar från motparten. När pengarna har mottagits meddelar vi dig om transaktionen.",
      "completed": "Avslutad",
      "processing": "Pågående",
      "pending_sales_details": "Försäljningsinformation väntar",
      "export_xlsx": "Exportera till Excel",
      "view_aggregated": "Samlad vy",
      "view_by_company": "Per företag",
      "view_by_power_plant": "Per kraftverk",
      "power_plant": "Kraftverk",
      "revenue": "Intäkter",
      "soldera_fees": "Soldera-avgifter (exkl. moms)",
      "registry_fees": "Registeravgifter (exkl. moms)",
      "fees_pending": "Avgifter väntar"
    },
    "automaticReporting": {
      "title": "Automatisk produktionsrapportering",
      "requiresAction": "Kräver åtgärd",
      "lastUpdated": "Senast uppdaterad:",
      "lastDeclaredMonth": "Senast redovisad produktionsmånad:",
      "lastDeclaredAmount": "Senast redovisat totalbelopp:",
      "helpNeeded": "Vi behöver din hjälp för att säkerställa att rätt produktionsanläggning på ESO är kopplad till rätt anläggning i Litgrids Grexel-register.",
      "missingAssociation": "Saknad anslutning till mätpunkt",
      "automaticallyDeclared": "Automatiskt deklarerad",
      "declaredFor": "Deklarerad för:",
      "amount": "Belopp:",
      "pendingApproval": "Väntar på godkännande"
    },
    "income_estimate": {
      "view_estimate": "Visa intäktsprognos"
    },
    "companyData": {
      "automatic_sale_with_highest_offer": "Automatisk försäljning till högstbjudande",
      "fresh_production_sale_above_minimum_price": "Försäljning av ny produktion över minimipris på {price}€/MWh",
      "modify": "Ändra",
      "money_pending": "Innestående summa",
      "transaction_history": "Transaktionshistorik",
      "origin_certificates": "Ursprungsgarantier",
      "view_details": "Visa detaljer",
      "hide_details": "Dölj detaljer",
      "submit_invoice": "Skicka faktura",
      "invoice_history": "Fakturahistorik",
      "documents": "@:common.documents",
      "continue_authorization_creation": "Fortsätt ansökan",
      "thank_you_for_joining": "Tack för att ni ansluter er till i Soldera!",
      "thank_you_message": "Vi kontaktar registret för din räkning och hanterar alla förfaranden. Nu behöver du bara vänta på att registret ska utföra sina åtgärder, så säljer vi dina certifikat. När försäljningen är genomförd meddelar vi dig och ber dig skapa en faktura så att vi kan föra över pengarna.",
      "add_companies_or_devices_while_waiting": "Medan du väntar på att din ansökan ska gå igenom har du möjlighet att lägga till företag eller anläggningar",
      "add_companies_while_waiting": "Medan du väntar kan du lägga till ett annat företag",
      "invite_a_friend": "Bjud in en vän",
      "invite_a_friend_message": "Känner du någon som också skulle kunna vara intresserad av Soldera? Du får 30% av vår provisionsavgift från varje inbjuden vän under deras första år går till dig.",
      "click_to_copy_link": "Klicka här för att kopiera länken för att skicka till en vän",
      "production_settings": "Produktionsinställningar",
      "measurement_points": "Mätpunkter",
      "documents_signed_with_soldera": "Medlemsavtal signerat med Soldera",
      "other_documents": "Andra dokument",
      "device_contract": "Avtal för Anläggning {deviceName}",
      "company_contract": "Avtal med {companyName}",
      "contract_between_company_and_soldera": "Avtal mellan {companyName} och Soldera",
      "link_copied": "Länk har kopierats!",
      "link_copied_fallback": "Länk kopierad till urklipp (reservplan).",
      "link_copy_failed": "Kunde inte kopiera länk. Kopiera den manuellt.",
      "update_min_price_success": "Uppdatering av minimipris lyckades",
      "new_min_price_effective_immediately": "Det nya minimipriset gäller omedelbart",
      "update_min_price_failed": "Det gick inte att uppdatera minimipris",
      "invoice_submission_success": "Fakturainlämning lyckades",
      "invoice_paid_within_7_days": "Faktura har skickats in och kommer att betalas inom 7 dagar.",
      "fetch_pending_invoice_items_failed": "Det gick inte att hämta aktuella fakturaposter",
      "fetch_certificates_failed": "Kunde inte hämta ursprungsgarantier",
      "team": {
        "title": "Team",
        "invite_title": "Bjud in till teamet",
        "not_trusted_tooltip": "Att lägga till teammedlemmar blir tillgängligt när ditt konto har aktiverats. Kontakta support@soldera.org.",
        "delete": "Ta bort",
        "invite": "Bjud in",
        "send_invite_email": "Skicka inbjudningsepost",
        "invalidName": "Namnet måste vara minst 2 tecken långt",
        "invalidEmail": "Ogiltigt e-postformat",
        "domain_not_allowed": "Endast dessa e-postdomäner kan bjudas in: {domains}",
        "allowed_domains_hint": "Inbjudningar är begränsade till dessa e-postdomäner: {domains}",
        "confirmDelete": "Är du säker på att du vill ta bort {account_name}s som användare för {company_name}?"
      },
      "available_guarantees_of_origin": "Tillgängliga ursprungsgarantier",
      "manage_inventory": "Hantera lager",
      "projected_production": "Prognostiserad produktion",
      "manage_production_strategy": "Hantera produktionsstrategi",
      "invoice_management": "Fakturering",
      "cancellation_documents": "Annulleringsdokument",
      "add_device": "Lägg till anläggning",
      "no_devices": "Inga anläggningar",
      "add_device_message": "Lägg till en anläggning till ditt företag för att börja hantera din produktion."
    },
    "devices": "Registrerade anläggningar",
    "generator": {
      "license_number": "Anläggning med licensnummer {license_number}",
      "hide_documents": "Dölj relaterade dokument",
      "show_documents": "Visa relaterade dokument"
    },
    "documents": {
      "last_updated": "Senast uppdaterad",
      "section_title": "{document_count} dokument",
      "expand": "Se alla {document_count} dokument",
      "collapse": "Dölj dokument",
      "hide_details": "Dölj dokument för anslutning",
      "show_details": "Visa dokument för anslutning",
      "document_title": "{document_name}",
      "other_document": "Dokument uppdaterat {updated_at}",
      "show_associated_device": "Visa tillhörande anläggning",
      "hide_associated_device": "Dölj tillhörande anläggning",
      "no_documents": "Inga dokument än",
      "no_documents_message": "Dokument du laddar upp eller tar emot visas här"
    },
    "portfolio": {
      "no_portfolio_data_title": "Portföljerna är inte tillgängliga än",
      "no_portfolio_data_subtitle": "Portföljerna kommer att visas här när vi har hämtat dina registreringsdata.",
      "all_portfolios": "Alla portföljer",
      "total_volumes": "Totala volymer",
      "available_volumes": "Tillgängliga volymer",
      "expired_volumes": "Utgångna volymer",
      "sold_volumes": "Sålda volymer",
      "monthly_technology_breakdown": "Månadsvis per teknologi",
      "monthly_sales_status": "Månadsvis per försäljningsstatus",
      "company_breakdown": "Volymer per företag",
      "guarantees_of_origin_in_portfolios": "Ursprungsgarantier i portföljer",
      "projected_production": "Prognostiserad produktion",
      "pending_payouts": "Väntande utbetalningar",
      "production_devices": "Produktionsanläggningar",
      "documents": "@:common.documents",
      "recipient_eecs_account_number": "Mottagarens EECS-kontonummer",
      "recipient_internal_account_number": "Registrets interna kontonummer",
      "recipient_internal_account_help": "Valfritt. Krävs endast för registret som använder underkonton.",
      "recipient_internal_account_placeholder": "Valfritt underkonto-ID",
      "certificatesTableTitle": "Portföljcertifikat",
      "sendGoChatWelcome": "Hej! Hur kan jag hjälpa dig att skicka ursprungsgarantier idag?",
      "sendGoChatWelcomeWithCerts": "Hej! Jag ser att du har valt {count} certifikat. Vilka är mottagaruppgifterna?",
      "sendGoChatAssistant": "GO Skicka Assistent",
      "sendGoChatPlaceholder": "Fråga om att skicka GO, ange mottagaruppgifter eller släpp en fil...",
      "sendGoChatInputPlaceholder": "Ange mottagaruppgifter eller MWh-belopp...",
      "sendGoOrderSummary": "Sändningsorderöversikt",
      "selected_certificates": "Valda certifikat",
      "selected_certificates_summary": "Översikt av valda certifikat",
      "disabledReasonPortfolio": "Denna certifikatbunt kan inte skickas eftersom den redan är allokerad för {portfolio}-portföljen",
      "disabledReasonStatus": "Detta certifikat är inte tillgängligt i vald status.",
      "disabledReasonUnknown": "Detta certifikat är inte tillgängligt i vald portfölj.",
      "recipientRegistryId": "Mottagarens register-ID",
      "recipientCountry": "Mottagarland",
      "recipientCompanyName": "Mottagarens företagsnamn",
      "certificatesToSend": "Certifikat att skicka",
      "noCertificatesSelected": "Inga certifikat valda för sändning.",
      "totalMwhToSend": "Totalt MWh att skicka",
      "totalMwhInTable": "Valda MWh",
      "sendGoDropFile": "Släpp filen här för att extrahera detaljer",
      "sendGoUploadingFile": "Laddar upp {name}...",
      "sendGoUploadSuccess": "Lyckades ladda upp {name}.",
      "sendGoSuccessMessage": "Skicka-beställning framgångsrikt skickad!",
      "no_certificates_to_display": "Inga certifikat matchar de aktuella filtren.",
      "disabled_reason_portfolio": "Certifikatet finns i portföljen '{portfolio}'.",
      "disabled_reason_status_sold": "Detta certifikat kan inte väljas eftersom det har sålts.",
      "disabled_reason_status_ongoing_sale": "Detta certifikat kan inte väljas eftersom försäljningen pågår.",
      "disabled_reason_status_expired": "Detta certifikat kan inte väljas eftersom det har gått ut.",
      "disabled_reason_status_non_transferrable": "Detta certifikat kan inte väljas eftersom det inte är överförbart.",
      "disabled_reason_status_reserved": "Detta certifikat kan inte väljas eftersom det är reserverat för andra uppgifter.",
      "disabled_reason_status_waiting_for_sale": "Detta certifikat kan inte väljas eftersom det väntar på försäljning.",
      "disabled_reason_status_pending": "Detta certifikat kan inte väljas eftersom det väntar på åtgärd från systemet.",
      "disabled_reason_status_unknown": "Detta certifikat kan inte väljas på grund av dess status: {status}.",
      "disabled_reason_unknown": "Kan inte väljas",
      "recipient_registry_id": "Mottagarens register-ID",
      "recipient_country": "Mottagarland",
      "recipient_company_name": "Mottagarens företagsnamn",
      "certificates_to_send": "Certifikat att skicka",
      "no_certificates_selected": "Inga certifikat valda för sändning.",
      "total_mwh_to_send": "Totalt MWh att skicka",
      "available_certificates_title": "Tillgängliga certifikat i självförvaltad portfölj",
      "table": {
        "more_certificates": "{count} certifikat till",
        "select_columns": "Välj kolumner",
        "columns_selected": "{count} kolumner valda",
        "filters": {
          "search_company": "Sök företag",
          "search_accounts": "Sök konton",
          "search_portfolio": "Sök portfölj / projekt",
          "search_device": "Sök enhet",
          "month_placeholder": "YYYY-MM",
          "cod_age_year_placeholder": "År",
          "cod_age_add_condition": "Lägg till villkor",
          "active": "@:common.active"
        },
        "filter_chips": {
          "group_label": "Aktiva filter",
          "label": "Filter",
          "none": "Inga",
          "value": "{column}: {value}",
          "remove": "Ta bort filtret {column}",
          "hiding": "döljer {values}",
          "count_of_total": "{shown} av {total}",
          "contains": "innehåller ”{text}”",
          "cod_age_years": "{conditions} år",
          "tag_default": "Standard",
          "tag_document": "Från dokument",
          "tag_unavailable": "Ingen matchning i lager",
          "reset": "Återställ standardfilter",
          "clear_all": "Rensa alla"
        },
        "filtered_total": "Totalt",
        "count_cell": {
          "of": "av {count}",
          "editor": "MWh att välja från den här raden",
          "full_title": "Klicka för att välja bara en del av raden",
          "full_label": "Alla {count} MWh valda, välj bara en del av raden",
          "partial_title": "Klicka för att ändra volymen",
          "partial_label": "{selected} av {count} MWh valda, ändra volym"
        }
      },
      "footer": {
        "action": "Åtgärd",
        "technology_amount": "Teknik och volym",
        "production_period": "@:common.production_period",
        "production_support": "Produktionsstöd",
        "no_certificates_selected": "Inga certifikat valda",
        "review_send_title": "Granska sändning",
        "review_sell_title": "Granska försäljning",
        "review_cancel_title": "Granska annullering",
        "confirm_send_btn": "Skicka nu",
        "confirm_sell_btn": "Sälj nu",
        "confirm_cancel_btn": "Annullera nu",
        "cancel_btn": "@:common.cancel",
        "missing": "Saknas",
        "overselected": "För många valda",
        "matched": "Matchar",
        "strategy_auto_high": "Automatisk hög budnivå",
        "strategy_min_price": "Ny produktion över minpris",
        "strategy_min_price_detailed": "Minimipris €{price}/MWh de första {duration} månaderna, sedan automatisk försäljning till marknadspris",
        "risk_flags": "Risker",
        "risk_region_mismatch": "Regionavvikelse upptäckt",
        "risk_insufficient_inventory": "Otillräckligt lager",
        "selected_mwh": "{mwh} MWh",
        "of_available": "av {mwh} tillgängliga",
        "rows": "Rader",
        "rows_selected": "inga valda | {count} vald | {count} valda",
        "rows_partial": "ingen delvis | {count} delvis | {count} delvis",
        "rows_hidden": "ingen dold av filter | {count} dold av filter | {count} dolda av filter",
        "partial_hint": "Klicka på en volym för att välja en del av en rad"
      },
      "cancelGoChatAssistant": "GO Annulleringsassistent",
      "cancelGoChatPlaceholder": "Bekräfta certifikat för annullering eller ställ frågor...",
      "cancelGoChatInputPlaceholder": "Ange bekräftelse eller anledning...",
      "cancelGoOrderSummary": "Annulleringssammanfattning",
      "certificatesToCancel": "Certifikat att annullera/pensionera",
      "noCertificatesSelectedCancel": "Inga certifikat valda för annullering.",
      "totalMwhToCancel": "Totalt MWh att annullera",
      "cancelGoChatIntro": "Du har valt {count} certifikat för annullering. Vänligen bekräfta eller ange en anledning.",
      "sellGoChatAssistant": "GO Försäljningsassistent",
      "sellGoChatPlaceholder": "Bekräfta certifikat och försäljningsstrategi...",
      "sellGoChatInputPlaceholder": "Bekräfta försäljningsstrategi eller ställ frågor...",
      "sellGoOrderSummary": "Försäljningssammanfattning",
      "certificatesToSell": "Certifikat att sälja",
      "noCertificatesSelectedSell": "Inga certifikat valda för försäljning.",
      "totalMwhToSell": "Totalt MWh att sälja",
      "sellGoChatIntro": "Du har valt {count} certifikat att ställa in för försäljning. Vänligen bekräfta försäljningsstrategin.",
      "receiveGoChatAssistant": "GO Mottagningsassistent",
      "receiveGoChatPlaceholder": "Beskriv de GO du förväntar dig att ta emot...",
      "receiveGoChatInputPlaceholder": "Ange avsändaruppgifter eller ställ frågor...",
      "receiveGoOrderSummary": "Mottagningssammanfattning",
      "senderRegistryId": "Avsändarens register-ID",
      "senderCountry": "Avsändarland",
      "senderCompanyName": "Avsändarens företagsnamn",
      "expectedMwh": "Förväntat MWh",
      "receiveGoTablePlaceholder": "Förväntade inkommande överföringar kommer att listas här.",
      "buyGoChatAssistant": "GO Köpassistent",
      "buyGoChatPlaceholder": "Vilken typ av GO letar du efter? Beskriv volym, teknik, prisintervall etc.",
      "buyGoChatInputPlaceholder": "Ange volym, teknik, prisintervall...",
      "buyGoOrderSummary": "Köpbegäran/Erbjudanden",
      "buyVolume": "Volym (MWh)",
      "buyTechnology": "Teknik (Valfritt)",
      "buyMaxPrice": "Maxpris (€/MWh, Valfritt)",
      "buyOffersPlaceholder": "Erbjudanden som matchar din begäran kommer att visas här.",
      "buyGoTablePlaceholder": "Potentiella GO att köpa kommer att listas här.",
      "sellGoSuccessMessage": "Försäljningsorder framgångsrikt skickad!",
      "sellGoSuccessTitle": "Försäljningsinställning klar",
      "confirmSellTitle": "Bekräfta försäljningsinställning",
      "confirmSellMessage": "Du är på väg att begära att sälja {mwh} MWh av dina förnybar energi-certifikat genom Solderas marknadsprissystem.",
      "confirm_sell_minimum_price_message": "Du begär att sälja {mwh} MWh av dina förnybar energi-certifikat med minimiprisstrategi. Så fungerar det:",
      "confirm_phase_1_title": "Första {duration} månaderna från produktion",
      "confirm_phase_1_description": "Certifikat säljs endast om marknadspriset når eller överskrider ditt minimipris på €{price}/MWh.",
      "confirm_phase_2_title": "Efter {duration} månader från produktion",
      "confirm_phase_2_description": "Alla kvarvarande certifikat säljs automatiskt till högsta tillgängliga marknadspris för att säkerställa att de inte tappar i värde.",
      "technologies": "Teknologier",
      "production_months": "Produktionsmånader",
      "spotSalesPortfolio": "Spotförsäljning",
      "spotSalesPortfolioDescription": "Tillgänglig för försäljning till marknadspris",
      "spot_sales_min_price_description": "Minimipris gäller först, sedan automatisk försäljning till marknadspris",
      "oldCertificatesWarningTitle": "Varning för certifikatålder",
      "oldCertificatesWarningMessage": "Du har valt {count} MWh certifikat som är äldre än {duration} månader från deras utfärdandedatum. Minimiprisstrategin gäller endast för certifikat inom de första {duration} månaderna efter utfärdande. Ta bort dessa äldre certifikat för att fortsätta med minimiprisstrategin.",
      "document": {
        "title": "@:common.documents",
        "company": "@:common.company",
        "status": "Status",
        "last_updated": "Senast uppdaterad",
        "actions": "@:common.actions.title",
        "contract_details": "Kontraktsinformation"
      },
      "fileUpload": {
        "uploadPrompt": "Släpp kontrakt här eller klicka för att ladda upp",
        "drop_prompt": "Släpp filen för att ladda upp",
        "title": "Ladda upp kontrakt",
        "description": "Ladda upp ett kontrakt för att automatiskt extrahera mottagardetaljer",
        "dropzone": "Släpp kontraktet här eller klicka för att bläddra",
        "supportedFormats": "Stödda format: PDF, Word, Excel, etc.",
        "analyzing": "Analyserar kontrakt...",
        "extractionComplete": "Analys klar! Jag har hittat mottagarinformation.",
        "apply": "Tillämpa extraherade detaljer",
        "reset": "Återställ",
        "uploadAnother": "Ladda upp en annan fil",
        "analysisSuccessTitle": "Kontraktet har analyserats framgångsrikt.",
        "analysisSuccessMessage": "Fildetaljer har extraherats och tillämpats på formuläret.",
        "analysisNoMatchTitle": "Inga matchande certifikat.",
        "analysisNoMatchMessage": "Dokumentets kriterier (teknik, enhet eller produktionsperiod) matchar inga av dina tillgängliga certifikat, så inget kunde väljas. Se över begäran eller dina filter.",
        "analysisShortfallTitle": "Inte tillräckligt med matchande certifikat.",
        "analysisShortfallMessage": "Endast {selected} MWh av de begärda {requested} MWh kunde väljas från de matchande certifikaten. Se över underskottet innan du bekräftar."
      },
      "disabled_reason_status_own_use": "Detta certifikat kan inte väljas eftersom det är märkt för egen användning och inte kan handlas."
    }
  },
  "cancellation": {
    "list_title": "Annulleringsutlåtanden",
    "add_new_statement": "Lägg till nytt annulleringsutlåtande",
    "not_trusted_tooltip": "Att lägga till utlåtanden blir tillgängligt när ditt konto har aktiverats. Kontakta support@soldera.org.",
    "no_cancellations": "Inga annulleringsutlåtanden",
    "no_cancellations_info": "Dina annulleringsutlåtanden kommer att visas här efter uppladdning",
    "view_details": "Visa detaljer",
    "download_documents": "Ladda ner dokument",
    "download_shown": "Ladda ner visade (inga dokument) | Ladda ner visade ({count} dokument) | Ladda ner visade ({count} dokument)",
    "download_preparing": "Förbereder {current} / {total}…",
    "download_preparing_documents": "Förbereder dokument…",
    "download_none_selected": "Inga dokument i det aktuella urvalet",
    "download_too_many_documents": "För många dokument att ladda ner på en gång ({count}). Begränsa filtren till högst {max}.",
    "download_too_many_bytes": "De valda dokumenten är totalt {total} MB; gränsen är {max} MB. Begränsa filtren och försök igen.",
    "download_too_large_title": "Urvalet är för stort att ladda ner",
    "bulk_download_failed": "Det gick inte att ladda ner annulleringsutlåtanden",
    "bulk_download_no_documents_title": "Inga dokument att ladda ner",
    "bulk_download_no_documents": "Inget av de valda dokumenten är längre tillgängligt. Listan har uppdaterats.",
    "create_statement": "Skapa utlåtande",
    "drop_to_create": "Släpp filer här för att skapa ett nytt annulleringsutlåtande",
    "table": {
      "id": "@:common.id",
      "created": "Skapad",
      "beneficiary_name": "Mottagarens namn",
      "period": "Period",
      "mwh_cancelled": "Annullerad MWh",
      "purpose": "Syfte",
      "registry": "Register",
      "registry_code": "Registerkod",
      "more_statements": "{count} utlåtanden till"
    },
    "details_title": "Detaljer för annulleringsutlåtande",
    "details": {
      "basic_info": "Utlåtandeinformation",
      "documents": "Uppladdade dokument",
      "no_documents": "Inga dokument uppladdade",
      "period": "@:cancellation.table.period",
      "order_id": "Order-ID",
      "load_error": "Misslyckades med att ladda annulleringsdetaljer",
      "download_all": "Ladda ner alla dokument",
      "registry_document": "Registerdokument",
      "view_registry_document": "Visa i registret",
      "add_documents": "Lägg till dokument",
      "upload_selected": "Ladda upp"
    },
    "upload": {
      "drop_files": "Dra och släpp filer här eller klicka för att bläddra",
      "supported_formats": "Format som stöds: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, PNG, JPG, JPEG (max 25MB vardera)"
    },
    "modal": {
      "upload_documents": "Ladda upp dokument",
      "uploaded_files": "Uppladdade filer",
      "files_required": "Minst en fil krävs",
      "order_selection": "Länka till annulleringsorder",
      "order_selection_description": "Valfritt länka detta utlåtande till en befintlig annulleringsorder för automatisk formulärfyllning.",
      "linked_order": "Länkad annulleringsorder",
      "no_order_selected": "Ingen (manuell inmatning)",
      "order_option": "Order #{id} - {date}",
      "order_help_text": "Välj en order för automatisk formulärfyllning med befintlig data, eller välj 'Ingen' för manuell inmatning.",
      "statement_selection": "Välj utlåtande",
      "no_statement_selected": "Välj ett utlåtande",
      "statement_help_text": "Välj ett specifikt utlåtande från den valda ordern för automatisk formulärdatafyllning.",
      "statement_details": "Utlåtandedetaljer",
      "auto_fill_from_statement_notice": "Formulärdata har automatiskt fyllts från det valda utlåtandet. Du kan ändra vilket fält som helst enligt behov.",
      "select_statement_notice": "Välj ett utlåtande från dropdown-menyn ovan för automatisk formulärfyllning.",
      "upload_description_with_ai": "Ladda upp annulleringskontrakt eller regelefterlevnadsdokument för automatisk formulärfyllning eller lägg till extra dokumentation.",
      "analyzing_document": "Analyserar dokument med AI...",
      "ai_analysis_applied": "AI-analys tillämpat på formuläret",
      "ai_populated": "AI-ifyllt",
      "clear_ai_data": "Rensa AI-data",
      "confirm_override_ai_data": "Detta kommer att ersätta AI-ifyllda data med orderdata. Är du säker på att du vill fortsätta?",
      "analysis_complete_title": "Analys slutförd",
      "analysis_success_with_fields": "Dokumentet har analyserats framgångsrikt och {count} fält uppdaterades.",
      "analysis_success_no_fields": "Dokumentet analyserades framgångsrikt men ingen ny information hittades för att uppdatera formuläret.",
      "analysis_success_multiple_statements_with_fields": "Hittade {total_statements} utlåtanden i dokumentet. Tillämpade det första utlåtandet och uppdaterade {count} fält. Vänligen granska de återstående utlåtandena manuellt.",
      "analysis_success_multiple_statements_no_fields": "Hittade {total_statements} utlåtanden i dokumentet men ingen ny information för att uppdatera formuläret.",
      "multiple_statements_warning": "Flera utlåtanden ({total_statements}) upptäcktes i dokumentet. Endast det första utlåtandet användes för formulärfyllning. Vänligen granska resterande utlåtanden manuellt.",
      "field": {
        "operation_notes": "Driftanteckningar"
      }
    },
    "purpose": {
      "DISCLOSURE": "Redovisning",
      "GRID_LOSSES": "Nätförluster",
      "SELF_CONSUMPTION": "Egenanvändning",
      "SUPPORT_SCHEME": "Stödschema",
      "OTHER": "Annat"
    },
    "success": {
      "title": "Utlåtande skapat!",
      "message": "Ditt annulleringsutlåtande har skapats framgångsrikt."
    }
  },
  "document": {
    "document_container": "Samlade dokument",
    "send_elering_email": "Skicka Energimyndigheten-e-post",
    "resend_email": "Skicka e-post igen",
    "signed": "Signerad",
    "awaiting_signature": "Väntar på signatur",
    "download": "Ladda ner dokument",
    "sign_document": "Signera dokument",
    "delete_document": "Ta bort dokument",
    "admin_delete_document": "Admin - ta bort dokument",
    "confirm_delete": "Är du säker på att du vill ta bort detta dokument?",
    "confirm_admin_delete": "Är du säker på att du vill ta bort detta dokument som admin?",
    "unfinished_document": "Ej fullbordad registrering",
    "forward_service_appendix": {
      "title": "Avtal om terminsförsäljning",
      "description": "Detta stipulerar standardvillkoren för alla terminsförsäljningar som medlemmen och Soldera ingår i och tillhandahåller ett ramverk för parterna för överenskommelse om instruktionerna för terminsförsäljning."
    }
  },
  "followup": {
    "international_self_signup": {
      "title": "Vi hör av oss snart!",
      "message": "Tack för att du registrerade dig! Vårt team kontaktar dig för att slutföra introduktionen och hjälpa dig att signera de nödvändiga dokumenten."
    },
    "latvia_manual_auth": {
      "title": "Auktorisera Soldera i Grexel för att slutföra registreringen",
      "message": "Innan Soldera kan börja hantera dina Ursprungsgarantier behöver du manuellt auktorisera oss i Grexel-systemet. Följ instruktionerna i dokumentet nedan för att slutföra processen.",
      "button": "Visa auktoriseringsinstruktioner"
    },
    "latvia_sales_followup": {
      "title": "Vi kontaktar dig snart!",
      "message": "Dina nya anläggningar kommer att kräva en oberoende revision innan AST kan godkänna dem. Vi kontaktar dig snart för att diskutera nästa steg. Under tiden kan du lägga till ett annat företag eller en annan anläggning.",
      "button": "Lägg till företag eller anläggningar"
    }
  },
  "validations": {
    "required": "Detta fält är obligatoriskt.",
    "maxValue": "Det maximala värdet är {max}.",
    "required_and_min": "Detta fält är obligatoriskt och värdet måste vara minst {min}.",
    "required_and_range": "Detta fält är obligatoriskt och värdet måste vara mellan {min} och {max}.",
    "exactStringLength": "Detta fält måste vara exakt {length} tecken långt.",
    "exactDigitLength": "Detta fält måste vara exakt {length} siffror långt.",
    "minLength": "Detta fält är för närvarande '{model}' tecken långt, men måste vara minst {min} tecken långt.",
    "maxLength": "Detta fält får vara högst {max} tecken långt.",
    "estonianPersonalID": "Detta fält måste innehålla ett giltigt personnummer.",
    "estonianCompanyCode": "Detta fält måste innehålla ett giltigt organisationsnummer.",
    "estonianIDorCompanyCode": "Detta fält ska antingen en företagsregistreringskod eller ägarens personnummer.",
    "estonianYourPersonalIDifID": "Personnumret måste matcha ägarens personnummer.",
    "estonianDeviceEIC": "Detta fält måste innehålla en giltig EIC-kod för anläggningen (t.ex.: 38ZEE-12345678-X).",
    "estonianVATNumber": "Ange ett giltigt momsregistreringsnummer.",
    "latvianCompanyNumber": "Detta fält måste innehålla en giltig företagsregistreringskod.",
    "lithuanianCompanyNumber": "Detta fält måste innehålla en giltig företagsregistreringskod.",
    "latvianIDorVATNumber": "Detta fält måste innehålla momskoden för företag eller personnumret för individer",
    "latvianYourPersonalIDifID": "Personnumret måste matcha ägarens personnummer.",
    "latvianIDorRegistryCode": "Detta fält måste innehålla registreringskoden för företag eller personnumret för individer",
    "notExampleEIC": "EIC-koden får inte vara den kod som anges i exemplet, utan måste vara den faktiska EIC-koden för anläggningen.",
    "alpha": "Detta fält får endast innehålla bokstäver.",
    "personalName": "Ange ditt fullständiga namn.",
    "phoneNumber": "Detta fält måste innehålla ett giltigt telefonnummer.",
    "someSubsidies": "Om anläggningen har fått bidrag måste det specificeras här.",
    "generatorExists": "Ladda upp ditt nätavtal för anläggningen för att fortsätta.",
    "reasonableDate": "Säkerställ att datumet är korrekt.",
    "iban": "Ange ett giltigt IBAN-nummer.",
    "fileRequired": "Ladda upp det obligatoriska dokumentet.",
    "swedishPersonalID": "Detta fält måste innehålla ett giltigt svenskt personnummer (ÅÅMMDD-XXXX).",
    "swedishCompanyCode": "Detta fält måste innehålla ett giltigt svenskt organisationsnummer.",
    "swedishIDorCompanyCode": "Detta fält måste innehålla antingen ett giltigt svenskt personnummer eller organisationsnummer.",
    "productionValue": "Produktionsvärdet måste vara större än noll.",
    "dateCannotBeFuture": "Datumet kan inte vara i framtiden.",
    "finnishPersonalID": "Detta fält måste innehålla en giltig finsk personbeteckning.",
    "finnishBusinessID": "Detta fält måste innehålla ett giltigt finskt FO-nummer (Y-tunnus).",
    "finnishIDorBusinessID": "Detta fält måste innehålla antingen ett giltigt finskt personnummer eller FO-nummer.",
    "integer": "Detta fält måste innehålla ett heltal.",
    "required_and_integer": "Detta fält är obligatoriskt och måste vara ett heltal.",
    "required_integer_and_min": "Detta fält är obligatoriskt, måste vara ett heltal och minst {min}.",
    "required_integer_and_range": "Detta fält är obligatoriskt, måste vara ett heltal och mellan {min} och {max}.",
    "selection_required": "Minst en markering krävs.",
    "between": "Värdet måste vara mellan {min} och {max}.",
    "validRegistryCode": "Registreringskod måste vara 3-20 alfanumeriska tecken (bokstäver, siffror, bindestreck tillåtna).",
    "validAddress": "Adressen måste vara mellan 5 och 200 tecken lång.",
    "validVATNumber": "Vänligen ange ett giltigt momsregistreringsnummer (format: XX123456789 eller CHE123456789).",
    "swedishVATNumber": "Vänligen ange ett giltigt svenskt momsregistreringsnummer (format: SE + 10 siffror + 01, t.ex. SE556229657301).",
    "validRepresentativeName": "Namnet måste vara 2-100 tecken långt och innehålla både för- och efternamn.",
    "validRepresentativePhone": "Telefonnumret måste vara 6-25 tecken långt och i ett giltigt format.",
    "minValue": "Minsta värde är {min}.",
    "polishVATNumber": "Detta fält måste innehålla ett giltigt polskt momsregistreringsnummer (PL + 10 siffror).",
    "polishRegistryCode": "Detta fält måste innehålla en giltig polsk företagsregistreringskod (10 siffror för KRS).",
    "email": "Vänligen ange en giltig e-postadress.",
    "eecs_account_format": "Ogiltigt EECS-kontonummerformat",
    "unit_price_pln_format": "Måste vara ett positivt belopp med högst 2 decimaler"
  },
  "validation": {
    "pl": {
      "invalid_vat_number": "Vänligen ange ett giltigt polskt momsregistreringsnummer (PL + 10 siffror).",
      "invalid_registry_code": "Vänligen ange en giltig polsk företagsregistreringskod (10 siffror för KRS)."
    }
  },
  "registry_device": {
    "device_name": "Anläggningsnamn",
    "device_power": "Kapacitet",
    "supported_device": "Subventionerad anläggning",
    "fetch_failed": "Det misslyckades att hämta anläggningar",
    "device_code": "Anläggning med kod {code}",
    "technology_code": "Teknikkod",
    "commercial_operation_date": "Kommersiell driftsdatum",
    "ecolabel_approved": "Miljömärkning godkänd",
    "address": "@:common.address",
    "device_eic_placeholder": "Ange enhetens identifieringskod",
    "device_name_placeholder": "Ange enhetsnamn",
    "device_power_placeholder": "Ange effekt i kW",
    "device_eic_description": "Unik identifierare för enheten i registret",
    "commercial_operation_date_description": "Datumet då enheten började kommersiell drift",
    "polish_fields": {
      "title": "Ytterligare information som krävs för fullmakt för utfärdandedata",
      "installation_address": "Installationsadress",
      "installation_address_placeholder": "Ange den fysiska adressen för enhetens installation",
      "installation_address_description": "Den fysiska adressen där enheten för förnybar energi är installerad",
      "metering_system_number": "Mätsystemnummer",
      "metering_system_number_placeholder": "Ange mätsystemets identifierare",
      "metering_system_number_description": "Den unika identifieraren för mätsystemet",
      "metering_system_multiplier": "Mätsystemsmultiplikator",
      "metering_system_multiplier_placeholder": "Ange multiplikatorvärdet",
      "metering_system_multiplier_description": "Multiplikatorfaktorn som tillämpas på mätaravläsningar",
      "osd_name": "Distributionsnätsoperatör (OSD) namn",
      "osd_name_placeholder": "Ange OSD-namn och filial (om tillämpligt), t.ex. PGE Dystrybucja S.A. Oddział Łódź",
      "osd_name_description": "Namnet på distributionsnätsoperatören och den specifika filial som är ansluten till din enhet",
      "osd_address": "OSD-adress",
      "osd_address_placeholder": "Ange OSD-adressen (filialadress om tillämpligt), t.ex. ul. Tuwima 58, 90-021 Łódź",
      "osd_address_description": "Adressen till den distributionsnätsoperatörsfilial som är ansluten till din enhet"
    },
    "poa": {
      "generate": "Generera fullmakt",
      "generating": "Genererar fullmakt...",
      "generated_successfully": "Fullmakt har genererats framgångsrikt",
      "description": "Generera ett fullmaktsdokument för att ge Soldera åtkomst till din enhets utfärdandedata",
      "missing_polish_data_error": "Denna enhet saknar nödvändig information för fullmaktsgenerering",
      "required_for_issuance": "Följande information krävs för att generera en fullmakt för åtkomst till utfärdandedata."
    },
    "production_estimate_override": {
      "title": "Överskrivning av produktionsprognos",
      "save": "Spara",
      "saving": "Sparar...",
      "use_manual_estimates": "Använd manuella prognoser",
      "use_automatic_estimates": "Använd automatiska prognoser",
      "monthly_production_estimates": "Månatliga produktionsprognoser",
      "automatic_vs_manual": "Automatisk vs manuell",
      "automatic_calculated": "Automatisk (beräknad)",
      "automatic": "Automatisk",
      "manual": "Manuell",
      "override_button": "Skriv över prognoser",
      "projected_production": "Prognostiserad produktion",
      "configured_values": "Konfigurerade värden",
      "calculated_values": "Beräknad från historiska data",
      "feasibility_warning": "Baserat på de nya prognoserna kanske dina terminsförsäljningsmandat inte längre täcker sina åtaganden: under {period} är {demand} MWh åtagna men prognosen saknar {shortfall} MWh. Vänligen granska dina terminsvolymer.",
      "feasibility_warning_title": "Varning för framtida försäljningsstrategi"
    }
  },
  "account": {
    "name": "Namn",
    "email": "E-post",
    "phone_number": "Telefonnr",
    "registry_code": "Personnr",
    "comment": "Kommentar"
  },
  "company": {
    "payout_currency": "Utbetalningsvaluta",
    "payout_currency_hint": "Utbetalningar i andra valutor aktiveras av Solderas support.",
    "name": "@:common.name",
    "registry_code": "Org.nr",
    "address": "@:common.address",
    "vat": "Momsnr",
    "vat_or_personal_id": "Momsnr eller personnr",
    "bank_account": "IBAN-nummer",
    "bank_name": "Bankens namn",
    "bank_swift": "SWIFT-kod",
    "invalid_vat": "Momsnummer måste vara enligt formatet XX999999999 (landskod + 8-12 siffror)",
    "contact_email": "Kontakt e-post",
    "invoice_email": "Faktura e-post",
    "billing_email": "E-postadress för fakturering",
    "billing_email_tooltip": "Fakturor skickas även till denna adress utöver ditt kontos e-post. Användbart för vidarebefordran till din revisor eller ekonomiavdelning.",
    "monthly_rollup": "Hoppa över försäljningsmeddelanden — få ett månatligt e-postmeddelande den 1:a",
    "monthly_rollup_tooltip": "Du får inget e-postmeddelande när en försäljning görs. I stället får du den 1:a varje månad ett e-postmeddelande med förra månadens försäljningar och din avgiftsfaktura. Utbetalningsfakturor skickas fortfarande när du begär en utbetalning."
  },
  "generator": {
    "device_name": "Växelriktarmodell",
    "device_eic": "Anläggningens EIC-kod",
    "device_power": "Total kapacitet (kW)",
    "device_address": "Anläggningens adress",
    "grid_contract_start_date": "Produktionsstartdatum",
    "subsidies": "Subventioner",
    "battery": "Lagringsenhet",
    "ppa": "Elköpsavtal",
    "no_subsidies": "Inga subventioner",
    "no_storage_device": "Ingen lagringsenhet",
    "no_ppa": "Inget elköpsavtal",
    "no_battery": "Ingen lagringsenhet",
    "subsidy_provider": "Subventionsleverantör: {provider}",
    "subsidy_plan": "Subventionsplan: {plan}",
    "unit_power": "Enhetseffekt: {power}",
    "capacity": "Kapacitet: {capacity}",
    "ppa_start_date": "Startdatum: {date}",
    "ppa_mwh": "MWh: {mwh}",
    "ppa_client_name": "Kundföretag: {name}",
    "ppa_country": "Kundland: {country}",
    "EIC": "EIC",
    "status": {
      "1": "Ej registrerad",
      "2": "Dokument att signera",
      "3": "Registrerad"
    },
    "continue_registration": "Fortsätt registrering",
    "sign_document": "Signera dokument",
    "edit": "Redigera",
    "properties": {
      "device_name": "Växelriktarmodell",
      "solar_panel_model": "Solpanelsmodell",
      "device_address": "Adress",
      "device_power": "Kapacitet",
      "battery": "Lagringsenhet",
      "subsidies": "Subventioner"
    },
    "unspecified": "Ej specificerad",
    "documents": "@:common.documents",
    "document_title": "Kontrakt för enhets-EIC: {eic}",
    "license_number": "Licensnummer"
  },
  "invoice": {
    "status": {
      "paid": "Betald",
      "canceled": "Avbruten",
      "requested": "Begärd",
      "drafting": "Under skapande"
    },
    "regenerate_confirmation": "Är du säker på att du vill återgenerera fakturan?",
    "regenerate": "Återgenerera",
    "cancel_fee_only": "Avbryt",
    "cancel_fee_only_confirmation": "Är du säker på att du vill avbryta denna avgiftsfaktura? Fakturaposterna återgår till väntande och både avgifts- och avräkningsfakturan tas bort.",
    "cancel_mixed_types_disabled": "Det går inte att avbryta utgifts- och avgiftsfakturor i samma omgång — välj endast en typ i taget.",
    "send_to_merit": "Skicka till Merit",
    "send_to_merit_confirmation": "Är du säker på att du vill skicka denna faktura till Merit?",
    "already_in_merit": "Fakturan är redan registrerad i Merit.",
    "error_downloading": "Fel vid nedladdning av faktura",
    "number": "Fakturanummer",
    "status_label": "Status",
    "requested_date": "Begärt datum",
    "amount": "Summa"
  },
  "invoiceHistory": {
    "title": "Fakturahistorik",
    "noInvoices": "Här hittar du dina framtida fakturor",
    "notificationInfo": "Vi meddelar dig via e-post när försäljningstransaktioner har genomförts.",
    "export_xlsx": "Exportera till Excel"
  },
  "setPriceTerms": {
    "modifyStrategyTitle": "Ändra försäljningsstrategi",
    "selectStrategyLabel": "Välj försäljningsstrategi",
    "automaticHighBid": "Automatisk försäljning till högsta bud",
    "fresh_prod_above_min_price": "Ange ett tidsbegränsat minimipris",
    "minimumPriceDuration": "Minimipris för de första {duration} månaderna",
    "minimumPriceLabel": "Minimipris",
    "enterPrice": "Ange pris",
    "saveChanges": "Spara ändringar",
    "readMore": "Läs mer",
    "duration": {
      "minimum_price_window": "Minimipris-fönster",
      "default_hint": "Standard är 6 månader från produktionsdatum",
      "limit_active_for": "Gräns aktiv i {duration} månader från utfärdande"
    },
    "warning": {
      "depreciation": "Varning: Certifikat äldre än 6 månader tenderar att minska snabbt i värde när de närmar sig 12-månaders överföringsfrist.",
      "noSaleAt12": "Kritisk varning: Med 10-12 månader valt kan era ursprungsgarantier minska i värde till noll eftersom certifikat inte kan överföras efter 12 månader från utfärdandet. Redan vid 10-månadersmarkeringen återstår lite tid, vilket gör dessa certifikat svåra att sälja."
    },
    "phases": {
      "title": "Så fungerar denna strategi",
      "phase_1_badge": "Fas 1",
      "phase_1_title": "Första {duration} månaderna från produktion",
      "phase_1_description": "Certifikat hålls kvar tills marknadspriset når eller överskrider ditt minimipris på €{price}/MWh. Om priset är under ditt minimum säljs certifikaten inte.",
      "phase_2_badge": "Fas 2",
      "phase_2_title": "Efter {duration} månader från produktion",
      "phase_2_description": "Alla osålda certifikat säljs automatiskt till högsta tillgängliga marknadspris. Detta säkerställer att dina certifikat alltid säljs innan de löper ut.",
      "readonly_summary": "Minimipris de första {duration} månaderna, sedan automatisk försäljning till marknadspris"
    },
    "howMinimumPriceWorks": "Hur Solderas minimipris fungerar",
    "contentParagraph1": "Automatisk försäljning till marknadspris medför ett säkert sätt att sälja ursprungsgarantier, sprida risk och säkerställa att de säljs när de är som nyast.",
    "content_paragraph_2": "Vi förstår att många av våra medlemmar vill planera sin försäljning av ursprungsgarantier. Det finns dock alltid en risk att priset på dem inte når det önskade minimipriset. Försäljning till marknadspris är således ett betydligt bättre alternativ än att riskera att ursprungsgarantierna löper ut och därmed förblir osålda.",
    "content_paragraph_3": "Vi erbjuder därför möjligheten att sätta en minimiprisstrategi. Under de första {duration} månaderna efter att era certifikat har utfärdats kommer vi endast att sälja dem om marknadspriset når eller överträffar ert minimipris. Efter att denna {duration}-månadersperiod löper ut kommer vi automatiskt att sälja alla återstående certifikat till nuvarande marknadspris för att förhindra värdeförlust. Denna strategi ger er möjligheten att dra nytta av prisökningar samtidigt som det säkerställs att era certifikat alltid säljs innan de löper ut.",
    "howMarketPriceWorks": "Hur Solderas marknadspris fungerar",
    "marketPriceContentParagraph1": "Soldera aggregerar ursprungsgarantier från flera medlemmar till större försäljningstransaktioner, vilket kombinerar vår kollektiva volym för att uppnå starkare marknadspositionering och bättre priser. Vi genomför regelbundna försäljningar med smarta strategier och timing som maximerar transaktionsfrekvensen. För att underlätta denna process överför vi era ursprungsgarantier till vårt registerkonto, där vår programvara hanterar allt automatiskt - ni behöver aldrig förhandla med köpare eller hantera överföringar själva.",
    "marketPriceContentParagraph2": "Före varje försäljning inhämtar Soldera prisofferter från vårt breda nätverk av internationella köpare, vilket säkerställer konkurrenskraftig prissättning genom våra marknadsrelationer. Vi väljer det bästa erbjudna priset och genomför försäljningen för alla deltagande medlemmars räkning. Vårt automatiserade system hanterar all komplexitet samtidigt som det upprätthåller transparens i prissättningsprocessen.",
    "marketPriceContentParagraph3": "Inom 5 dagar efter att ha mottagit betalning från köparen kommer vi att meddela er transaktionsdetaljerna via e-post, inklusive er andel av intäkterna efter avdrag för våra avgifter och transaktionskostnader (oftast registrets exportavgifter). Därefter kan ni begära er utbetalning med ett klick genom Soldera-plattformen - om ni inte vill utfärda en faktura omedelbart kan ni göra det senare när som helst. Soldera överför betalningen till ert konto inom 7 dagar efter att ha mottagit er faktura."
  },
  "requestInvoice": {
    "indicative_payout_explainer": "Till ECB-kursen {rate} ({date}). Vägledande: utbetalningen räknas om till kursen på sitt eget datum.",
    "submit_invoice": "Skicka faktura",
    "money_pending": "Innestående summa",
    "sales_revenue": "Försäljningsintäkter",
    "sales_vat": "Försäljningsmoms",
    "state_income_tax": "Statlig inkomstskatt",
    "service_fees_vat": "Serviceavgifter (inkl. moms)",
    "detailed_overview": "Detaljerad översikt",
    "view_details": "Visa detaljer",
    "invoice_items": "Fakturaposter",
    "item": "Artikel",
    "quantity": "Kvantitet",
    "unit_price": "Enhetspris",
    "total_excl_vat": "Totalt (exkl. moms)",
    "vat": "Moms",
    "offset_service_fees": "Räkna av serviceavgifter",
    "invoice_details": "Fakturauppgifter",
    "invoice_number": "Fakturanummer",
    "invoice_number_placeholder": "Fakturanummer",
    "vat_number": "Momsnummer",
    "vat_number_placeholder": "Momsnummer",
    "bank_account_iban": "IBAN-nummer",
    "bank_account_placeholder": "IBAN",
    "contact_block_on_invoice": "Kontaktinformation på fakturan",
    "contact_block_placeholder": "Företagsnamn, \nAdress, \nOrganisationsnummer",
    "reference": "Referens (valfritt)",
    "reference_placeholder": "Referensnummer",
    "monthly_rollup_label": "Hoppa över försäljningsmeddelanden — få ett månatligt e-postmeddelande med din avgiftsfaktura den 1:a",
    "month_split_label": "Datera förra månadens försäljning {date}",
    "month_split_tooltip": "Din försäljning från {month} hamnar på en separat utbetalningsfaktura daterad {date}, samma månad som din avgiftsfaktura för {month}. Försäljning från {current_month} hamnar på en andra faktura daterad i dag.",
    "month_split_tooltip_pending": "Din försäljning från {month} hamnar på en utbetalningsfaktura daterad {date}, samma månad som din avgiftsfaktura för {month}. Försäljning från {current_month} väntar på en senare utbetalning.",
    "month_split_previous_heading": "Försäljning {month} — faktura daterad {date}",
    "month_split_current_heading": "Försäljning {current_month} — faktura daterad i dag",
    "month_split_pending_heading": "Försäljning {current_month} — väntar på en senare utbetalning",
    "month_split_current_number": "Fakturanummer för försäljning {current_month}",
    "month_split_number_must_differ": "Måste skilja sig från fakturanumret ovan"
  },
  "certificateHistory": {
    "overview": "Översikt ursprungsgarantier",
    "productionPeriod": "@:common.production_period",
    "certificateCount": "Antal ursprungsgarantier",
    "expired": "Förfallna",
    "sold": "Sålda",
    "awaitingSale": "Väntar på försäljning"
  },
  "chooseCompany": {
    "select_company": "Välj företag att ge behörighet",
    "choose_company": "Välj företag",
    "create_new_company": "Skapa ett nytt företag"
  },
  "invoiceItem": {
    "quantity": "Kvantitet",
    "unit_price": "Enhetspris",
    "total_excl_vat": "Totalt (exkl. moms)",
    "vat": "Moms"
  },
  "tradingCenter": {
    "tradingStrategy": "Handelsstrategi",
    "title": "Produktionsstrategi",
    "tabs": {
      "overview": "Översikt",
      "strategyCustomisation": "Anpassa handelsstrategi",
      "issuance_reporting": {
        "title": "Utfärdanderapport"
      }
    },
    "customization": {
      "forwardSales": "Terminsförsäljning",
      "spotSales": "Spotförsäljning",
      "ppaReserve": "PPA-reserv",
      "holdPortfolio": "Självhantering"
    },
    "overview": {
      "projectedProduction": {
        "title": "Förväntad produktion",
        "noData": "Din uppskattade årliga produktion kommer att visas här efter att vi har hämtat information om dina enheter från registret."
      },
      "spot": {
        "title": "Spotförsäljning",
        "visualization": {
          "minimumPrice": {
            "title": "Försök att sälja över {price}€/MWh",
            "description": "Produktion ingår i anbud om förväntat pris är användarens fastställda minimipris",
            "firstMonths": "Första {duration} månaderna"
          },
          "highestBid": {
            "title": "Sälj till högsta bud",
            "description": "Produktionen säljs automatiskt till högstbjudande",
            "lastMonths": "Senaste {duration} månaderna"
          }
        }
      }
    }
  },
  "market_insights": {
    "title": "Marknadsinsikter",
    "description": "Marknadsinformation och analys för förnybar energi",
    "sections": {
      "reports": "Marknadsrapporter",
      "charts": "Marknadsdata och diagram"
    },
    "forward_outlook": {
      "title": "Soldera Forward Outlook",
      "description": "Månadsanalys om GO-marknadstrender och viktiga nyheter som påverkar marknaden"
    },
    "consulting_services": {
      "title": "Scope 2-efterlevnadsstöd",
      "description": "Soldera tillhandahåller efterlevnad på begäran. Kontakta oss för mer information.",
      "button_text": "Kontakta oss"
    },
    "norway_reservoir": {
      "title": "Norges reservoarnivåer",
      "description": "Veckovisa reservoarnivåer med historisk jämförelse och prognoser",
      "zone_label": "Handelszon",
      "y_axis_label": "% av kapacitet",
      "loading": "Laddar reservoardata...",
      "error": "Kunde inte ladda reservoardata",
      "no_data": "Ingen data tillgänglig för vald zon",
      "locked_zones_hint": "Lås upp alla reservoarzoner — kontakta oss för att aktivera detaljerade regionala insikter",
      "info_text": "Norge är den största exportören av ursprungsgarantier (UG) till andra AIB-medlemsländer, drivet av landets omfattande vattenkraftsproduktion. Inhemska policyer uppmuntrar inte lokal användning av UG och skapar ett betydande exportöverskott. Därför får förändringar i Norges vattenkraftskapacitet eller inhemska konsumtionsmönster oproportionerligt stor påverkan på den bredare europeiska UG-marknaden.\n\nDatan uppdateras varje vecka. Faktiska reservoarnivåer bekräftas vanligtvis betydligt senare, så vi tillhandahåller våra uppskattningar för att bättre förutsäga marknadsdynamiken.",
      "zones": {
        "norway_total": "Norge totalt"
      },
      "legend": {
        "historical_max": "Historiskt max",
        "historical_median": "Historisk median",
        "historical_min": "Historiskt min",
        "last_year": "Förra året",
        "this_year": "I år",
        "predicted": "Prognosticerat"
      }
    },
    "cumulative_re": {
      "title": "Kumulativ förnybar energiproduktion",
      "description": "Årsjämförelse av förnybar energiproduktion",
      "country_label": "Land",
      "eu_aggregate": "Europeiska unionen (Aggregerad)",
      "y_axis_label": "GWh",
      "loading": "Laddar diagramdata...",
      "error": "Kunde inte ladda diagramdata",
      "info_text": "Årlig produktion av förnybar energi är en stark indikator på prisriktningen – om produktionen ökar kraftigt brukar priserna på UG sjunka när utbudet av UG ökar.\n\nDatan uppdateras varje vecka och inkluderar inte länder som inte är AIB-medlemmar eller som inte tillhör Fastlandseuropa."
    }
  },
  "charts": {
    "xAxisLabel": "X-axel",
    "stackByLabel": "Stapla efter",
    "fields": {
      "portfolio_type": "Portföljtyp",
      "production_month": "Produktionsmånad",
      "status": "Status",
      "technology_type": "Teknologi",
      "company_name": "Företagsnamn",
      "portfolio_name": "Portföljnamn",
      "production_device_name": "Produktionsenhet",
      "production_support": "Produktionsstöd",
      "ecolabel_tags": "Ecolabel",
      "transfer_deadline": "Överföringsfrist",
      "count": "Antal",
      "certificate_id": "Certifikat-ID",
      "registration_authority": "Registreringsmyndighet",
      "registry_region": "Nuvarande register",
      "issuing_region": "Utfärdanderegister",
      "cod_age": "COD ålder",
      "limit_price": "Minimipris",
      "sale_price": "Försäljningspris",
      "account_emails": "Konton",
      "registry_id": "Register-ID",
      "bundle_start": "Bunt-start",
      "bundle_end": "Bunt-slut"
    },
    "values": {
      "production_support": {
        "true": "Med stöd",
        "false": "Utan stöd",
        "null": "Okänt"
      },
      "portfolio_type": {
        "FORWARD": "Terminsförsäljning",
        "SPOT_MARKET_PRICE": "Spotförsäljning",
        "SPOT_MIN_PRICE": "Spotförsäljning med minimipris",
        "HOLD": "Håll",
        "UNALLOCATED": "Väntar på åtgärd",
        "VIRTUAL": "Värdkonton",
        "PPA": "PPA-reserv",
        "OWN_USE": "Egen användning"
      },
      "certificate_status": {
        "ONGOING_SALE": "Pågående försäljning",
        "SOLD": "Såld",
        "EXPIRED": "Förfallna",
        "NON_TRANSFERRABLE": "Ej överförbart",
        "RESERVED": "Reserverad",
        "WAITING_FOR_SALE": "Väntar på försäljning",
        "AVAILABLE": "Tillgänglig",
        "CANCELLED": "Annullerad",
        "PENDING": "@:common.pending",
        "TRANSFERRED": "Överförd",
        "REVOKED": "Återkallad av registret",
        "OWN_USE": "Egen användning"
      }
    },
    "noDataMessage": "Ingenting att visa. Vänligen justera dina filterval.",
    "panel": {
      "title": "Diagram",
      "region_label": "Diagram över certifikaten i tabellen",
      "mwh": "{mwh} MWh",
      "summary_rows": "på inga rader · {available} MWh tillgängliga | på {count} rad · {available} MWh tillgängliga | på {count} rader · {available} MWh tillgängliga",
      "hide": "Dölj diagram",
      "show": "Visa diagram",
      "break_down_by": "Dela upp efter",
      "segment_label": "Filtrera tabellen till {field} {value}, {mwh} MWh",
      "segment_inline": "{label} · {mwh} MWh",
      "segment_hint": "Klicka på ett segment för att filtrera tabellen till det"
    }
  },
  "inventory": {
    "actions": {
      "title": "Lagerhantering",
      "send": {
        "success": "Skicka operationen slutfördes framgångsrikt",
        "prompt": "Vart vill du skicka dessa ursprungsgarantier? Vänligen ange land, volymer och mottagarens registreringsnummer.",
        "simulated_response": "Förstått! Förbereder att skicka dina ursprungsgarantier."
      },
      "receive": {
        "success": "Mottagningsoperationen slutfördes framgångsrikt",
        "prompt": "Från vem förväntar du dig att ta emot ursprungsgarantier? Vänligen ange land, volymer och avsändarens registreringsnummer.",
        "simulated_response": "Förstått! Vi meddelar dig vid ankomst."
      },
      "buy": {
        "success": "Köpoperationen slutfördes framgångsrikt",
        "prompt": "Vilka ursprungsgarantier vill du köpa idag? Vänligen ange land, volymer och mottagarens registreringsnummer.",
        "simulated_response": "Utmärkt! Söker efter tillgängliga ursprungsgarantier att köpa. Här är några erbjudanden: 500 MWh från Estland, Vindkraft, Produktionsdatum: Jan 2024, Pris: €2.50/MWh; 1,000 MWh från Lettland, Solkraft, Produktionsdatum: Feb 2024, Pris: €3.00/MWh; 750 MWh från Litauen, Vattenkraft, Produktionsdatum: Mars 2024, Pris: €2.75/MWh"
      },
      "sell": {
        "success": "Försäljningsoperationen slutfördes framgångsrikt",
        "prompt": "Vilka ursprungsgarantier vill du lägga ut till försäljning? Vänligen ange land, volymer.",
        "simulated_response": "Perfekt! Listar dina ursprungsgarantier till försäljning. Vi meddelar dig när en köpare hittas."
      }
    }
  },
  "errors": {
    "genericNetworkError": "Nätverksfel. Var god försök igen.",
    "missingCompanyId": "Fel: Företagsammanhang saknas.",
    "unsupportedFileType": "Ej stödd filtyp. Vänligen ladda upp en giltig fil.",
    "fileTooLarge": "Filen är för stor. Maximal storlek är 25MB."
  },
  "go_cancel": {
    "beneficiary_suggestions": {
      "placeholder": "Välj eller ange en förmånstagare"
    },
    "statements_title": "Annulleringsdeklarationer",
    "add_statement_button": "Lägg till annulleringsdeklaration",
    "no_statements_yet": "Inga annulleringsdeklarationer har lagts till ännu. Klicka på 'Lägg till annulleringsdeklaration' för att börja.",
    "more_statements": "fler deklarationer",
    "statement_number": "Deklaration #{number}",
    "remove_statement_button": "Ta bort",
    "remove_statement_row_aria": "Ta bort annulleringsuttalandets rad {index}",
    "statement_form_placeholder": "Komplett annulleringsdeklarationsformulär kommer att visas här.",
    "confirm_order_button": "Granska annulleringsorder",
    "portfolio_items_title": "Välj portföljartiklar för annullering",
    "portfolio_table_placeholder": "PortfolioItemsTable kommer att visas här för att välja certifikat.",
    "upload_description": "Ladda upp ett dokument för att automatiskt extrahera annulleringsdeklarationer och mottagarinformation",
    "analysis_success_with_statements": "Analys slutförd! Extraherade {count} annulleringsdeklarationer från dokumentet.",
    "analysis_success_no_statements": "Analys slutförd! Inga annulleringsdeklarationer hittades i dokumentet.",
    "analysis_complete_title": "Dokumentanalys slutförd",
    "analysis_shared_fields_inconsistent_warning": "Gemensamma fält mellan deklarationerna är inkonsekventa. Bekräfta förmånstagartyp, period och syftesmall manuellt.",
    "shared_defaults_title": "Gemensamma inställningar för alla deklarationer",
    "shared_defaults_incomplete": "Fyll i de gemensamma inställningarna innan du granskar annulleringsordern.",
    "table_validation_hint": "Vissa rader är ofullständiga eller ogiltiga. Korrigera markerade fält för att fortsätta.",
    "max_statements_reached": "Maximalt {max} annulleringsdeklarationer nåddes. Dela upp i flera ordrar om du behöver fler.",
    "analysis_truncated_warning": "Dokumentet innehöll {total} deklarationer men bara de första {max} laddades. Skicka dem som en separat order och ladda sedan upp resten på nytt.",
    "form": {
      "prior_year_cutoff_specific": "Annulleringar för {year} är inte längre tillåtna — tidsfristen var {cutoffDate}",
      "beneficiary_details_title": "Mottagarens information",
      "beneficiary_name": {
        "label": "Mottagarens namn",
        "placeholder": "Ange företags- eller personnamn"
      },
      "beneficiary_type": {
        "label": "Mottagartyp",
        "CONSUMER": "Konsument",
        "ELECTRICITY_SELLER": "Elhandlare",
        "CONVERSION_PLANT_OPERATOR": "Konverteringsanläggningsoperatör"
      },
      "registry_code": {
        "label": "Registreringskod (organisations- eller personnummer)",
        "short_label": "Registreringskod",
        "placeholder": "Ange organisationsnummer eller personnummer"
      },
      "address": {
        "label": "Adress",
        "placeholder": "Ange fullständig adress",
        "required_help": "Adress krävs för detta land"
      },
      "registry_country_region": {
        "label": "Registerland/region",
        "placeholder": "Välj registerland eller region",
        "mismatch_warning": "Valt register skiljer sig från certifikatets plats"
      },
      "cancellation_details_title": "Annulleringsinformation",
      "mwh_cancelled": {
        "label": "MWh att annullera",
        "short_label": "Annullerad MWh",
        "placeholder": "0"
      },
      "period_start": {
        "label": "Konsumtionsperiod start"
      },
      "period_end": {
        "label": "Konsumtionsperiod slut",
        "invalid_date_range": "Slutdatum måste vara efter startdatum",
        "cutoff_help": "Annulleringar för {year} års konsumtion måste skickas in före 31 mars {nextYear}"
      },
      "cancellation_purpose": {
        "label": "Annulleringsändamål",
        "DISCLOSURE": "Redovisning",
        "GRID_LOSSES": "Nätförluster",
        "SELF_CONSUMPTION": "Egenförbrukning",
        "SUPPORT_SCHEME": "Stödordning",
        "OTHER": "Annat"
      },
      "cancellation_purpose_text": {
        "label": "Annulleringsändamål",
        "placeholder": "Ange annulleringsändamålet",
        "help": "Beskriv kortfattat varför dessa certifikat annulleras"
      },
      "global_operation_notes": {
        "label": "Övergripande anteckningar för annulleringsordern (valfritt)",
        "placeholder": "Ange eventuella övergripande anteckningar för hela annulleringsordern..."
      },
      "keep_private": {
        "label": "Håll annulleringsdeklarationen privat",
        "hint": "Registret skapar ingen offentligt tillgänglig länk till PDF-filen för denna annulleringsdeklaration.",
        "ppa_hint": "Gäller endast i register på Grexel-plattformen (LV, LT, DK, HR, HU, BE-FED, SE, FR); ignoreras i övriga."
      },
      "tge_legal_form": {
        "label": "Företagsform",
        "placeholder": "Välj mottagarens företagsform",
        "detected_hint": "Hämtad från mottagarens namn",
        "not_detected_hint": "Kunde inte hämtas från mottagarens namn. TGE kräver den.",
        "options": {
          "limited_company": "Aktiebolag (sp. z o.o., S.A.)",
          "partnership": "Handels- eller kommanditbolag (sp. j., sp. p., sp. k., S.K.A.)",
          "private_partnership": "Enkelt bolag (s.c.)",
          "sole_proprietorship": "Enskild firma",
          "other": "Annan"
        }
      },
      "tge_vat_number": {
        "label": "Momsregistreringsnummer (NIP)",
        "short_label": "Momsnr",
        "placeholder": "PL1234567890",
        "hint": "Valfritt"
      }
    },
    "no_portfolio_items_available": "Det finns för närvarande inga portföljartiklar tillgängliga för annullering.",
    "tooltip_beneficiary_name": "Den juridiska eller fysiska person som kommer att anges som förmånstagare på annulleringsutlåtandet.",
    "tooltip_registry_country_region": "Registret där annulleringen kommer att utföras.",
    "tooltip_registry_code": "Företagets organisationsnummer eller en privatpersons personnummer — inte momsnumret. Visas på annulleringsutlåtandet.",
    "tooltip_address": "Förmånstagarens registrerade adress eller anläggningsadress. Krävs av vissa register.",
    "tooltip_mwh_cancelled": "Antal certifikat att annullera i megawattimmar (MWh). 1 MWh = 1 certifikat.",
    "auto_select_certificates_checkbox": "Välj certifikat automatiskt",
    "order_submitted_successfully": "Annulleringsorder har skickats in!",
    "order_submission_failed": "Misslyckades med att skicka in annulleringsorder. Var god försök igen.",
    "buy_missing_request_sent": "Begäran om att köpa saknade ursprungsgarantier har skickats. Vi kontaktar dig inom kort.",
    "buy_missing_request_failed": "Misslyckades med att skicka begäran om saknade ursprungsgarantier. Var god försök igen eller kontakta support.",
    "insufficient_inventory_warning": "Varning: Otillräckliga ursprungsgarantier i lager för att täcka den totala MWh som anges i deklarationerna. Du har {availableMwh} MWh tillgängliga men behöver {neededMwh} MWh.",
    "buy_missing_gos_button": "Begär saknade ursprungsgarantier",
    "autoselect_failed": "Automatiskt val av certifikat misslyckades. Var god välj manuellt eller försök igen.",
    "review_modal_statement_title": "Annullering för: {beneficiaryName} i",
    "region_mismatch_warning": {
      "title": "Registeravvikelse",
      "message": "Vissa valda certifikat finns för närvarande i ett annat register än det valda målregistret för annullering. Innan vi behandlar annulleringen överför vi dessa certifikat till det valda registret."
    },
    "any_aib_option": "Any AIB",
    "any_aib_address_hint": "Lägg till {'{'}address{'}'} i annulleringsändamålet som platshållare när du använder Any AIB. Förmånstagarens plats rapporteras som \"Europe\" på utlåtandet.",
    "address_placeholder_missing_warning": "Annulleringsändamålet använder platshållaren {'{'}address{'}'}, men minst en förmånstagare saknar adress. För dessa rader lämnas texten {'{'}address{'}'} oförändrad.",
    "beneficiary_type_conflict_switch": "Alla deklarationer i denna annullering skickas in med mottagartypen {sharedType}, men {names} har tidigare använt {rememberedType}. Byt den delade mottagartypen till {rememberedType}, eller fortsätt om den tidigare typen är föråldrad.",
    "beneficiary_type_conflict_mixed": "Alla deklarationer i denna annullering skickas in med mottagartypen {sharedType}, men dessa mottagare har tidigare använt en annan typ: {details}. Fortsätt om de tidigare typerna är föråldrade.",
    "accelerator_title": "Börja från ett dokument",
    "summary_order_title": "Annulleringsorder",
    "summary_mwh_to_cancel": "MWh att annullera",
    "summary_statements": "Deklarationer",
    "summary_consumption_period": "Konsumtionsperiod",
    "summary_certificates_selected": "Valda certifikat",
    "summary_mwh_value": "{mwh} MWh",
    "summary_ready": "Redo att bekräfta",
    "summary_status_incomplete": "Fyll i annulleringsuppgifterna",
    "summary_status_select": "Välj certifikat att annullera",
    "summary_status_match": "Välj certifikat för totalt {mwh} MWh",
    "summary_status_insufficient": "Otillräckligt matchande lager",
    "no_data_short": "—",
    "summary_build_title": "Skapa din order",
    "summary_step_beneficiary": "Lägg till en mottagare och konsumtion",
    "summary_step_certificates": "Välj certifikat att annullera",
    "summary_step_review": "Granska och bekräfta ordern",
    "private_pill": "Privat",
    "statement_options_button_aria": "Inställningar för deklaration {index}",
    "statement_options_button_private_aria": "Inställningar för deklaration {index} — hålls privat",
    "statement_private_tooltip": "Annulleringsdeklarationen hålls privat",
    "carried_selection_summary": "Inga rader kom från ditt urval i Översikt. | {count} rad ({mwh} MWh) kom från ditt urval i Översikt. | {count} rader ({mwh} MWh) kom från ditt urval i Översikt.",
    "carried_selection_summary_partial": "Inga rader kom från ditt urval i Översikt. | {count} rad ({mwh} MWh, {partial}) kom från ditt urval i Översikt. | {count} rader ({mwh} MWh, {partial}) kom från ditt urval i Översikt.",
    "carried_selection_partial": "ingen delvis | {count} delvis | {count} delvis",
    "carried_selection_paused": "Automatiskt urval är pausat så att det inte ersätter dem.",
    "carried_selection_use_amount": "Använd {mwh} MWh som volym",
    "carried_selection_clear": "Rensa och välj automatiskt",
    "table_hint": "Endast certifikat som kan annulleras visas. Markerade rader annulleras helt; klicka på en volym för att annullera bara en del av raden.",
    "filter_shortfall": "Endast {available} av {needed} MWh matchar dina filter. Ta bort ett filter för att se fler certifikat.",
    "filter_shortfall_unavailable": "Inga certifikat matchar dina filter, {needed} MWh behövs. Ta bort filtret markerat i rött för att se dina certifikat.",
    "summary_status_filter_shortfall": "För få certifikat matchar dina filter"
  },
  "go_send": {
    "insufficient_inventory_warning": "Varning: Otillräckligt antal GO-certifikat i lager för att täcka den totala MWh-mängden i sändningsbegäran. Du har {availableMwh} MWh tillgängligt men behöver {neededMwh} MWh.",
    "recipient_hosted_badge": "HOSTAD",
    "recipient_hosted_helper": "Levereras till detta företags hostade konto hos Soldera",
    "recipient_hosted_region_note": "Regionen bestäms per certifikat vid sändning",
    "recipient_search_placeholder": "Sök efter företagsnamn, registreringskod eller EECS…",
    "recipient_no_results": "Inga matchande företag",
    "hosted_delivery_info": "Leveransuppgifter hanteras av Soldera och löses automatiskt per certifikat vid sändning.",
    "mixed_registry_selection_error": "Certifikat från olika register kan inte skickas i samma order. Skicka dem som separata ordrar.",
    "unit_price_pln_label": "Enhetspris (PLN/MWh)",
    "unit_price_pln_help": "Avtalets enhetspris i PLN/MWh. Det polska registret (TGE) kräver det och registrerar det på själva överföringen.",
    "account_invalid_unknown_registry": "Ange ett EECS-kontonummer (t.ex. 23X1234567) eller ett Ofgem-kontonummer så att registerlandet kan fastställas"
  },
  "portfolio_instructions": {
    "description": "Beskrivning",
    "ppa_name": "PPA namn",
    "configuration": "Konfiguration",
    "allocation_configuration": "Allokeringskonfiguration",
    "delivery_configuration": "Leveranskonfiguration",
    "allocation_mode": "Allokeringsläge",
    "allocate_all": "All produktion",
    "allocate_percentage": "Procentsats",
    "whole_production_info": "All produktion från de valda enheterna kommer att allokeras till detta PPA.",
    "allocate_fixed_amount": "Allokera fast belopp",
    "allocate_fixed_amounts": "Fasta belopp",
    "total_mwh_label": "Totalt MWh",
    "allocate_fixed_amounts_per_year": "Allokera fasta belopp per år",
    "granularity_yearly": "Årlig",
    "granularity_quarterly": "Kvartalsvis",
    "granularity_monthly": "Månadsvis",
    "granularity": "Granularitet",
    "leap_year_badge": "Skottår",
    "current_period_limit": "Allokera fast belopp ({amount} {unit}) för {periodLabel}",
    "apply_to_all_years": "Tillämpa på alla år",
    "apply_to_all_years_tooltip": "Kopiera dessa värden till alla andra år (delvisa kvartal hoppas över)",
    "reset_year": "Återställ",
    "partial_quarter_badge": "Delvis",
    "partial_period_badge": "Delvis",
    "contract_range_required_for_granularity": "Ange PPA start- och slutdatum i Utförandekonfiguration nedan för att konfigurera månads-/kvartalsgränser.",
    "start_date_required_for_granularity": "Startdatum krävs för månads- och kvartalsgränser.",
    "end_date_must_follow_start": "Kontraktets slutdatum måste vara samma som eller efter startdatumet.",
    "invalid_limit_durations_for_granularity": "Gränsernas varaktighet matchar inte vald granularitet. Skapa om gränserna eller konvertera dem till vald granularitet.",
    "partial_period_hint_single": "En period är partiell: {firstRange}.",
    "partial_period_hint_multiple": "{count} perioder är partiella: {firstRange} → {lastRange}.",
    "confirm_granularity_switch_title": "Ändra allokeringsgranularitet?",
    "confirm_granularity_switch_body": "Du har värden som inte är noll. Att byta kommer att omfördela dem till den nya granulariteten. Fortsätta?",
    "granularity_switch_title": "Omfördela befintliga värden?",
    "granularity_switch_body": "Du har angett värden på {from}-nivå. Om du byter till {to} omfördelas de för att matcha den nya granulariteten.",
    "granularity_switch_from": "Från",
    "granularity_switch_to": "Till",
    "granularity_buckets": "{count} fack/år",
    "granularity_switch_note": "Årssummor bevaras.",
    "granularity_switch_confirm": "Omfördela",
    "matrix_year_total": "Årssumma: {total}",
    "year_issues_badge": "{count} problem",
    "matrix_grand_total": "Totalt: {total} MWh ({count} poster)",
    "percentage_to_allocate": "Procentsats att allokera",
    "select_devices": "Välj enheter",
    "search_devices_placeholder": "Sök {count} tillgängliga enheter...",
    "search_more_devices_placeholder": "{selected} valda • Sök {available} tillgängliga enheter",
    "all_devices_selected": "Alla enheter valda",
    "devices_blocked_by_other_ppas": "Återstående anläggningar används av andra PPA-portföljer",
    "no_devices_available": "Inga enheter tillgängliga",
    "loading_devices": "Laddar enheter...",
    "selected_devices": "Valda enheter",
    "selected_devices_summary": "{count} valda",
    "add_devices": "Lägg till enheter",
    "allocate_percentage_display": "Allokera {percent}%",
    "devices_count_display": "{count} enhet(er) vald(a)",
    "from_all": "Från alla enheter",
    "no_instructions_set": "Inga instruktioner inställda.",
    "editing_title": "Redigerar: {name}",
    "upload_ppa_document": "Ladda upp PPA-dokument",
    "ppa_document_formats": "PDF, DOC, DOCX-filer stöds",
    "ppa_document_upload_error": "Ogiltigt PPA-dokumentformat",
    "fixed_amounts_per_year": "Fasta belopp per år",
    "period_limits": "Periodgränser",
    "add_period_limit": "Lägg till periodgräns",
    "remove_period_limit": "Ta bort periodgräns",
    "select_year": "Välj år",
    "mwh_placeholder": "Ange MWh-gräns",
    "fixed_amount_must_be_gt_zero": "Varje fast allokerad mängd måste vara större än 0 MWh",
    "update_success": "Portföljinstruktioner har uppdaterats framgångsrikt.",
    "update_success_title": "Framgång",
    "remove_device": "Ta bort enhet {deviceName}",
    "device_assigned_to_100_percent_ppa": "Enhet '{deviceId}' är tilldelad till 100% PPA och måste vara exklusivt tilldelad",
    "device_used_in_fixed_limit_ppa": "Enhet '{deviceId}' används i PPA med fasta periodgränser och kan inte tilldelas till någon annan PPA",
    "device_exceeds_100_percent": "Enhet '{deviceId}' överskrider 100% över PPA:er (totalt: {totalPercentage}%)",
    "device_cannot_mix_with_exclusive_mode": "Enhet '{deviceId}' kan inte användas i {currentMode} eftersom den redan är tilldelad till andra PPA:er",
    "fixed_amounts_mode": "fasta mängder-läge",
    "all_mode": "all produktion-läge"
  },
  "hold_strategy": {
    "customize_strategy_title": "Anpassa strategi för självhanterade certifikat",
    "about_hold_strategy": "Om strategin för självhanterade certifikat",
    "no_hold_instructions": "Ingen strategi för självhanterade certifikat konfigurerad",
    "create_hold_portfolio": "Skapa strategi för självhanterade certifikat",
    "hold_portfolio": "Självhanterade certifikat",
    "percentage_to_hold": "Procent att skicka till självhantering",
    "scope_all_label": "Global behållning (alla anläggningar)",
    "scope_all_description": "Gäller alla oallokerade certifikat.",
    "scope_specific_label": "Målinriktad behållning (specifika anläggningar)",
    "scope_specific_description": "Gäller endast valda anläggningar. Övriga går till spot.",
    "targeted_allocation_badge": "{percentage}% från {deviceCount} anläggningar"
  },
  "ppa_strategy": {
    "customize_strategy_title": "Anpassa PPA-reserv",
    "creating_new_ppa_instructions": "Skapar nya PPA-reservinstruktioner",
    "about_ppa_strategy": "Om PPA-reserv",
    "no_ppa_instructions": "Inga PPA-reservinstruktioner konfigurerade",
    "ppa_agreement": "PPA-avtal",
    "projected_total": "Prognostiserat totalt",
    "delivered": "Levererat",
    "no_documents": "Inga dokument bifogade",
    "fixed_yearly_allocation": "Fast årlig allokering",
    "percentage_allocation": "{percentage}% av produktionen",
    "next_delivery": "Nästa leverans"
  },
  "go_buy": {
    "volume_to_buy": "Volym att köpa",
    "procurement_fee": "Upphandlingsavgift",
    "purchase_summary": "Köpsammanfattning",
    "price_breakdown_title": "Prisuppdelning",
    "price_breakdown_description": "Priserna följer marknadens tredjepartsindex för att ge dig det bästa priset på marknaden. Volymer köps från över 3000 kraftverk i hela Europa. Aggregerad automatiserad inköp ger bästa värde.",
    "premiums": "Attributtillägg",
    "upload_description": "Ladda upp ett dokument som beskriver dina köpbehov",
    "ask_for_quote_button": "Begär offert",
    "send_purchase_request_button": "Skicka köpförfrågan",
    "purchase_request_submitted": "Köpförfrågan skickad",
    "purchase_request_submitted_detail": "{volume} MWh förfrågan skickad.",
    "agent_quote_prompt": "Skicka din inköpsbegäran så genomför Soldera en offertförfrågan (RFQ) — du får en indikativ offert, vanligtvis inom en arbetsdag",
    "modes": {
      "re100": "RE100",
      "cheapest": "Billigast",
      "advanced": "Avancerat",
      "re100_help": "RE100: vind + sol, COD ≤ 15 år, optimerat pris",
      "cheapest_help": "Billigast: optimerad för lägsta kostnad, samtidigt som den är kompatibel",
      "advanced_help": "Avancerat: anpassa alla attribut"
    },
    "form": {
      "volume": {
        "label": "Volym att köpa (MWh)"
      },
      "operation_notes": {
        "label": "Ytterligare anteckningar (valfritt)",
        "placeholder": "Ange eventuella specifika krav eller anteckningar för detta köp..."
      }
    },
    "certificate_scheme": "Certifikatsystem"
  },
  "issuance_reporting": {
    "upload_file": "Ladda upp fil",
    "export": "Exportera",
    "add_new": "@:common.add",
    "filters": {
      "period_start": "Från månad",
      "period_end": "Till månad",
      "all_devices": "Alla enheter",
      "all_statuses": "Alla statusar"
    },
    "status": {
      "pending": "@:common.pending",
      "accepted": "Accepterad",
      "rejected": "Avvisad",
      "completed": "Slutförd"
    },
    "table": {
      "device": "Enhet",
      "device_code": "Enhetskod",
      "total_production": "Total produktion",
      "date": "Datum",
      "actions": "Åtgärder"
    },
    "file_upload": {
      "import_summary": "Importerade poster: {imported}. Avvisade poster: {rejected}.",
      "rejected_records": "Avvisade poster",
      "rejected_record": "Post {index} · {device}",
      "country_label": "Land",
      "select_country": "Välj land",
      "title": "Ladda upp produktionsdatarapport",
      "description": "Vänligen ladda upp din produktionsdatarapport i tabellformat (Excel, CSV etc.)",
      "upload_prompt": "Dra och släpp din fil här eller klicka för att bläddra",
      "upload_another": "Ladda upp en annan fil",
      "supported_formats": "Stödda format: .xlsx, .xls, .csv. Stora Excel-filer kan behöva rensas från oanvända blad och formatering eller delas upp i mindre filer.",
      "analyzing": "Analyserar fil...",
      "countries": {
        "ES": {
          "label": "Spanien"
        },
        "PL": {
          "label": "Polen"
        }
      }
    },
    "no_data_for_period": "Inga data för perioden",
    "delete_record": "Radera post",
    "confirm_delete_record": "Är du säker på att du vill radera denna post? Denna åtgärd kan inte ångras.",
    "delete_success": "Posten raderades framgångsrikt",
    "update_success": "Produktionsdata uppdaterades framgångsrikt",
    "create_success": "Produktionsdatapost skapades framgångsrikt",
    "export_success": "Data exporterades framgångsrikt",
    "file_upload_success": "Filen har laddats upp. Skapade {created} poster av {total} bearbetade.",
    "no_data": "Ingen produktionsdata tillgänglig",
    "no_data_description": "Ladda upp produktionsdata för att komma igång med utfärdanderapportering.",
    "pl_status": {
      "title": "Status för utfärdandeprocessen",
      "production_data_received": "Produktionsdata mottagen",
      "waiting_for_quarterly_application_submission": "Kvartalsansökan väntar på inlämning",
      "application_submitted_to_tge_registry": "Ansökan inlämnad",
      "tge_registry_overdue_submission_deadline": "Kvartalsansökan är försenad",
      "goos_issued_successfully": "Ursprungsgarantier framgångsrikt utfärdade"
    },
    "pl_status_flags": {
      "application_fee_paid": "Ansökningsavgift betald",
      "application_fee_not_paid": "Ansökningsavgift ej betald",
      "communication_with_tge_initiated": "Uppföljning initierad",
      "automatic_written_notice": "Automatiskt skriftligt meddelande",
      "telephone_call": "Telefonsamtal"
    },
    "import_not_trusted": "Filimport är tillgänglig när ditt konto har aktiverats. Kontakta support@soldera.org för hjälp.",
    "company_required": "Välj ett företag för att visa utfärdanderapporter."
  },
  "links": {
    "trading_procedure": "https://www.soldera.org/compliance/trading-procedure",
    "trading_procedure_text": "Solderas handelsförfarande"
  },
  "company_orders": {
    "rfq_timeline": {
      "submitted": "Offertförfrågan (RFQ) inskickad",
      "quote_expected": "Indikativ offert väntas senast {date}",
      "approval_gate": "Inget köps förrän du godkänner offerten"
    },
    "title": "Transaktioner",
    "order_type": "Ordertyp",
    "portfolio": "Portfölj",
    "total_selected_mwh": "Volym",
    "order_starter": "Orderinitierare",
    "initiated_by": "Initierad av",
    "order_date": "Orderdatum",
    "date": "Datum",
    "export_csv": "Exportera order som CSV",
    "created": "Skapad",
    "updated": "Uppdaterad",
    "confirm_order": "Bekräfta order",
    "edit_order": "Redigera order",
    "edit_order_title": "Redigera företagets order",
    "edit_order_success": "Ordern uppdaterades.",
    "edit_order_error": "Det gick inte att uppdatera ordern.",
    "edit_order_load_error": "Det gick inte att ladda orderdetaljer för redigering.",
    "mwh_mismatch_warning": "Totalt antal MWh i annulleringsbeskeden ({statementsMwh}) matchar inte de valda portföljposterna ({portfolioMwh}). Justera MWh-värdena eller portföljvalet så att de överensstämmer.",
    "order_details": "Orderdetaljer",
    "order_information": "Orderinformation",
    "portfolio_items_summary": "Sammanfattning av portföljposter",
    "total_mwh": "Totalt MWh",
    "support_status": "Stödstatus",
    "associated_portfolio_items": "Associerade portföljposter",
    "no_portfolio_items": "Inga portföljposter är kopplade till denna order.",
    "processing_result": "Bearbetningsresultat",
    "order_type_details": "{type} orderdetaljer",
    "order_types": {
      "SEND": "@:common.actions.send",
      "RECEIVE": "Ta emot",
      "BUY": "Köp",
      "SELL": "Sälj",
      "CANCEL": "Annullera",
      "BUY_AND_CANCEL": "Köp och annullera"
    },
    "loading_portfolio_items": "Laddar portföljposter...",
    "view": "Visa",
    "confirm": "Bekräfta",
    "reject": "Avvisa",
    "confirm_all": "Bekräfta alla",
    "confirm_all_message": "Är du säker på att du vill bekräfta alla {count} väntande order? Behandlingen startar automatiskt.",
    "confirm_order_message": "Är du säker på att du vill bekräfta denna order? Behandlingen startar automatiskt.",
    "reject_all": "Avvisa alla",
    "batch_confirm_success": "Framgångsrikt bekräftade {count} order",
    "batch_confirm_partial": "Bekräftade {success} order, misslyckades {failed}",
    "batch_reject_success": "Framgångsrikt avvisade {count} order",
    "batch_reject_partial": "Avvisade {success} order, misslyckades {failed}",
    "status": {
      "waiting_confirmation": "Väntar på bekräftelse",
      "pending": "Väntar",
      "pending_agent": "Manuell hantering",
      "processing": "Bearbetas",
      "completed": "Slutförd",
      "failed": "Misslyckad",
      "cancelled": "Avbruten"
    },
    "send": {
      "recipient_information": "Mottagarinformation",
      "company_name": "Företagsnamn",
      "registry_country": "Registerland",
      "eecs_account_id": "EECS-konto-ID",
      "internal_account_id": "Registrets interna kontonummer",
      "unit_price_pln": "Enhetspris (PLN/MWh)",
      "operation_notes": "Övriga anteckningar",
      "portfolio_items_title": "Välj portföljartiklar att skicka"
    },
    "cancel": {
      "total_statements": "Totalt antal uttalanden",
      "total_mwh_cancelled": "Totalt annullerade MWh",
      "statement": "Uttalande",
      "address": "@:common.address",
      "period": "@:cancellation.table.period",
      "purpose": "Syfte"
    },
    "sell": {
      "sale_summary": "Förberedelse för försäljning",
      "hold_to_spot_description": "Denna order flyttar valda ursprungsgarantier från din självförvaltade portfölj till @:{'charts.values.portfolio_type.SPOT_MARKET_PRICE'}-portföljen för marknadsförsäljning.",
      "hold_to_min_price_description": "Denna order flyttar valda ursprungsgarantier från din självförvaltade portfölj till @:{'charts.values.portfolio_type.SPOT_MIN_PRICE'}-portföljen (minimipris €{minimumPrice}/MWh).",
      "process_information": "Processinformation",
      "source_portfolio": "Källportfölj",
      "destination_portfolio": "Målportfölj",
      "operation_type": "Operationstyp",
      "internal_portfolio_transfer": "Intern portföljöverföring"
    },
    "buy": {
      "purchase_summary": "Inköpssammanfattning",
      "volume": "Volym",
      "total_price": "Totalt pris",
      "go_specifications": "EAC-specifikationer",
      "eac_source": "EAC-källa",
      "technology": "Teknik",
      "ecolabel": "Miljömärkning",
      "vintage": "Produktionsår",
      "support": "Stöd",
      "operation_notes": "Övriga anteckningar",
      "purchase_mode": "Köpläge",
      "cod_requirement": "COD-krav",
      "matching": "Matchning",
      "order_summary": "Beställningssammanfattning",
      "total_price_per_mwh": "Totalpris per MWh",
      "uploaded_contract": "Uppladdad kontrakt",
      "contract": "Kontrakt"
    },
    "generic": {
      "no_additional_details": "Ingen ytterligare information finns tillgänglig."
    },
    "transactions": {
      "no_portfolio_items": "Inga portföljposter finns för ursprungsgarantierna i denna transaktion.",
      "transaction_type": "Transaktionstyp",
      "awaiting_confirmation": "{count} order väntar på bekräftelse | {count} order väntar på bekräftelse",
      "in_progress": "{count} pågår",
      "no_transactions": "Inga transaktioner att visa",
      "load_more": "Ladda fler",
      "more_transactions": "{count} fler transaktioner",
      "registry_transaction": "Registertransaktion",
      "registry_transactions": "Registertransaktioner",
      "not_yet_in_registry": "Ännu inte synlig i registret",
      "occurred": "Inträffade",
      "connection": "Registeranslutning",
      "volume": "Volym",
      "certificates": "Certifikat",
      "volume_in_registry": "Volym i registret",
      "certificates_in_registry": "Certifikat i registret",
      "counterparty": "Motpart",
      "counterparty_account": "Motpartens konto",
      "counterparty_eecs": "Motpartens EECS",
      "event_group": "Grupp av registertransaktioner",
      "events": "Registertransaktioner",
      "event_count": "Transaktioner",
      "from": "Från",
      "to": "Till",
      "total": "Totalt",
      "showing": "{shown} av {total}",
      "technology": "Teknik",
      "production_month": "Produktionsmånad",
      "production_device": "Produktionsanläggning",
      "production_device_count": "{count} anläggningar",
      "event_group_label": "{label} · {count}",
      "event_types": {
        "ISSUANCE": "Utfärdande",
        "INCOMING_TRANSFER": "Inkommande överföring",
        "OUTGOING_TRANSFER": "Utgående överföring",
        "CANCEL": "Annullering",
        "EXPIRY": "Utgång",
        "REVOCATION": "Återkallelse"
      },
      "event_row_types": {
        "ISSUANCE": "Registerutfärdande",
        "INCOMING_TRANSFER": "Inkommande registeröverföring",
        "OUTGOING_TRANSFER": "Utgående registeröverföring",
        "CANCEL": "Registerannullering",
        "EXPIRY": "Registerutgång",
        "REVOCATION": "Registeråterkallelse",
        "ALLOCATION": "Portföljallokering",
        "RETURN": "Portföljretur"
      },
      "event_group_types": {
        "ISSUANCE": "Registerutfärdanden",
        "INCOMING_TRANSFER": "Inkommande registeröverföringar",
        "OUTGOING_TRANSFER": "Utgående registeröverföringar",
        "CANCEL": "Registerannulleringar",
        "EXPIRY": "Registerutgångar",
        "REVOCATION": "Registeråterkallelser",
        "ALLOCATION": "Portföljallokeringar",
        "RETURN": "Portföljreturer"
      }
    }
  },
  "hosted_accounts": {
    "receive_new_gos_title": "Ta emot nya ursprungsgarantier",
    "receive_new_gos_description": "Ställ in en avsikt att ta emot ursprungsgarantier till ert Soldera-värdkonto. Vi använder detta för att matcha inkommande överföringar.",
    "select_country": "Välj land där du vill ta emot ursprungsgarantier",
    "select_country_placeholder": "Välj land...",
    "select_country_first": "Välj ett land för att fortsätta",
    "hosted_account": "Värdkonto",
    "account_details_heading": "Dela dessa uppgifter med avsändaren",
    "transfer_identification_heading": "Identifiera den inkommande överföringen",
    "description": "Lämna dessa Soldera-registeruppgifter till parten som skickar ursprungsgarantier, så att överföringen når rätt konto.",
    "company_name": "Företagsnamn",
    "eecs_account": "EECS-konto",
    "amount_mwh": "Mängd (MWh)",
    "sender_company_name": "Avsändarens företagsnamn",
    "sender_eecs_account": "Avsändarens EECS-konto",
    "counterparty_email": "Avsändarens e-post",
    "counterparty_email_hint": "Vi mejlar avsändaren kontouppgifterna att överföra till.",
    "counterparty_email_optional_hint": "Valfritt när en produktionsanläggning har angetts. Om det anges mejlar vi avsändaren kontouppgifterna att överföra till.",
    "optional_notes_on_email": "Anteckningar för aviseringsmail",
    "operation_notes_placeholder": "Lägg till särskilda instruktioner eller anteckningar...",
    "operation_notes_hint": "Visas för avsändaren i mejlet med överföringsinstruktioner och för Soldera-teamet.",
    "production_device_codes": "Koder för produktionsanläggningar",
    "production_device_codes_placeholder": "t.ex. 643XXXXXXXXXXXXXXX",
    "production_device_codes_hint": "Endast ursprungsgarantier från dessa anläggningar matchas mot den här ordern. Lämna mängden tom för att ta emot allt som anläggningarna levererar; med ett återkommande schema fortsätter ordern att göra det varje period. Separera flera koder med kommatecken.",
    "production_device_codes_too_many": "Ange högst {max} anläggningskoder",
    "production_device_code_too_long": "Varje anläggningskod får vara högst {max} tecken",
    "receive_order_created": "Mottagningsordern har skapats. Vi matchar inkommande överföringar mot den.",
    "receive_order_created_sender_notified": "Mottagningsordern har skapats. Vi har mejlat avsändaren överföringsinstruktionerna.",
    "create_receive_order": "Skapa mottagningsorder",
    "create_order": "Skapa mottagningsorder",
    "advanced_options": "Avancerade alternativ",
    "company_name_copied": "Företagsnamn kopierat till urklipp!",
    "eecs_account_copied": "EECS-konto kopierat till urklipp!",
    "copy_fallback": "Kopierat till urklipp (reservmetod)",
    "copy_failed": "Kopieringen misslyckades. Kopiera manuellt.",
    "no_regions_unlocked": "Inga värdkonton är ännu konfigurerade för er organisation.",
    "contact_us_cta": "Kontakta oss",
    "contact_us_title": "Behöver du ta emot i ett annat land?",
    "contact_us_title_no_accounts": "Redo att ta emot ursprungsgarantier?",
    "contact_us_description": "Kontakta oss för att köpa fler värdkonton.",
    "contact_us_description_no_accounts": "Kontakta oss för att konfigurera ditt första värdkonto.",
    "contact_us_button": "Kontakta oss",
    "no_accounts_configured": "Inga värdkonton är konfigurerade. Kontakta oss för att komma igång.",
    "company_id_missing": "Företags-ID saknas"
  },
  "receive_order": {
    "repeating_label": "Återkommande schema",
    "repeating_options": {
      "none": "Engångs",
      "monthly": "Månadsvis",
      "quarterly": "Kvartalsvis",
      "half_yearly": "Halvårsvis",
      "yearly": "Årsvis"
    },
    "at_least_one_required": "Fyll i minst ett av dessa fält för att hjälpa oss matcha överföringen"
  },
  "portfolios": {
    "title": "Portföljer",
    "description": "Visa och hantera alla dina portföljfördelningar. Byt namn, dela, slå samman eller flytta objekt mellan portföljer.",
    "show_items": "Inga objekt | Visa 1 objekt | Visa {count} objekt",
    "merge": "Sammanfoga",
    "split": "Dela",
    "merge_modal_title": "Sammanfoga portföljer",
    "source_portfolio": "Källportfölj",
    "target_portfolio": "Målportfölj",
    "select_target_placeholder": "Välj målportfölj...",
    "merge_confirm_warning": "Alla objekt från {source} kommer att flyttas till {target}. Källportföljen kommer att raderas permanent.",
    "merge_info": "Välj en målportfölj för att se sammanfogningsdetaljerna. Källportföljen kommer att raderas efter sammanfogning.",
    "volume_and_items": "{volume} MWh • {count} objekt",
    "split_modal_title": "Dela portfölj",
    "split_select_items": "Välj certifikat att flytta",
    "split_new_name_label": "Namn på ny portfölj",
    "split_new_name_placeholder": "t.ex. Parti B",
    "split_default_name": "Delad från {name} den {date}",
    "items_selected": "Inga objekt valda | 1 objekt valt | {count} objekt valda",
    "confirm_merge": "Bekräfta sammanfogning",
    "confirm_split": "Bekräfta delning",
    "section_inventory": "Lager",
    "section_inventory_desc": "UG tillgängliga för åtgärder som skicka, annullera med mera.",
    "section_spot": "Spotförsäljning",
    "section_spot_desc": "UG i kö för försäljning på spotmarknaden.",
    "section_ppa": "PPA",
    "section_ppa_desc": "Reserverat för framtida åtaganden.",
    "section_forwards": "Terminsaffärer",
    "section_forwards_desc": "Reserverat för terminsförsäljning.",
    "volume_label_inventory": "Tillgängligt",
    "volume_label_spot": "I kö för försäljning",
    "volume_label_ppa": "Reserverat",
    "volume_label_forwards": "Reserverat",
    "badge_own_registry": "Anslutet",
    "badge_soldera_account": "Värd",
    "badge_spot_market": "Marknadspris",
    "badge_spot_min": "Min {price} EUR",
    "badge_spot_min_default": "Minimipris",
    "badge_stx": "STX",
    "badge_ppa": "PPA",
    "badge_forward": "Terminsaffär",
    "badge_default": "Standard",
    "tooltip_own_registry": "Ursprungsgarantier på företagets anslutna EECS-registerkonto",
    "tooltip_soldera_account": "Ursprungsgarantier på Solderas värdkonto på företagets vägnar",
    "tooltip_spot_market": "Sålt till aktuellt marknadspris",
    "tooltip_spot_min": "Säljs bara när marknadspriset når minimigränsen",
    "tooltip_default": "Standardportfölj för allokering. Kan inte slås ihop.",
    "view_ppa_config": "Konfigurera",
    "view_forwards": "Visa terminsaffärer",
    "move_items": "Flytta",
    "move_modal_title": "Flytta objekt",
    "move_modal_desc": "Välj en målportfölj och markera de objekt du vill flytta.",
    "move_target": "Målportfölj",
    "select_move_target": "Välj mål...",
    "confirm_move": "Bekräfta flytt",
    "no_portfolios": "Inga portföljer hittades för denna sektion.",
    "empty_inventory": "Inga UG i lagret för närvarande. UG visas här efter mottagning eller köp.",
    "empty_portfolio": "Denna portfölj har inga objekt.",
    "show_empty": "Visa {count} tomma portföljer",
    "hide_empty": "Dölj tomma portföljer",
    "badge_own_use": "Ej handelsbar",
    "tooltip_own_use": "Ursprungsgarantier som i registret är märkta för egen användning. De kan inte säljas, överföras eller annulleras."
  },
  "production_strategy": {
    "title": "Produktionsstrategi",
    "overview": "Översikt",
    "ppa_settings": "PPA-inställningar",
    "self_managed_settings": "Självförvaltade inställningar",
    "spot_settings": "Spotförsäljningsinställningar",
    "issuance_report": "Utfärdanderapport",
    "forward_commitments": "Terminsåtaganden",
    "whole_year": "Nästa 12 månader",
    "from_this_month_onward": "Från denna månad och framåt",
    "bulk_issuance_report": "TSO-deklaration Excel",
    "generating_report": "Genererar...",
    "generating_report_progress": "Genererar... {current}/{total}",
    "report_duration_hint": "Varje företag hämtas från registret i tur och ordning, så detta kan ta en stund. Du kan lämna sidan och komma tillbaka senare.",
    "download_report": "Ladda ner rapport",
    "generate_new_report": "Generera ny",
    "report_generated_at": "Genererad {time}",
    "report_failed": "Misslyckades - Klicka för att försöka igen",
    "bulk_issuance": {
      "button_text": "Utfärda alla ursprungsgarantier",
      "title": "Utfärda alla ursprungsgarantier",
      "description": "Välj produktionsperiod och företag för utfärdande:",
      "production_period": "Produktionsperiod",
      "period_error": "Startmånad måste vara före eller lika med slutmånad",
      "companies_label": "@:common.companies",
      "no_companies": "Inga HKNR-företag hittades för detta konto.",
      "confirm_all": "Bekräfta alla deklarationer",
      "confirm_title": "Bekräfta massutfärdande",
      "confirm_message": "Utfärdar ursprungsgarantier för {count} företag. Om ett företag saknar anläggningar kommer det att hoppas över.\n\n\"Proof of origin/Herkunftsnachweis\"-texten lämnas tom i formuläret.\n\"Subsidy for electricity generation/Förderung der Stromerzeugung\" lämnas som det är i formuläret.\n\nÄr du säker på att du vill fortsätta?",
      "cancel_title": "Avbryt massutfärdande",
      "cancel_message": "Är du säker på att du vill avbryta? Certifikat som redan utfärdats kan inte återkallas.",
      "already_processed": "Redan bearbetade företag:",
      "in_progress": "Pågår",
      "status": {
        "pending": "@:common.pending",
        "in_progress": "Bearbetar...",
        "completed": "{count} anläggning(ar) skickade",
        "skipped": "Hoppades över (inget att utfärda)",
        "error": "Fel"
      }
    },
    "next_year": "Nästa år",
    "yearly_allocations": "Årliga allokeringar",
    "production_allocations": "Produktionsallokeringar",
    "company_production": "Företagets produktion",
    "show_all_companies": "Visa alla företag",
    "not_available_consolidated": "Inte tillgängligt i konsoliderad vy",
    "ppa": "PPA",
    "agreements": "avtal",
    "ppa_agreements": "PPA-avtal",
    "documents": "@:common.documents",
    "display_name": "Visningsnamn",
    "no_display_name": "Inget visningsnamn tillgängligt",
    "display_name_help": "Autogenererat från transaktionsdetaljer",
    "action_instructions": "Åtgärdsinstruktioner",
    "execution_configuration": "Utförandekonfiguration",
    "delivery_method": "Leveranssätt",
    "automatic": "Utför automatiskt",
    "manual": "Be om bekräftelse",
    "automatic_explainer": "systemet utför transaktionen automatiskt på det schemalagda datumet — inget manuellt godkännande behövs.",
    "manual_explainer": "vid den schemalagda utförandetiden skapar systemet en företagsorder som måste godkännas manuellt innan utförande.",
    "execution_method": "Utförandemetod",
    "execution_method_aria": "Utförandemetod",
    "delivery_method_aria": "Leveransmetod",
    "delivery_timing": "Leveransfrekvens",
    "execution_timing": "Utförandefrekvens",
    "yearly": "En gång per år",
    "half_year": "Halvårsvis",
    "quarterly": "Kvartalsvis",
    "monthly": "Månadsvis",
    "fixed_dates": "Fasta datum",
    "fixed_dates_count": "{count} fasta datum",
    "fixed_delivery_dates": "Fasta leveransdatum",
    "add_date": "Lägg till datum",
    "end_date": "Slutdatum",
    "ppa_contract_end_date": "PPA-avtalets slutdatum",
    "end_date_help": "När PPA-avtalet slutar",
    "ppa_contract_start_date": "PPA-avtalets startdatum",
    "start_date_help": "När PPA-avtalet börjar (krävs för månads-/kvartalsgränser)",
    "transaction_type": "Transaktionstyp",
    "send": "Skicka",
    "cancel": "@:common.cancel",
    "send_help": "Överför GO till mottagare",
    "cancel_help": "Makulerar GO till förmån för mottagaren",
    "send_details": "Skickningsdetaljer",
    "cancel_details": "Makuleringsdetaljer",
    "notes": "Anteckningar",
    "notes_placeholder": "Valfria anteckningar för denna PPA",
    "analyze_files": "Analysera filer",
    "counterparty_details": "Motpartsdetaljer",
    "transaction_type_aria": "Transaktionstyp",
    "q4_production_execution_date": "Q4 utförandedatum:",
    "q1_production_execution_date": "Q1 utförandedatum:",
    "q2_production_execution_date": "Q2 utförandedatum:",
    "q3_production_execution_date": "Q3 utförandedatum:",
    "h1_production_delivery_date": "H1 produktionsleveransdatum:",
    "h2_production_delivery_date": "H2 produktionsleveransdatum:",
    "h3_production_delivery_date": "H3 produktionsleveransdatum:",
    "h4_production_delivery_date": "H4 produktionsleveransdatum:",
    "allocation_mode_aria": "Allokeringsläge",
    "remove_recurring_date": "Ta bort återkommande datum",
    "yearly_delivery_day": "Datum 1 (Årlig leverans)",
    "half_year_delivery_days": "Halvårsleveransdatum",
    "quarterly_delivery_days": "Kvartalsvisa leveransdatum",
    "monthly_delivery_day": "Månatlig leveransdag",
    "last_day_of_month": "Sista dagen",
    "recurring_delivery_dates": "Återkommande leveransdatum",
    "recurring_execution_dates": "Återkommande utförandedatum",
    "recurring_dates_description": "Välj dag+månads-kombinationer som upprepas varje år till PPA:s slutdatum",
    "recurring_dates_description_monthly": "Välj vilken dag varje månad då utförandet ska ske.",
    "recurring_dates_description_quarterly": "Ange utförandedatum för varje kvartal (visas i operativ ordning).",
    "recurring_dates_description_half_year": "Välj utförandedatum för första och andra halvåret.",
    "recurring_dates_description_yearly": "Välj det årliga utförandedatumet.",
    "recurring_dates_description_fixed_dates": "Lägg till utförandedatum som upprepas i turordning genom avtalet.",
    "add_recurring_date": "Lägg till återkommande datum",
    "first_half": "Datum 1 - Första halvåret",
    "second_half": "Datum 2 - Andra halvåret",
    "date_1_q1": "Datum 1 - Q1",
    "date_2_q2": "Datum 2 - Q2",
    "date_3_q3": "Datum 3 - Q3",
    "date_4_q4": "Datum 4 - Q4",
    "quarter_range_q1": "(Jan-Mar)",
    "quarter_range_q2": "(Apr-Jun)",
    "quarter_range_q3": "(Jul-Sep)",
    "quarter_range_q4": "(Okt-Dec)",
    "thinking": "Tänker ...",
    "forward_sales": "Terminsförsäljning",
    "forward_sales_overview": {
      "title": "Översikt över terminsförsäljning"
    },
    "forward_mandates_list": {
      "title": "Dina aktiva terminsförsäljningsmandat",
      "empty": "Dina bolag ingår inte i något aktivt terminsförsäljningsmandat.",
      "load_failed": "Dina terminsförsäljningsmandat kunde inte läsas in."
    },
    "forward_materials": {
      "description": "Solderas terminsförsäljning är utformad för att hjälpa er att säkra förutsägbara intäkter och minska risker för prisfluktuationer, utan att ni behöver sköta den dagliga hanteringen av er terminsförsäljning.",
      "outlook_info_1": "Lär dig om marknadstrender och se hur priserna har utvecklats historiskt.",
      "outlook_info_2": "Förstå hur Solderas terminsförsäljning kan hjälpa dig att säkra intäkter.",
      "strategy_title": "Soldera terminsförsäljning Handelsstrategi",
      "strategy_info": "Få information om hur vi gör terminsförsäljning för din räkning.",
      "framework_title": "Ramverk för terminsförsäljning",
      "framework_info": "Granska de juridiska villkoren för alla terminsförsäljningar som görs genom Soldera."
    },
    "of_projected_production_per_quarter": "av beräknad produktion per kvartal",
    "hedged": "Säkrad",
    "already_committed": "Redan åtagen",
    "for_upcoming_sales": "För kommande försäljningar",
    "self_managed_certificates": "Självförvaltade certifikat",
    "self_manage": "Självförvalta",
    "allocation": "Allokering",
    "allocated": "Allokerad",
    "spot_sale": "Spotförsäljning",
    "sell_at_highest_bid": "Sälj till högsta bud",
    "reserved_for_ppas": "Reserverad för PPA:er",
    "hedged_for_forward_sales": "Säkrad för terminsförsäljning",
    "committed_forward": "Åtagit forward",
    "forward_estimate": "uppskattning",
    "forward_estimate_note": "Uppskattad andel av ett delat mandat",
    "to_be_sold": "Att sälja",
    "to_be_sold_description": "Utbjuden terminsvolym som ännu inte sålts, placerad i de månader där produktion återstår efter befintliga åtaganden.",
    "sell_all_remaining_spot": "Sälj allt återstående via Spot",
    "ppa_allocation_card": "PPA-allokeringskort",
    "forward_allocation_card": "Terminsförsäljningsallokeringskort",
    "self_managed_allocation_card": "Självförvaltade certifikat allokeringskort",
    "spot_allocation_card": "Spotförsäljningsallokeringskort",
    "wizard_step_action": "Åtgärd",
    "wizard_step_allocation": "@:production_strategy.allocation",
    "wizard_step_execution": "Körning & granskning",
    "wizard_step_1_hint": "Släpp ett avtal för att autofylla, eller fortsätt manuellt",
    "show_all_as_one_form": "Visa allt som ett formulär",
    "new_ppa_portfolio": "Ny PPA-portfölj",
    "edit_ppa_portfolio": "Redigera PPA-portfölj",
    "ppa_modal_crumb": "Produktionsstrategi · PPA",
    "step_x_of_y": "Steg {current} av {total}",
    "save_ppa": "Spara PPA",
    "prefill_from_document": "Förifyll från dokument",
    "portfolio_name_title": "Portföljnamn",
    "portfolio_name_desc": "Hur det här PPA visas i dina instrumentpaneler.",
    "contract_dates_title": "Avtalsdatum",
    "contract_dates_desc": "När PPA-avtalet börjar och slutar.",
    "action_title": "Åtgärd",
    "action_desc": "Vad som ska hända med GO från detta PPA.",
    "allocation_title": "@:production_strategy.allocation",
    "allocation_desc": "Hur mycket produktion som täcks.",
    "devices_title": "Enheter",
    "devices_desc": "Vilka anläggningar som levererar energin.",
    "execution_title": "Körning",
    "execution_desc": "När och hur transaktioner körs.",
    "review_title": "Granska",
    "review_desc": "Vad som händer när du sparar.",
    "notes_title": "Anteckningar",
    "notes_desc": "Lägg till intern kontext för detta PPA.",
    "upload_ppa_to_auto_fill": "Ladda upp ett PPA-dokument för autofyll",
    "upload_ppa_auto_fill_subtitle": "Släpp en PDF, DOC eller DOCX — vi extraherar vad vi kan. Allt kan redigeras efteråt.",
    "or_skip_and_continue": "eller hoppa över och fortsätt nedan",
    "what_is_this_ppa_for": "Vad är detta PPA till för?",
    "send_certificates": "Skicka certifikat",
    "cancel_on_behalf": "Avsluta för någons räkning",
    "send_label": "@:common.actions.send",
    "send_explainer": "överför certifikaten till motpartens registerkonto — de tar emot dem och kan använda eller avsluta dem själva.",
    "cancel_on_behalf_label": "Avsluta för någons räkning",
    "cancel_on_behalf_explainer": "avslutar certifikaten för motpartens räkning — inget överförs; certifikaten förbrukas i deras namn.",
    "not_set": "Ej satt",
    "no_devices_selected": "Inga enheter valda",
    "review_cancel_for": "Avslutat för {name}",
    "review_cancel_generic": "Avsluta för någons räkning",
    "review_n_periods": "{count} perioder",
    "review_devices_summary": "{count} valda · {mw} MW",
    "review_counterparty_label": "Motpart",
    "review_allocation_label": "@:production_strategy.allocation",
    "review_devices_label": "Enheter",
    "review_execution_label": "Körning",
    "automatic_short": "Automatisk",
    "manual_short": "Manuell"
  },
  "ecolabels": {
    "documents_modal": {
      "title": "Dokument — {name}",
      "open_hint": "Visa och ladda ner de ursprungligen uppladdade dokumenten",
      "empty": "Inga dokument synliga för dig för denna anläggning.",
      "download": "Ladda ner"
    },
    "fuzzy_search_placeholder": "Sök anläggningar efter namn, registrerings-ID eller adress…",
    "renewable_types": {
      "solar": "Sol",
      "wind": "Vind",
      "hydro": "Vatten",
      "geothermal": "Geotermisk",
      "bioenergy": "Bioenergi",
      "marine": "Marin energi",
      "other": "Övrigt"
    },
    "statuses": {
      "pending_review": "Väntar på granskning",
      "pre_approved": "Förhandsgodkänd",
      "rejected": "Avvisad",
      "approved": "Godkänd",
      "not_approved": "Ej godkänd"
    },
    "upload": {
      "add_manually": "Lägg till anläggning manuellt",
      "pending_hint": "Stora filer kan ta några minuter — du kan fortsätta redigera raderna under tiden.",
      "wait_for_ai": "Vänta tills assistenten är klar innan du skickar in",
      "duplicate_of_row_named": "Rad {row} (”{name}”) i denna uppladdning",
      "open_in_catalog": "Öppna i katalogen",
      "back_to_catalog": "Tillbaka till anläggningskatalogen",
      "title": "Skicka in anläggningar för förhandsgodkännande",
      "subtitle": "Ladda upp en anläggningslista (kalkylblad, registerutdrag, e-post eller PDF) och granska raderna innan du skickar in.",
      "seller_company": "Säljarföretag",
      "no_seller_company": "Inget auktoriserat säljarföretag är kopplat till ditt konto. Kontakta EKOenergy för åtkomst.",
      "chat_title": "Ladda upp din anläggningslista",
      "review_title": "Granska extraherade anläggningar",
      "review_counts": "{total} rader, {selected} valda",
      "select_all": "Markera alla",
      "select_all_without_duplicates": "Markera alla utan dubbletter",
      "check_and_next": "Markera och nästa",
      "irec_relaxed_hint": "Identifierad som en I-REC-anläggning via Evident-länk / anläggningskod. Teknik och plats är valfria här — granskarna verifierar dem i Evident.",
      "irec_lookup_loading": "Slår upp anläggningen i Evidents anläggningsregister…",
      "irec_lookup_found": "Anläggningens uppgifter fylldes i från Evidents anläggningsregister — kontrollera dem och ändra vid behov. Teknik och plats är valfria här; granskarna verifierar dem i Evident.",
      "irec_lookup_not_found": "Koden hittades inte i Evidents anläggningsregister. Fyll i anläggningens namn och land själv; teknik och plats förblir valfria.",
      "irec_lookup_unavailable": "Evidents anläggningsregister kunde inte nås. Fyll i anläggningens namn och land själv; teknik och plats förblir valfria.",
      "deselect_all": "Avmarkera alla",
      "empty_state": "Anläggningar som extraherats från din uppladdning visas här för granskning.",
      "flags": "Kontroller",
      "flag_ok": "OK",
      "flag_incomplete": "Fält saknas",
      "all_fields": "Alla fält",
      "flag_duplicate": "{count} dubblett?",
      "flag_duplicate_hint": "Möjliga dubbletter hittades — klicka för att se träffarna",
      "flag_reg_id": "ID: {quality}",
      "flag_reg_id_hint": "Registrerings-ID:t kunde inte valideras mot kända registerformat",
      "blocked_row_hint": "Fyll i de obligatoriska fälten som saknas för att aktivera raden",
      "blocked_rows_note": "{count} rad(er) blockerade av saknade obligatoriska fält",
      "field_address_or_coordinates": "Adress eller koordinater",
      "missing_fields": "Saknas: {fields}",
      "duplicate_details": "Möjliga dubbletter",
      "duplicate_what_to_do": "Om det verkligen är olika anläggningar, skicka bara in — granskarna ser samma flaggor. Om en rad verkligen är en dubblett, ta bort en av dem (✕).",
      "show_row": "Visa rad",
      "duplicate_of_catalog": "Befintlig anläggning “{name}” ({status})",
      "duplicate_of_row": "Rad {row} i denna uppladdning",
      "submit_selected": "Skicka in {count} anläggning(ar) för granskning",
      "submitted_title": "{count} anläggning(ar) inskickade för granskning",
      "submitted_flagged": "{count} möjliga dubblettpar flaggades för granskarna.",
      "view_submissions": "Visa inskick",
      "upload_more": "Ladda upp fler"
    },
    "submissions": {
      "collapse_all": "Fäll ihop alla",
      "title": "Inskick",
      "subtitle_admin": "Granska inskickade anläggningar: kontrollera flaggor, godkänn eller avvisa sedan.",
      "subtitle_seller": "Dina inskickade anläggningspartier och deras granskningsstatus.",
      "submit_devices": "Skicka in anläggningar",
      "empty": "Inga inskickade anläggningar ännu.",
      "submitted_on": "Inskickat",
      "seller": "Säljare",
      "devices": "Anläggningar",
      "status": "Status",
      "pending_badge": "{count} väntar",
      "approved_badge": "{count} godkända",
      "rejected_badge": "{count} avvisade",
      "flagged_badge": "{count} flaggade",
      "duplicates_column": "Dubbletter",
      "details": "Detaljer",
      "duplicates_badge": "{count} möjliga",
      "duplicates_hint": "Möjliga dubbletter — klicka för att granska och lösa",
      "actions": "Åtgärder",
      "approve": "Godkänn",
      "reject": "Avvisa",
      "rejection_reason_placeholder": "Avvisningsorsak (synlig för säljaren)…",
      "no_duplicates": "Inga olösta dubblettkandidater för denna anläggning.",
      "approved_toast": "{name} godkänd",
      "override_confirm": "Denna anläggning har olösta dubbletter med hög säkerhet. Godkänn ändå?",
      "approve_anyway": "Godkänn ändå",
      "filter_pending": "Behöver granskas",
      "filter_all": "Alla",
      "no_pending": "Inga inlämningar väntar på granskning.",
      "show_all": "Visa alla inlämningar",
      "merged_badge": "{count} sammanslagna",
      "internal_notes": "Interna anteckningar",
      "internal_notes_hint": "Syns endast för EKOenergy-teamet — säljare ser dem aldrig.",
      "note_placeholder": "Lägg till en anteckning för teamet…",
      "add_note": "Lägg till",
      "save_changes": "Spara ändringar",
      "device_saved": "Anläggningen uppdaterad",
      "invalid_number_fields": "Latitud, longitud eller kapacitet är inte ett giltigt tal. Inget sparades."
    },
    "duplicates": {
      "title": "Dubbletter",
      "subtitle": "{pending} kandidatpar väntar på granskning. Besluten är permanenta.",
      "filter_pending": "Väntar",
      "scan": "Sök efter dubbletter",
      "scan_started": "Dubblettsökning startad — nya par visas snart.",
      "empty": "Inga dubblettkandidater i denna vy. Snyggt och rent!",
      "load_more": "Visa fler ({shown} av {total})",
      "device_a": "Anläggning A",
      "device_b": "Anläggning B",
      "this_submission": "Denna inlämning",
      "existing_device": "Befintlig katalogenhet",
      "newer_entry": "Nyare post",
      "older_entry": "Äldre post",
      "coordinates": "Koordinater",
      "not_duplicate": "Inte en dubblett",
      "keep_a": "Slå ihop, behåll A",
      "keep_b": "Slå ihop, behåll B",
      "merge_confirm": "Slå ihop paret och behåll “{name}”? Den andra posten arkiveras och dess dokument flyttas över.",
      "confirm_merge": "Bekräfta ihopslagning",
      "resolved_toast": "Par löst",
      "ask_ai": "Fråga AI",
      "ai": {
        "duplicate": "AI: dubblett",
        "not_duplicate": "AI: inte dubblett",
        "unsure": "AI: osäker"
      },
      "statuses": {
        "not_duplicate": "Inte en dubblett",
        "merged": "Ihopslagen"
      },
      "reasons": {
        "registration_id_exact": "Samma registrerings-ID",
        "registration_id_overlap": "Registrerings-ID överlappar",
        "registration_id_suspect_overlap": "ID överlappar (låg tillit)",
        "name_exact": "Samma namn",
        "name_exact_distinct_ids": "Samma namn, olika register-ID",
        "name_fuzzy": "Liknande namn {detail}",
        "coords_within_250m": "Inom 250 m"
      }
    },
    "title": "Miljömärkningar",
    "description": "Hantera förnybara energianläggningar som är certifierade med miljömärkning",
    "add_device": "Lägg till anläggning",
    "edit_device": "Redigera anläggning",
    "ai_upload": "AI-uppladdning",
    "devices_selected": "anläggningar valda",
    "bulk_delete": "Ta bort valda",
    "export_csv": "Exportera CSV",
    "no_access_title": "Ingen åtkomst till EKOenergy-registret",
    "no_access_contact": "Kontakta {0} för åtkomst.",
    "no_devices": "Inga miljömärkta anläggningar hittades. Lägg till din första anläggning för att komma igång.",
    "showing_count": "Visar {filtered} av {total} anläggningar",
    "total_count": "{total} anläggningar",
    "devices_heading": "Miljömärkta anläggningar",
    "device_saved": "Anläggningen har sparats",
    "device_deleted": "Anläggningen har tagits bort",
    "devices_created": "Anläggningarna har skapats",
    "confirm_delete": "Är du säker på att du vill ta bort {name}?",
    "confirm_bulk_delete": "Är du säker på att du vill ta bort {count} anläggningar?",
    "bulk_deleted": "{count} anläggningar har tagits bort",
    "columns_selected": "{count} kolumner",
    "select_columns": "Kolumner",
    "add_devices": "Lägg till anläggningar",
    "add_devices_description": "Ladda upp ett dokument för AI-baserad autofyllning eller lägg till anläggningar manuellt nedan.",
    "save_devices": "Spara alla anläggningar",
    "add_row": "Lägg till rad",
    "no_rows": "Inga anläggningar har lagts till ännu. Ladda upp ett dokument eller lägg till rader manuellt.",
    "devices_saved": "{count} anläggningar har sparats",
    "filters": {
      "standard": "Standard",
      "status": "Status",
      "country": "Land",
      "search": "Sök",
      "search_placeholder": "Sök efter namn...",
      "capacity_placeholder": "t.ex. 50",
      "cod_placeholder": "t.ex. 2020"
    },
    "table": {
      "name": "@:common.name",
      "plant_ecolabel_id": "Registrerings-ID",
      "standard": "Standard",
      "status": "Status",
      "country": "Land",
      "address": "@:common.address",
      "type": "Typ",
      "renewable_type": "Teknik",
      "latitude": "Latitud",
      "longitude": "Longitud",
      "capacity": "Kapacitet",
      "cod": "COD",
      "date_reviewed": "Granskningsdatum",
      "valid_from": "Godkänd från",
      "valid_through": "Godkännande giltigt till",
      "registration_authority": "Register",
      "technology_code": "Teknikkod",
      "public_notes": "Anteckningar",
      "relevant_link": "Länk",
      "link": "Länk",
      "documents": "@:common.documents",
      "actions": "@:common.actions.title"
    },
    "form": {
      "status": "Status",
      "name": "Anläggningsnamn",
      "plant_id": "Anläggningens miljömärknings-ID",
      "country": "Landskod",
      "address": "@:common.address",
      "latitude": "@:ecolabels.table.latitude",
      "longitude": "@:ecolabels.table.longitude",
      "renewable_type": "Typ av förnybar energi",
      "marine": "Marin energi",
      "nuclear": "Kärnkraft",
      "technology_code": "Teknikkod",
      "technology_code_placeholder": "t.ex. T010000",
      "registration_authority": "Registreringsmyndighet",
      "relevant_link": "Relevant länk",
      "capacity": "Kapacitet",
      "capacity_units": "Enheter",
      "cod": "Datum för kommersiell driftstart",
      "public_notes": "Offentliga anteckningar",
      "rejection_reason": "Avvisningsorsak",
      "location_hint": "Antingen adress eller koordinater krävs.",
      "errors": {
        "name_required": "Namn är obligatoriskt.",
        "country_required": "Land är obligatoriskt.",
        "renewable_type_required": "Typ av förnybar energi är obligatorisk.",
        "latitude_range": "Latitud måste vara ett tal mellan -90 och 90.",
        "longitude_range": "Longitud måste vara ett tal mellan -180 och 180.",
        "capacity_invalid": "Kapacitet måste vara ett tal.",
        "location_required": "Ange antingen en adress eller koordinater (latitud och longitud).",
        "registration_authority_required": "Registreringsmyndighet är obligatorisk när ett registrerings-ID anges.",
        "rejection_reason_required": "En avvisningsorsak krävs när statusen är Avvisad."
      },
      "registry_device_id": "Register-ID för anläggning",
      "date_reviewed": "Granskningsdatum",
      "valid_from": "Godkänd från",
      "valid_through": "Godkännande giltigt till"
    },
    "ai_autofill": "AI-autofyllning från dokument",
    "autofill_btn": "Autofyll",
    "autofill_confidence": "Säkerhet: {value}%",
    "upload_wizard": {
      "title": "Ladda upp annulleringsintyg",
      "ekoenergy_logo_alt": "EKOenergy-logotyp",
      "no_authorized_seller_title": "Bli en auktoriserad EKOenergy-säljare",
      "no_authorized_seller_description": "Uppladdning av annulleringsintyg kräver minst ett auktoriserat säljföretag.",
      "no_authorized_seller_cta": "Besök EKOenergy",
      "step1_label": "Uppladdning",
      "step2_label": "Annulleringsdetaljer",
      "step1_title": "Ladda upp annulleringsdokument",
      "step1_description": "Ladda upp ett annulleringsintyg. Vår AI analyserar det och matchar det mot registrerade miljömärkta anläggningar.",
      "cancellation_source": "Annulleringskälla",
      "upload_new_statement": "Ladda upp ett nytt annulleringsintyg",
      "using_existing_cancellation": "En befintlig annullering används. Filuppladdning och fält för intygsdetaljer är dolda.",
      "step2_title": "Granska och tilldela anläggningar",
      "step2_description": "Granska de AI-matchade anläggningarna, lägg till eller ta bort anläggningar manuellt och justera MWh-fördelningen.",
      "drop_file": "Släpp filen här eller klicka för att bläddra",
      "seller_company": "Säljföretag",
      "new_company_placeholder": "Nytt företagsnamn",
      "new_company_email_placeholder": "Ägarens e-post",
      "company_created": "Auktoriserat säljföretag skapat",
      "ai_matching_failed_warning": "AI-matchningen misslyckades för denna uppladdning. Intyget sparades, men fält/anläggningar fylldes inte i automatiskt.",
      "upload_and_match": "Ladda upp och matcha anläggningar",
      "analyze": "Analysera dokument",
      "analyzing": "Dokumentet analyseras med AI...",
      "ai_applied": "AI-analysen har tillämpats. Granska och justera de förifyllda fälten nedan.",
      "ai_found_matches": "AI hittade {count} matchande anläggning(ar) i ditt intyg.",
      "matching_devices": "Söker efter matchande miljömärkta anläggningar...",
      "no_matches": "Inga matchande anläggningar hittades automatiskt. Du kan tilldela anläggningar manuellt nedan.",
      "assigned_devices": "Tilldelade anläggningar",
      "add_device_manually": "Lägg till anläggning",
      "no_devices_assigned": "Inga anläggningar har tilldelats ännu. Lägg till anläggningar manuellt eller ladda upp intyget igen.",
      "select_device": "Välj en anläggning",
      "search_devices": "Sök efter namn eller land...",
      "no_devices_found": "Inga matchande anläggningar hittades.",
      "save_and_submit": "Spara och skicka",
      "beneficiary_name": "Mottagarens namn",
      "registry_code": "Registerkod",
      "country_region": "Land/region",
      "period_start": "Periodstart",
      "period_end": "Periodslut",
      "mwh_cancelled": "Annullerade MWh",
      "purpose": "Syfte med annulleringen",
      "notes": "Anteckningar",
      "confirm_proceed": "Bekräfta och matcha anläggningar",
      "mwh": "@:common.mwh",
      "confidence": "Säkerhet",
      "total_mwh": "Totalt MWh i dokumentet",
      "selected_mwh": "Valda MWh",
      "generate_certificates": "Generera certifikat",
      "success": "Annulleringsintyget har laddats upp och anläggningarna har tilldelats"
    },
    "certificates": {
      "heading": "EKOenergy-certifikat",
      "upload_statement": "Ladda upp annulleringsintyg",
      "no_statements": "Det finns inga annulleringsintyg ännu. Ladda upp ditt första intyg för att komma igång.",
      "file_name": "Intyg",
      "uploaded": "Uppladdat",
      "period_col": "@:cancellation.table.period",
      "total_mwh_col": "Totala MWh",
      "devices_col": "Anläggningar",
      "status_col": "Status",
      "actions_col": "@:common.actions.title",
      "download_statement": "Ladda ner intyg",
      "edit_statement": "Redigera intyg",
      "manage_devices": "Hantera länkade anläggningar",
      "approve": "Godkänn",
      "reject": "Avvisa",
      "generate": "Generera certifikat",
      "download_certificate": "Ladda ner certifikat",
      "approved_success": "Intyget har godkänts",
      "rejected_success": "Intyget har avvisats",
      "confirm_reject": "Är du säker på att du vill avvisa detta intyg?",
      "certificate_generated": "Certifikatet har genererats och laddats ner",
      "statement_uploaded": "Annulleringsintyget har laddats upp"
    },
    "manage_devices": {
      "title": "Redigera annulleringsintyg",
      "statement_details": "Detaljer för intyget",
      "documents_section": "@:common.documents",
      "statement_document": "Annulleringsintyg",
      "certificate_document": "Certifikat-PDF",
      "no_certificate_document": "Ingen certifikatfil",
      "add_document": "@:common.add",
      "statement_document_updated": "Intygsdokumentet har uppdaterats",
      "certificate_document_updated": "Certifikatsdokumentet har uppdaterats",
      "statement_document_deleted": "Intygsdokumentet har tagits bort",
      "certificate_document_deleted": "Certifikatsdokumentet har tagits bort",
      "linked_devices": "Länkade anläggningar",
      "add_device": "Lägg till anläggning",
      "no_devices": "Inga anläggningar är länkade till detta intyg.",
      "select_device": "Välj en anläggning",
      "saved": "Tilldelningarna av anläggningar har uppdaterats"
    },
    "ekoenergy": {
      "title": "EKOenergy ecolabel",
      "description": "Anläggningar som auktoriserade säljare kan använda för EKOenergy"
    }
  },
  "documents_table": {
    "no_documents": "Inga dokument att visa",
    "columns": {
      "id": "@:common.id",
      "name": "@:common.name",
      "type": "Typ",
      "category": "Kategori",
      "company": "@:common.company",
      "status": "Status",
      "created": "Skapad",
      "actions": "@:common.actions.title"
    },
    "filters": {
      "search_name": "Sök efter namn",
      "search_company": "Sök efter företag"
    },
    "type": {
      "custom_upload": "Uppladdning",
      "dokobit_document": "Signerat dokument"
    },
    "category": {
      "sending_gos_file_upload": "UG-sändning",
      "buy_contract_analysis": "Köpeavtal",
      "cancel_contract_analysis": "Annulleringsavtal",
      "ppa_contract_analysis": "PPA-avtal",
      "bulk_buy_analysis": "Bulkköp",
      "ppa_instructions": "PPA-instruktioner",
      "ppa_creation": "PPA-skapande",
      "cancellation_statement": "Annulleringsbesked",
      "issuance_data_import": "Utfärdandedata",
      "arbitrary_file_upload": "Filuppladdning",
      "portfolio_documentation": "Portföljdokumentation",
      "other": "Övrigt",
      "unknown": "Okänd"
    },
    "status": {
      "uploaded": "Uppladdad",
      "completed": "Signerad",
      "awaiting_signature": "Väntar på signatur",
      "canceled": "Avbruten"
    },
    "actions": {
      "archive": "Arkivera",
      "sign": "Signera",
      "view_details": "Detaljer"
    },
    "details_modal": {
      "title": "Dokumentdetaljer",
      "contract_details": "Avtalsdetaljer",
      "source": "Källa"
    },
    "confirm_archive": "Är du säker på att du vill arkivera detta dokument? Det kommer att tas bort från listan.",
    "archive_success_title": "Dokument arkiverat",
    "archive_success_message": "Dokumentet har arkiverats.",
    "linked_cancellations": "Länkade annulleringar",
    "cancellation_id": "Annullering #{id}"
  },
  "ppa_summary": {
    "heading": "Kommande utföranden",
    "loading": "Beräknar förväntade volymer...",
    "no_data": "Inga prognosdata tillgängliga ännu.",
    "no_data_short": "—",
    "mwh_value": "{amount} MWh",
    "next_delivery": "Nästa leverans",
    "following_delivery": "Följande leverans",
    "contract_ends": "Avtalet slutar",
    "send": "Genomförs {date} (förväntat {amount} MWh).",
    "cancel": "Makulerar perioden {start} -> {end} den {date} (förväntat {amount} MWh)."
  },
  "ai_chat": {
    "certificate_criteria_conflict": "{context} innehåller motstridiga certifikatkrav ({criterion}). Ladda upp dem separat.",
    "conflict_contexts": {
      "excel_rows": "Excel-raderna",
      "uploaded_documents": "De uppladdade dokumenten",
      "draft_and_document": "Det aktuella utkastet och det uppladdade dokumentet"
    },
    "shared_setting_conflict": {
      "intro": "Inget importerades. En annulleringsorder kan bara ha en mottagartyp, en konsumtionsperiod och ett annulleringsändamål, men dessa deklarationer skiljer sig åt:",
      "other_statements": "Övriga deklarationer ({count})",
      "more_statements": "…och {count} till",
      "outro": {
        "uploaded_documents": "Rätta dessa deklarationer i dokumentet och ladda upp det igen, ladda upp dem i separata filer, eller lägg till en anteckning i uppladdningen med det värde som gäller för alla deklarationer.",
        "draft": "Utkastet ändrades inte. Berätta vilket värde som gäller för alla deklarationer, eller slutför den här ordern och starta en ny chatt för de övriga deklarationerna."
      }
    },
    "document_irrelevant": "Det här dokumentet verkar inte passa det vi förbereder här, så inget importerades. Ladda upp ett annat dokument eller fråga mig varför det inte passade.",
    "title": "AI-assistent",
    "input_placeholder": "Skriv ett meddelande…",
    "send": "Skicka",
    "attach": "Bifoga ett dokument",
    "drop_files": "Släpp filerna för att bifoga dem",
    "drop_files_hint": "PDF, Word, Excel, CSV eller TXT · upp till {maxMb} MB",
    "drop_busy": "Bifoga filer när svaret har kommit",
    "new_chat": "Starta en ny chatt",
    "thinking": "Jobbar på det…",
    "error_reply": "Tyvärr gick något fel vid bearbetningen. Försök igen.",
    "greetings": {
      "cancel": "Hej! Ladda upp ett annulleringsdokument (PDF, Word, Excel eller CSV) så tar jag fram utkast till intygen. Om viktig information saknas frågar jag efter den här. Du kan också bara beskriva vad du behöver i ett meddelande.",
      "buy": "Hej! Ladda upp ett upphandlingsdokument eller beskriv vad du vill köpa (volym, teknik, årgång…) så fyller jag i inköpsinställningarna åt dig.",
      "send": "Hej! Ladda upp ett överföringsdokument eller berätta vem som ska ta emot ursprungsgarantierna (mottagare, EECS-konto, MWh-volym) så förbereder jag överföringen.",
      "bulk_buy": "Hej! Ladda upp förbrukningsrapporter eller anläggningslistor så extraherar jag företag, volymer och inköpsinställningar. Om viktig information saknas frågar jag efter den här.",
      "ppa": "Hej! Ladda upp ditt PPA-avtal eller beskriv leveransschemat så fyller jag i leveransinstruktionerna. Om viktig information saknas frågar jag efter den här.",
      "ecolabels": "Hej! Ladda upp ditt annulleringsintyg (PDF, Word, Excel eller CSV) eller beskriv det, så tar jag fram ett utkast till intygsuppgifterna och matchar enheterna åt dig. Om viktig information saknas frågar jag efter den här.",
      "ecolabel_devices": "Hej! Ladda upp din anläggningslista (kalkylblad, registerutdrag, e-post eller PDF) så extraherar jag varje anläggning med dess uppgifter, kontrollerar saknade fält och flaggar möjliga dubbletter. Du kan också beskriva anläggningar eller korrigeringar i ett meddelande."
    }
  },
  "branding": {
    "powered_by": "Drivs av",
    "registry_infrastructure": "Registerinfrastruktur",
    "powered_by_soldera": "Drivs av Solderas registerinfrastruktur"
  },
  "cnmc": {
    "workflow_intro": "Rapportera månadsproduktion, förbered CNMC:s utfärdandefiler och följ PPA-överföringar och export.",
    "filing_details": "Ansökningsuppgifter",
    "prepare_issuance": "Förbered utfärdande",
    "recipient_name": "Mottagarens juridiska namn",
    "destination_registry": "Målregister",
    "choose_registry": "Välj register",
    "domestic_transfer": "Spanien · inhemsk överföring",
    "recipient_r2": "CNMC-leverantörens identifierare (R2)",
    "eecs_account": "EECS-konto",
    "market_destination": "Exportdestination för marknadsvolymer",
    "change_destination": "Ändra destination",
    "confirm_representation": "Jag är behörig att lämna in ansökningar för denna producent och har bekräftat eventuella representationskrav.",
    "accept_declarations": "Jag bekräftar att dessa mätvärden är tillgängliga för utfärdande, att inga andra anspråk är öppna mot dem och att producenten godtar CNMC:s ansökningsdeklarationer och villkor för databehandling.",
    "fields": {
      "producer_name": "Producentens juridiska namn",
      "street": "Gata",
      "street_number": "Gatunummer",
      "staircase": "Trappuppgång (valfritt)",
      "postal_code": "Postnummer",
      "municipality": "Kommun",
      "province": "Provins",
      "country": "Land",
      "phone": "Telefon",
      "email": "E-post",
      "place": "Undertecknandeort",
      "representative_name": "Representantens namn (om tillämpligt)"
    },
    "production": "Produktion",
    "allocation": "Tilldelning",
    "review": "Granskning",
    "monthly_breakdown": "Ange varje anläggning och månad separat. Bråkdelar utesluts vid utfärdande av ursprungsgarantier; volymer slås aldrig samman mellan månader.",
    "device": "Produktionsanläggning",
    "month": "Produktionsmånad",
    "production_mwh": "Produktion (MWh)",
    "whole_go_total": "{count} hela ursprungsgarantier före befintliga åtaganden",
    "allocation_explanation": "PPA-instruktionerna styr tilldelningen. Uppdatera dina PPA-instruktioner och detta utkast för att ändra fördelningen.",
    "route": "Leveransväg",
    "market": "Marknad",
    "routes": {
      "DOMESTIC": "Inhemsk",
      "EXPORT": "AIB-export"
    },
    "issuance_split": "{domestic} inhemska ursprungsgarantier · {exported} ursprungsgarantier för AIB-export",
    "saved_draft_explanation": "Ditt utkast är sparat. Bekräfta omgången för att reservera volymerna och skapa utfärdandefilerna.",
    "open_batch": "Öppna omgång",
    "batch_number": "CNMC-omgång #{id}",
    "needs_attention_explanation": "Soldera behöver granska denna ansökan. Inlämnade ansökningar fortsätter att övervakas; berörda volymer förblir reserverade.",
    "edit_draft": "Redigera utkast",
    "delete_draft": "Radera utkast",
    "delete_draft_confirmation": "Radera CNMC-batch #{id}? Utkastet, dess fördelning och produktionsvärden raderas permanent. Detta kan inte ångras.",
    "confirm_and_generate": "Bekräfta tilldelningen och skapa filer",
    "stacking_instructions": "Ladda upp varje utfärdande-ZIP till CNMC och ange dess registreringsnummer nedan. Du kan förbereda överförings- och exportfiler när utfärdandeansökan har lämnats in, medan godkännande inväntas. Ladda upp varje leverans-ZIP separat och ange dess eget registreringsnummer.",
    "prepare_ppa_delivery": "Förbered leverans för {name}",
    "ppa_delivery_issuance_required": "Skicka utfärdandefilen för detta PPA till CNMC, ange sedan dess Número de Registro ovan och registrera inlämningen.",
    "market_export_issuance_required": "Skicka filen för AIB-exportutfärdande till CNMC, ange sedan dess Número de Registro ovan och registrera inlämningen.",
    "prepare_market_export": "Förbered marknadsexport",
    "kinds": {
      "DOMESTIC_ISSUANCE": "Inhemskt utfärdande",
      "EXPORT_ISSUANCE": "Utfärdande för AIB-export",
      "TRANSFER": "Inhemsk överföring",
      "EXPORT": "Export"
    },
    "statuses": {
      "DRAFT": "Utkast",
      "CONFIRMED": "Bekräftad",
      "PREPARED": "Förberedd",
      "SUBMITTED": "Inlämnad · ej verifierad",
      "PENDING": "Väntande",
      "APPROVED": "Godkänd · inväntar underlag",
      "COMPLETED": "Slutförd",
      "COMPLETE": "Klar",
      "IN_PROGRESS": "Pågår",
      "NEEDS_ATTENTION": "Kräver åtgärd",
      "ABANDONED": "Övergiven",
      "SUPERSEDED": "Ersatt"
    },
    "source_receipts": "Ursprungligt utfärdande · Nº Registro Origen",
    "outdated_file": "Den här filen använder en äldre mall. Ersätt en fil som inte har lämnats in före uppladdning; behåll inlämnade filer för dokumentation.",
    "lookup_retry": "CNMC-verifiering är tillfälligt otillgänglig. Ett nytt försök är planerat; senast kända status bevaras.",
    "filing_deadline": "Ansökningsfrist",
    "go_expiry": "Ursprungsgarantins giltighetstid",
    "last_checked": "Senast kontrollerad",
    "not_checked": "Ännu inte kontrollerad",
    "company_order": "Företagsorder",
    "download_zip": "Ladda ner ZIP",
    "check_status": "Kontrollera status",
    "record_submission": "Registrera inlämning",
    "correction_reason": "Orsak till korrigering eller återkallelse",
    "abandon_batch": "Överge omgång",
    "abandonment_reason": "Orsak till att överge denna omgång",
    "abandon_explanation": "Produktion kan endast frigöras för ej inlämnat eller verifierat avslaget/återkallat utfärdande. En misslyckad leverans frigör inte utfärdade volymer.",
    "connection": "CNMC-anslutning",
    "preparation_disabled": "Förberedelse av nya ansökningar är inte aktiverad för denna anslutning. Befintlig ansökningshistorik är fortfarande tillgänglig.",
    "profile_required": "Bekräfta dina ansökningsuppgifter innan du förbereder utfärdandet.",
    "template_updated": "CNMC har uppdaterat formuläret. Vi måste uppdatera stödet innan du kan skapa en ny fil. Dina inmatade uppgifter är sparade.",
    "checking_templates": "CNMC-formulären kontrolleras. Filer kan skapas efter verifieringen.",
    "no_batches": "Inga utfärdandeomgångar ännu.",
    "batch": "Omgång",
    "progress": "Förlopp",
    "filing_order": "Denna order hanteras via CNMC:s ansökningsformulär. Öppna utfärdandeomgången för att ladda ner filer, ange registreringsnummer och kontrollera förloppet.",
    "pending_ppa": "Reserverat för CNMC:s PPA-leverans",
    "cnmc_transferred": "Bekräftad PPA-leverans",
    "ppa_progress": "{reserved_go_count} UG reserverade · {ready_go_count} klara för ansökan · {transferred_go_count} överförda",
    "linked_filings": "CNMC-ansökningar",
    "order_instructions": "Ladda upp filerna i CNMC och ange varje registreringsnummer i den länkade omgången. Registerkontroller bekräftar slutförandet.",
    "awaiting_delivery_form": "Utfärdandet är reserverat. Förbered överförings- eller exportfilen i utfärdanderapporten efter att du har angett utfärdandets registreringsnummer.",
    "inventory_accepted": "Certifikat mottagna och tilldelade",
    "arrival_review": "Mottagna spanska exporter",
    "arrival_review_help": "Granska det exakta mottagarkontot, anläggningarnas hela volymer och produktionsmånader. Uppdelade mottagningar och alternativa anläggningsnamn kräver en motivering. Godkännande tilldelar ägande och portföljer tillsammans.",
    "export_verified": "Export verifierad",
    "awaiting_verification": "Inväntar CNMC-verifiering",
    "receiving_account": "Mottagarkonto",
    "imported_at": "Importerad",
    "production_months": "Produktionsmånader",
    "reviewed_name": "Granskat anläggningsnamn",
    "use_registry_name": "Använd registrets namn",
    "accept_inventory": "Acceptera certifikat",
    "replace_file": "Ersätt fil",
    "replace_file_help": "Skapa en länkad ersättning med den aktuella mallen. Inlämnade ansökningar måste först verifieras som avslagna eller återkallade. Historiska filer förblir tillgängliga.",
    "awaiting_issuance_receipt": "Inväntar utfärdandeansökans registreringsnummer",
    "next_action": "Nästa steg",
    "actions": {
      "REVIEW": "Granska och bekräfta tilldelningen",
      "SUBMIT_ISSUANCE": "Ladda upp utfärdandefiler och ange varje Número de Registro | Ladda upp utfärdandefilen och ange dess Número de Registro | Ladda upp utfärdandefiler och ange varje Número de Registro",
      "SUBMIT_DELIVERY": "Ladda upp leveransfiler och ange varje Número de Registro",
      "PREPARE_DELIVERY": "Förbered leveransfiler",
      "WAIT_CNMC": "Inväntar CNMC-bekräftelse",
      "WAIT_INVENTORY": "Inväntar certifikat på mottagarkontot",
      "CONTACT_SOLDERA": "Solderas granskning krävs",
      "COMPLETE": "Slutförd",
      "ABANDONED": "Övergiven"
    },
    "staff_review": "Solderas granskning",
    "staff_review_help": "Efter att ärendet lösts, dokumentera ändringarna och kontrollera nytt CNMC-underlag. Befintliga filer, reservationer och leveransposter bevaras i revisionshistoriken.",
    "resume_verification": "Återuppta verifiering",
    "load_more": "Läs in fler",
    "replacement_draft": "Skapa ersättningsutkast",
    "replacement_draft_help": "Ett ersättningsutkast behåller de ursprungliga produktionsanspråken. Hantera och frigör de gamla ansökningarna innan överlappande produktion bekräftas.",
    "template_check_failed": "CNMC-formulärets verifiering misslyckades. Ett nytt försök är planerat; dina uppgifter är sparade.",
    "next_check": "Nästa kontroll",
    "registry_evidence": "CNMC-underlag",
    "net_production": "Faktisk nettoproduktion",
    "domestic_volume": "Inrikes",
    "export_volume": "AIB-export",
    "unallocated_fraction": "Ofördelad decimaldel",
    "application_number": "Ansökan #{id}",
    "requested": "Begärt",
    "approved": "Godkänt",
    "delivered": "Levererat",
    "zip_package": "Originalarbetsbok i ZIP",
    "issuance_receipt": "Número de Registro · Expedición",
    "receipt_format": "20 siffror utan mellanslag: inlämningsår + 03 + 14 siffror. Använd inlämningsåret, inte produktionsåret.",
    "receipt_example": "t.ex. 20260300000045887410",
    "transfer_receipt": "Número de Registro · Transferencia",
    "export_receipt": "Número de Registro · Exportación",
    "issuance_receipt_help": "När denna ZIP-fil för utfärdande har skickats in, kopiera det Número de Registro som CNMC tilldelat. Det finns under Consultas por Solicitante eller som Nº registro överst i ärendets detaljer.",
    "delivery_receipt_help": "När denna ZIP-fil för överföring eller export har skickats in, kopiera det nya Nº registro överst i CNMC:s ärendedetaljer. Använd inte Nº Registro Origen (det ursprungliga utfärdandet) eller exportens Message ID.",
    "correct_receipt": "Korrigera registreringsnummer",
    "delivery_due": "Leveransberedskap",
    "issuance_stage": "Steg 1 · Utfärdandeformulär",
    "delivery_stage": "Steg 2 · Överförings- och exportformulär",
    "download_notice": "Att ladda ned ett paket innebär inte att det skickas in. Registrera varje CNMC-ärendenummer i omgången för att aktivera relaterade formulär och uppföljning.",
    "enter_manually": "Ange manuellt",
    "upload_with_ai": "Ladda upp med AI",
    "upload_readings_help": "AI läser anläggningarnas CIL-koder, produktionsmånader och MWh från Excel- eller CSV-filer (högst 25 MB). Granska och redigera raderna nedan. Stora Excel-filer kan behöva rensas från oanvända blad och formatering eller delas upp i mindre filer.",
    "readings_uploaded": "Mätvärdena från {filename} visas nedan. Granska dem innan du fortsätter.",
    "upload_readings_conflict": "En anläggning och månad i filen har redan ett annat mätvärde i tabellen. Ta bort den raden innan du laddar upp igen.",
    "invalid_readings_file": "Välj en Excel-fil (.xlsx, .xls) eller CSV-fil på högst 25 MB.",
    "add_production_help": "Ange ett månadsvärde manuellt eller ladda upp en fil med AI.",
    "ppa_reserves": "Reservationer för utfärdande",
    "no_ppa_reserves": "Inga PPA-reservationer. Tillgängliga hela UG tilldelas export för marknadsförsäljning.",
    "filing_snapshot_help": "Gemensamma standarduppgifter för CNMC-ansökningar. Varje omgång sparar de ansökningsuppgifter som användes när den förbereddes.",
    "producer": "Producent",
    "contact_address": "Kontakt och adress",
    "representation": "Representation",
    "declarations": "Försäkringar",
    "connection_identity": "Från den valda CNMC-anslutningen",
    "saved_for_connection": "Sparas för senare omgångar på denna anslutning",
    "eecs_recipient": "EECS-registerkonto",
    "domestic_recipient": "Spansk leverantör · CNMC",
    "recipient_type": "Mottagartyp",
    "domestic_delivery_help": "Inrikes leverans via CNMC. Soldera reserverar denna andel vid utfärdandet och förbereder överföringsformuläret. Du skickar in filerna till CNMC.",
    "export_delivery_help": "Exportleverans via CNMC till mottagarens EECS-registerkonto. Soldera reserverar denna andel vid utfärdandet och förbereder exportformuläret. Du skickar in filerna till CNMC.",
    "ppa_execution_desc": "Fördelning och leverans via CNMC.",
    "ppa_execution_help": "PPA-andelen och mottagaren fastställs när du bekräftar utfärdandet. Ange utfärdandets registreringsnummer för att förbereda överförings- eller exportfilen i utfärdanderapporten. Ladda upp varje fil till CNMC och ange dess registreringsnummer. Soldera följer godkännande och leverans.",
    "ppa_execution_summary": "Via CNMC-utfärdande",
    "r2_help": "Mottagarens registrering som behörig leverantör hos CNMC.",
    "ready_for_filing": "Klart att skicka in",
    "template_verification_pending": "CNMC-formulären väntar på verifiering. Filer kan skapas när de senaste mallarna har verifierats.",
    "validation": {
      "r2": "Ange CNMC:s leverantörsregistrering som börjar med R2-.",
      "eecs_region": "EECS-kontot måste tillhöra det valda registret.",
      "month": "Ange en giltig produktionsmånad.",
      "production_precision": "Ange MWh med högst 3 decimaler."
    },
    "connection_required": "Anslut ett spanskt producentkonto för att förbereda CNMC-ansökningar. Kontakta support@soldera.org för hjälp."
  },
  "forwards": {
    "common": {
      "mwh": "MWh",
      "mwh_value": "{value} MWh",
      "committed": "Bundet",
      "escrowed": "I depå",
      "available": "Tillgängligt",
      "planned": "Planerat",
      "delivered": "Levererat",
      "shortfall": "Ej täckt",
      "fill_of_total": "{filled} av {total} MWh",
      "no_window_end": "ingen leveransdeadline",
      "not_priced": "Inget pris ännu",
      "price_per_mwh": "{price} €/MWh",
      "price_range_per_mwh": "{min} – {max} €/MWh",
      "retry": "Försök igen",
      "unknown": "Okänt",
      "yes": "Ja",
      "no": "Nej",
      "none": "Inga",
      "actions": "Åtgärder",
      "status": {
        "draft": "Utkast",
        "confirmed": "Bekräftad",
        "completed": "Slutförd",
        "cancelled": "Annullerad",
        "archived": "Arkiverad",
        "escrow_remaining": "Kvarvarande depå",
        "pay_as_produced": "Efter produktion"
      },
      "super_admin_only_create": "Endast en superadministratör kan skapa affärer.",
      "support": {
        "mixed": "Blandat: med stöd eller okänt",
        "unsupported": "Utan stöd"
      },
      "period_width": {
        "month": "Månader",
        "quarter": "Kvartal",
        "half_year": "Halvår",
        "year": "År"
      },
      "device_count": "{count} anläggningar | {count} anläggning | {count} anläggningar",
      "deal_badges": {
        "under_committed": "{mwh} MWh utan täckning",
        "volume_over": "{mwh} MWh över affärsvolymen",
        "volume_under": "{mwh} MWh under affärsvolymen"
      },
      "deal_text": {
        "description_help": "Skrivs ut på producenternas fakturor och visas för producenterna i deras försäljningslista.",
        "internal_notes": "Interna anteckningar",
        "internal_notes_help": "Endast för personal: visas aldrig för producenter eller köpare och skrivs aldrig ut."
      }
    },
    "overview": {
      "title": "Terminsförsäljning",
      "description": "Åtgärdspunkter, terminsvolym såld per produktionsår, kommande leveranser och de affärer du hanterar.",
      "year_totals": {
        "title": "Terminsförsäljning per produktionsår",
        "description": "Terminsvolymen som sålts av varje produktionsår och dess genomsnittliga köparpris.",
        "loading": "Laddar årssummorna",
        "empty": "Ingen terminsförsäljning ännu.",
        "load_failed": "Årssummorna för terminsförsäljning kunde inte laddas.",
        "volume": "{mwh} MWh",
        "average": "snitt {price} €/MWh",
        "no_average": "ännu ingen prissatt volym",
        "unpriced": "{mwh} MWh utan pris",
        "contents": {
          "intro": "Volymen omfattar bekräftade och slutförda affärer samt det som avbrutna affärer redan hade skickat, men inga utkast. Per affärstyp:",
          "fixed_volume": "Affärer med fast volym: deras leveransplan, varje period räknad till det år den börjar, oavsett om den har skickats.",
          "pay_as_produced": "Avtal efter produktion: vad varje månad skickade, eller dess nominerade volym tills den skickas."
        }
      },
      "attention": {
        "title": "Kräver åtgärd",
        "description": "Punkter från det här kontots mandat och affärer. De försvinner av sig själva när problemet är löst.",
        "loading": "Laddar åtgärdspunkter",
        "empty": "Inget kräver din åtgärd.",
        "load_failed": "Åtgärdspunkterna kunde inte laddas.",
        "status": {
          "stale_draft": "Gammalt utkast",
          "open_slices": "Ej täckt",
          "escrow_shortfall": "Underskott",
          "producer_price_missing": "Inget producentpris",
          "price_conflict": "Priskonflikt",
          "delivery_unpriced": "Pris saknas",
          "free_escrow": "Depå att återföra",
          "infeasible": "Översåld",
          "mandate_escrow_missing": "Saknas",
          "other": "Övrigt",
          "coarse_issuance": "Utfärdande",
          "allocation_not_ready": "Fördelas inte",
          "contango_discouraged": "Contango 20 %"
        },
        "reason": {
          "stale_draft": "Utkast till affär, {days} dagar utan bekräftelse. Dess bindningar reserverar fortfarande volym, men inget allokeras.",
          "open_slices": "{mwh} MWh av denna affär täcks inte av något mandat.",
          "escrow_shortfall": "{mwh} MWh av bunden volym finns ännu inte i depå.",
          "producer_price_missing": "Swapleverans med förfallodag {date}: inget producentpris är angivet, så producenterna fakturerar till försäljningspriset.",
          "price_conflict": "Leverans med förfallodag {date}: {company} säljer genom mandat med olika priser ({mandates}), så leveransen kan inte skickas.",
          "delivery_unpriced": "Ingen leverans saknar köparpris. | {count} leverans ({mwh} MWh) saknar köparpris, så årssummorna för terminsförsäljning räknar inte med den. | {count} leveranser ({mwh} MWh) saknar köparpris, så årssummorna för terminsförsäljning räknar inte med dem.",
          "free_escrow": "{mwh} MWh ligger i depå men ingen leverans behöver dem längre. Återför dem till de ägande bolagen.",
          "infeasible": "Den väntade produktionen ligger {mwh} MWh under vad mandatet är skyldigt under {period}.",
          "infeasible_periods": "Den väntade produktionen ligger under vad mandatet är skyldigt under {periods}.",
          "mandate_escrow_missing": "{mwh} MWh som är bundet för {period} saknas i depån; registret borde redan ha utfärdat det.",
          "coarse_issuance": "Certifikat utfärdas {issued}, men mandatet bjuder ut {listed}: de anläggningarna kan inte leverera dess utbjudna volymer. Bjud ut {widest} eller längre.",
          "allocation_not_ready": "Den nattliga fördelningen hoppar över {companies} (inte redo för fördelning), så deras produktion når aldrig depån för mandatets affärer.",
          "contango_discouraged": "Det här mandatet säljer bara minst 20 % över spotpriset, vilket sällan inträffar, så dess volym säljs sällan. Överväg ”Sälj bara vid contango” i stället."
        },
        "issued_in_region": "{width} ({region})",
        "period_mwh": "{period} ({mwh} MWh)",
        "width_adverb": {
          "month": "månadsvis",
          "quarter": "kvartalsvis",
          "half_year": "halvårsvis",
          "year": "årsvis"
        }
      },
      "deliveries": {
        "title": "Kommande leveranser",
        "description": "Planerade leveranser i affärer du hanterar, närmast stängande fönster först. Saknad volym är det leveransens depå ännu saknar, grupperat efter anläggningsländerna i de mandat som band den. En månad i en affär efter produktion visas mot sin nominerade målvolym, som följs upp men inte är ett åtagande.",
        "loading": "Laddar leveranser",
        "empty": "Inga leveranser matchar filtren.",
        "load_failed": "Kommande leveranser kunde inte laddas.",
        "download_xlsx": "Ladda ner xlsx",
        "transaction": "Transaktion",
        "window": "Leveransfönster",
        "deal": "Affär",
        "escrowed_of_planned": "I depå / planerat · saknas per land",
        "open_transaction": "Öppna transaktionen",
        "open_deal": "Öppna affären",
        "escrowed_of_target": "{escrowed} av målet {target} MWh",
        "on_or_before": "senast {date}",
        "short": "saknas",
        "due_today": "förfaller idag",
        "due_tomorrow": "förfaller imorgon",
        "due_in_days": "om {days} dagar",
        "overdue_one_day": "1 dag försenad",
        "overdue_days": "{days} dagar försenad",
        "transaction_status": {
          "draft": "Utkast",
          "pending_buyer_details": "Väntar på köparuppgifter",
          "pending_contracts": "Väntar på avtal",
          "ready_to_transfer": "Klar för överföring",
          "delivered": "Levererad",
          "completed": "Slutförd"
        },
        "delivered_awaiting_completion": "levererad, väntar på betalning",
        "filters": {
          "status": "Transaktionens status",
          "window_end": "Leveransfönstret stänger",
          "window_end_any": "Valfritt datum",
          "deal_name": "Affärens namn"
        }
      },
      "deals": {
        "title": "Affärer du hanterar",
        "description": "All detalj (leveransplan, bindningar, depåfördelning) finns på affärssidan.",
        "loading": "Laddar affärer",
        "empty": "Inga affärer matchar filtren.",
        "load_failed": "Affärerna kunde inte laddas.",
        "new_deal": "Nytt terminsutkast",
        "new_pap_deal": "Ny affär efter produktion",
        "no_buyer": "Ej angiven",
        "no_price": "Ej angivet",
        "price_range": "{min} - {max}",
        "deliveries_of": "{done} av {total}",
        "stale": "{days} d gammal",
        "infeasible": "Ogenomförbar",
        "filters": {
          "status": "Status",
          "status_all": "Alla statusar",
          "name": "Affärens namn",
          "name_placeholder": "Valfritt namn",
          "mandate": "Innehåller mandat",
          "mandate_placeholder": "Mandatets namn",
          "company": "Innehåller bolag",
          "company_placeholder": "Bolagets namn"
        },
        "columns": {
          "deal": "Affär",
          "buyer": "Köpare",
          "quarters": "Produktion",
          "volume": "Affärsvolym (MWh)",
          "price": "Pris (€/MWh)",
          "deliveries": "Leveranser klara",
          "status": "Status"
        }
      }
    },
    "mandates": {
      "intro": {
        "title": "Sälj din framtida produktion i förväg",
        "body": "Med terminsförsäljning säljer du ursprungsgarantier för produktion som ännu inte har utfärdats, till ett pris som avtalas i dag. Solderas terminsförsäljning hjälper dig att säkra förutsägbara intäkter och minska risken för prisfluktuationer, utan att du behöver sköta den dagliga hanteringen av din terminsförsäljning. Börja med att skapa ett terminsförsäljningsmandat: välj vilka av dina bolag som deltar och hur mycket de bjuder ut under varje period. Soldera säljer den volymen till köpare i sitt nätverk, och certifikaten levereras när registret utfärdar dem. Om ett bolag producerar mindre än väntat kan mandatets övriga bolag täcka underskottet med sin extra produktion.",
        "cta": "Skapa ditt första mandat"
      },
      "guide": {
        "title": "Om terminsförsäljning"
      },
      "loading": "Laddar mandat",
      "empty": "Inga mandat matchar filtren ännu.",
      "load_failed": "Mandatens tidslinje kunde inte laddas.",
      "attention": {
        "description": "Vad du bör ändra i dina mandat. Punkterna försvinner när de är åtgärdade."
      },
      "restricted_access": "Ditt bolag ingår i det här mandatet. Du behöver åtkomst till alla medlemsbolag för att visa informationen.",
      "status_filter": "Status",
      "status_filter_all": "Alla statusar",
      "company_filter": "Bolag",
      "company_filter_all": "Alla bolag",
      "name_filter": "Mandatnamn",
      "name_filter_placeholder": "Sök på namn",
      "name_filter_no_matches": "Inga mandat matchar namnet.",
      "status": {
        "active": "Aktiv",
        "archived_open": "Arkiverad, åtaganden kvarstår",
        "archived_settled": "Arkiverad och avräknad"
      },
      "year_previous": "Föregående år",
      "year_next": "Nästa år",
      "band_title": "Alla mandat",
      "band_column": "{quarter}: {listed} MWh utbjudet, {committed} MWh bundet, {escrowed} MWh i depå, {available} MWh tillgängligt",
      "band_available": "{quarter}: {value} MWh tillgängligt av {listed} MWh utbjudet",
      "band_committed": "{quarter}: {value} MWh bundet, ännu inte i depå ({committed} MWh bundet totalt)",
      "band_escrowed": "{quarter}: {value} MWh i depå",
      "infeasible_periods": "Mandatet har sålt mer än vad dess anläggningar väntas producera under {periods}.",
      "row_subtitle": "{companies} · {devices} · {shape}",
      "row_companies": "{count} bolag | {count} bolag | {count} bolag",
      "pap_window": "Avtalsperiod · {escrowed} MWh i depå · {delivered} MWh levererat",
      "cell_figure": "{committed} av {listed}",
      "cell_escrowed_figure": "{value} i depå",
      "cell_available": "{mandate}, {quarter}: {value} MWh fortfarande tillgängligt",
      "available_help": "För varje period den största volym en ny affär fortfarande kan ta. Åtaganden över bredare perioder delas mellan perioderna, så siffrorna kan inte adderas.",
      "cell_committed": "{mandate}, {quarter}: {value} MWh bundet, varav {escrowed} MWh i depå",
      "cell_stranded": "{mandate}, {quarter}: {value} MWh i depå utan gällande åtagande",
      "cell_empty": "{mandate}, {quarter}: inget utbjudet",
      "cell_deal_tooltip": "{deal} · {value} MWh, {escrowed} MWh i depå · {status} · leverans senast {window}",
      "entry_width": {
        "quarter": "Kvartalsvis",
        "month": "Månadsvis",
        "half_year": "Halvårsvis",
        "half_year_recommended": "Halvårsvis (rekommenderas)",
        "year": "Årsvis"
      },
      "listing_kind": {
        "one_off": "Engångs",
        "recurring": "Återkommande",
        "pay_as_produced": "Efter produktion"
      },
      "options": {
        "title": "Inställningar",
        "minimum_price": "Lägsta pris",
        "minimum_price_placeholder": "Ingen gräns",
        "minimum_price_hint": "En affär får inte prissätta mandatets volym lägre än så här.",
        "minimum_price_negative": "Lägsta priset kan inte vara negativt.",
        "minimum_price_too_precise": "Lägsta priset får ha högst {decimals} decimaler.",
        "contango": {
          "label": "Contango",
          "help": "Contango innebär att terminspriset ligger över spotpriset den dag försäljningen görs.",
          "none": "Sälj oavsett spotpris",
          "any": "Sälj bara vid contango",
          "at_least_20_percent": "Sälj bara vid contango, minst 20 % över spot (avråds)",
          "discouraged": "En premie på 20 % över spot är ovanlig, så det här mandatets volym säljs sällan. Överväg ”Sälj bara vid contango” i stället."
        },
        "archive_on_delivery": "Arkivera mandatet när dess sista åtagande levererats",
        "archive_on_delivery_hint": "För ett mandat som finns till för ett enda avtal."
      },
      "advanced_listing": {
        "label": "Visa avancerade alternativ för utbud",
        "hint": "Alla som redigerar mandatet får alla former av utbud: engångs, andra periodlängder och efter produktion. Utan det visar redigeraren bara ett återkommande utbuds kvartal.",
        "locked": "Förblir på så länge utbudet är något annat än återkommande och kvartalsvis, eller så länge mandatet säljer i förväg."
      },
      "volumes": {
        "title": "Utbjuden volym",
        "intro": "Ange hur mycket mandatet bjuder ut för terminsförsäljning under varje period. Volymen gäller hela mandatet, inte varje bolag för sig. Utbjuden volym är inte bindande och kan ändras när som helst. Den blir bindande när den binds till en affär, och bunden volym måste levereras även om du sänker den utbjudna volymen senare. Du kan ange MWh eller % av den beräknade produktionen. En % sparas som MWh.",
        "previewing": "Uppdaterar",
        "mode": "Hur volymerna anges",
        "entry_width": "Periodlängd",
        "entry_width_hint": "Hur lång varje period du bjuder ut är. Din volym kan säljas tillsammans med dina andra perioder som en längre period, men aldrig delas upp i kortare.",
        "month_note": "Kan endast användas i register som utfärdar ursprungsgarantier månadsvis.",
        "month_warning": "Detta är en avancerad funktion. Månadsvisa erbjudanden stöder inte balansering: en månads överproduktion kan inte täcka en annan månads underproduktion.",
        "half_year_note": "Ett halvårsmandat kan endast täcka produktionsperioder på ett halvår eller ett helt år inom leveranser.",
        "year_note": "Ett årsmandat kan endast täcka produktionsperioder på ett helt år inom leveranser.",
        "pay_as_produced_note": "Ett mandat efter produktion säljer anläggningarnas hela produktion, bjuder därför inte ut några volymer, och dess anläggningar får inte ingå i något annat mandat.",
        "period": "Period",
        "share_of_estimate": "% av prognosen",
        "feedback": "Bundet · fritt · prognos",
        "mwh_for": "MWh utbjudet för {period}",
        "share_for": "Andel av prognosen för {period}",
        "remove_period": "Ta bort {period}",
        "no_rows": "Inga perioder är utbjudna ännu.",
        "add_period": "Lägg till period",
        "whole_year": "Hela året",
        "no_estimate": "Ingen prognos ännu",
        "feedback_line": "{committed} bundet · {free} fritt · {estimated} prognos",
        "free_hint": "Fritt är det som fortfarande kan säljas i dag: inget när periodens produktion är över, inget som försäljningsstrategin ännu inte har släppt, och aldrig mer än vad kvartalet, halvåret och året runt den har kvar.",
        "over_committed": "Mer bundet än utbjudet",
        "over_committed_note": "Följande befintliga åtaganden påverkas inte:",
        "over_committed_period": "{period}: {committed} MWh bundet",
        "over_estimate": "{percent}% av prognosen",
        "errors": {
          "period_duplicate": "Den här perioden är redan utbjuden på en annan rad."
        },
        "how_it_works": "Så fungerar utbudet"
      },
      "production_range": {
        "limited": "Begränsa utbudet till en fast produktionsperiod",
        "first_month": "Första produktionsmånad",
        "last_month": "Sista produktionsmånad",
        "hint": "Nya avtal kan bara omfatta produktion under dessa månader. Ett återkommande utbud bjuder inte ut något utanför dem; ett avtal efter produktion måste ligga inom dem. Lämna en månad tom för ingen gräns på den sidan.",
        "no_limit": "Ingen gräns",
        "last_before_first": "Den sista månaden kan inte vara före den första."
      },
      "members": {
        "title": "Bolag",
        "description": "Vems produktion mandatet säljer.",
        "placeholder": "Välj företag",
        "not_enabled": "Terminsförsäljning är inte aktiverad. Kontakta supporten.",
        "not_allocation_ready": "Inte uppsatt för nattlig allokering, så ingenting kommer att läggas i depå.",
        "no_candidates": "Inga bolag matchar.",
        "at_least_one": "Ett mandat behöver minst ett bolag.",
        "manage_account": "För att ändra mandatets företag, hantera ett konto som äger dem.",
        "own_companies_only": "Endast ditt eget kontos företag erbjuds. För att skapa ett mandat av en kunds företag, hantera kundens konto."
      },
      "devices": {
        "title": "Anläggningar",
        "description": "Alla registrerade anläggningar hos bolagen ovan. Prognoserna är netto efter PPA.",
        "use_allowlist": "Sälj bara från valda anläggningar",
        "empty": "Inga anläggningar.",
        "loading": "Läser in företagens anläggningar…",
        "include": "Ta med {device}",
        "device": "Anläggning",
        "company": "Bolag",
        "obligations": "Åtaganden",
        "mandate_count": "{n} mandat | {n} mandat",
        "ppa_count": "{n} PPA | {n} PPA:er",
        "obligations_note": "Allt som redan gör anspråk på anläggningen: de terminsförsäljningsmandat den ingår i (överlapp är tillåtet, det är de utbjudna volymerna som konkurrerar) plus de PPA som täcker den. Ett PPA betjänas före terminsaffärer, så dess volym når aldrig ett åtagande. En anläggning i ett mandat efter produktion tillhör bara det mandatet och kan inte läggas till här.",
        "country": "Land",
        "technology": "Teknik",
        "cod": "Driftsatt",
        "support": "Stöd",
        "ecolabel": "Förhandsgodkänd av EKOenergy",
        "estimate": "Prognos (MWh)",
        "estimate_note": "Prognosen täcker mandatets utbjudna perioder och räknar redan bort varje anläggnings PPA-andel.",
        "unnamed": "Anläggning {id}",
        "stale_deleted_by_registry": "Borttagen av registret. Avmarkera den för att ta bort den ur mandatet.",
        "stale_not_registered": "Inte längre registrerad. Avmarkera den för att ta bort den ur mandatet.",
        "include_all": "Inkludera alla anläggningar"
      },
      "eligibility": {
        "title": "Affärsbehörighet",
        "description": "Vad en affär som begränsar varje dimension skulle hitta här. Den sämsta anläggningen sätter varje värde.",
        "country_tier": "Länder",
        "tier": {
          "standard_aib_gc": "Standard AIB GC",
          "aib_outside_standard": "AIB, utanför standarduppsättningen",
          "pl_be": "Polen / Belgien",
          "non_aib": "Utanför AIB",
          "unknown": "Ej fastställt"
        },
        "technology_mix": "Tekniker",
        "oldest_cod": "Äldsta driftsättningsdatum",
        "cod_claim_year": "För rapporteringsår {year} är det föredragna driftsättningsdatumet {cutoff} eller senare. Detta kontrollerar endast ålder.",
        "cod_preferred": "Alla anläggningar uppfyller detta ålderskriterium.",
        "cod_not_preferred": "Mandatet uppfyller inte detta ålderskriterium, eller så saknas driftsättningsdatum.",
        "cod_standards_note": "Vissa rapporteringsstandarder begränsar hur gammal en anläggning får vara: RE100 godtar till exempel bara anläggningar som tagits i drift eller förnyats under de senaste 15 åren.",
        "supported": "Produktionsstöd",
        "ecolabels": "Miljömärkningar",
        "through_year": "till och med {year}",
        "ecolabel_requirements": {
          "ekoenergy": "Kräver att varje anläggning är förhandsgodkänd av EKOenergy.",
          "okpower": "Solderas bedömning enligt OK-power-kriterierna: varje anläggning är förhandsgodkänd av EKOenergy, saknar stöd och är vind- eller solkraft.",
          "okpower_new": "Solderas bedömning enligt OK-power-kriterierna: varje anläggning är förhandsgodkänd av EKOenergy, saknar stöd och är under produktionsåret solkraft högst 5 år gammal eller vindkraft högst 4 år gammal."
        },
        "failing_device_count": "uppfylls inte av {count} av {total} anläggningar",
        "failing_device_count_named": "uppfylls inte av {count} av {total} anläggningar: {devices}",
        "blocker_device_count": "{count} av {total} anläggningar",
        "blocker_device_count_named": "{count} av {total} anläggningar: {devices}",
        "no_issues": "Inga problem har rapporterats för detta kriterium. Affärsspecifika begränsningar gäller fortfarande.",
        "no_devices": "Det finns inga anläggningar i detta mandat.",
        "all_qualify": "Alla anläggningar uppfyller kraven",
        "guide": {
          "title": "Förbättra behörigheten",
          "intro": "Samla anläggningar som samma köpare skulle godta, så att ingen enskild anläggning håller mandatet utanför en affär:",
          "unsupported": "Vattenkraft, sol och vind utan stöd från ett och samma land i ett mandat. De flesta köpare godtar dessa.",
          "biomass": "Biomassa och biogas i ett separat mandat, eftersom många köpare utesluter dem.",
          "issuance": "Anläggningar i register som inte utfärdar varje månad i ett separat mandat, med en periodlängd som motsvarar hur ofta registret utfärdar.",
          "several_mandates": "Ett bolag kan ingå i flera mandat. Om du bara vill ta med några av dess anläggningar i det här mandatet slår du på ”{option}” under {section} och markerar de som ska ingå."
        }
      },
      "commitments": {
        "title": "Åtaganden på mandatet",
        "description": "Vad som sålts från den.",
        "loading": "Laddar åtaganden",
        "empty": "Ingenting har sålts från det här mandatet.",
        "all_completed": "Alla åtaganden i det här mandatet är slutförda.",
        "show_completed": "Visa slutförda ({count})",
        "period": "Produktionsperiod",
        "escrowed": "I depå",
        "window": "Leveransfönster",
        "status": "Status",
        "deal": "Affär",
        "open_deal": "Öppna affären",
        "committed_on": "Åtagande gjort",
        "on_or_before": "senast {date}"
      },
      "escrow_remaining": {
        "description": "Dina bolag ingår inte längre i det här mandatet, men certifikaten nedan ligger kvar i depå tills leveranserna de täcker har skickats eller återlämnats. Inget annat om mandatet visas.",
        "empty": "Du har inget kvar i det här mandatet.",
        "period": "Period",
        "escrowed": "I depå",
        "status": "Affärens status",
        "window_end": "Leverans senast"
      },
      "editor": {
        "loading": "Laddar mandatet",
        "not_found_title": "Det här terminsförsäljningsmandatet är inte tillgängligt",
        "not_found_body": "Den finns inte, eller tillhör bolag du inte har åtkomst till.",
        "title": "Terminsförsäljningsmandat",
        "new_title": "Nytt terminsförsäljningsmandat",
        "description": "Ett terminsförsäljningsmandat anger vilken volym dess bolag bjuder ut för terminsförsäljning, och från vilka anläggningar.",
        "name": "Namn",
        "name_hint": "Visas för alla som kan se mandatet, även för ägare till ett medlemsbolag som inte kan öppna det, och för Soldera när affärer sätts ihop. Ange gruppen och vad den säljer, t.ex. ”Acme vind 2027”. Ta inte med köparnamn eller priser.",
        "mandate_description": "Beskrivning",
        "mandate_description_hint": "Anteckningar för medlemsbolagen, till exempel vad gruppen har kommit överens om, vem man kontaktar eller annat att tänka på när mandatet säljs. Alla som kan öppna mandatet kan läsa den. Den är endast informativ: vad som kan säljas bestäms av den utbjudna volymen och inställningarna.",
        "delete": "Ta bort",
        "confirm_delete": "Ta bort mandatet? Inget åtagande har någonsin gjorts mot det, så ingenting går förlorat.",
        "archive": "Arkivera",
        "unarchive": "Återställ från arkiv",
        "discard": "Kasta ändringar",
        "save": "Spara",
        "save_anyway": "Spara ändå",
        "save_failed": "Mandatet kunde inte sparas. Kontrollera formuläret och försök igen.",
        "unsaved_changes": "Du har osparade ändringar.",
        "close_confirm": "Stänga mandatet och förkasta dina osparade ändringar?",
        "read_only": "Du kan se mandatet men inte ändra det.",
        "details_title": "Namn och beskrivning",
        "name_required": "Ange ett namn för mandatet."
      },
      "wizard": {
        "step_members": "Företag och anläggningar",
        "step_listing": "Utbud",
        "step_confirm": "Bekräfta",
        "create": "Skapa mandat"
      },
      "summary": {
        "title": "Sammanfattning",
        "companies": "Företag",
        "devices": "Anläggningar",
        "devices_all": "Alla anläggningar ({count})",
        "devices_allowlisted": "Inga anläggningar valda | {count} vald anläggning | {count} valda anläggningar",
        "listing": "Utbud",
        "obligation_note": "Det här är exakta volymer, inte produktionsuppskattningar. Att bjuda ut dem är inte bindande, men när en affär tar volym ur mandatet är företagen i det juridiskt skyldiga att leverera exakt den volym affären tog, oavsett vad deras anläggningar producerar.",
        "obligation_note_pay_as_produced": "När en affär tar volym ur mandatet är företagen i det juridiskt skyldiga att leverera det deras anläggningar producerar under affärens period."
      },
      "cell_sellable_now": "Säljbart nu: {value} MWh"
    },
    "sales_strategy": {
      "title": "Försäljningsstrategi",
      "help": "Hur mandatets utbjudna volym släpps till försäljning över tid. Att sälja ett produktionsår i delar, vid olika tidpunkter, sprider dess prisrisk.",
      "split": {
        "asap": "Så snart som möjligt",
        "half_yearly": "Sälj två gånger om året",
        "quarterly": "Sälj fyra gånger om året"
      },
      "split_help": {
        "asap": "släpper allt på en gång",
        "half_yearly": "släpper volymen i två lika delar",
        "quarterly": "släpper volymen i fyra lika delar (rekommenderas)"
      },
      "sell_ahead": {
        "label": "Sälj i förväg",
        "help": "Hur stor del av varje produktionsår som säljs två år före produktionen. Resten säljs under året före produktionen.",
        "next_year_only": "Bara nästa år",
        "two_years_ahead": "Två år i förväg",
        "preset": "{percent}%",
        "share_of": "av varje produktionsår",
        "lead_next_year": "Varje produktionsår säljs under året före det.",
        "lead_ahead": "Varje produktionsår säljs under två år: {early}% under året två år före produktionen och resterande {rest}% under året före.",
        "cadence": {
          "asap": "Allt släpps den 1 januari.",
          "half_yearly": "Den släpps i två lika delar, den 1 januari och den 1 juli.",
          "quarterly": "Den släpps i fyra lika delar, den 1 januari, 1 april, 1 juli och 1 oktober."
        },
        "cadence_ahead": {
          "asap": "Varje andel släpps på en gång, den 1 januari.",
          "half_yearly": "Varje andel släpps i två lika delar, den 1 januari och den 1 juli.",
          "quarterly": "Varje andel släpps i fyra lika delar, den 1 januari, 1 april, 1 juli och 1 oktober."
        },
        "bar_caption": "Exempel: så säljs produktionen {year}",
        "bar_segment": "{year} · {percent}%",
        "release_more": "Att spara släpper genast {mwh} MWh mer av produktionen {year} till försäljning, eftersom dess tidigare försäljningsfönster redan har öppnat.",
        "release_less": "Att spara håller tillbaka {mwh} MWh av produktionen {year} som i dag är släppt till försäljning."
      },
      "summary": "{split}, {horizon}",
      "summary_split": {
        "asap": "så snart som möjligt",
        "half_yearly": "två gånger om året",
        "quarterly": "fyra gånger om året"
      },
      "summary_next_year": "nästa års produktion",
      "summary_ahead": "{percent}% två år framåt",
      "future_only": "En ändring gäller bara framtida försäljningar. Redan åtagen volym står kvar.",
      "schedule_title": "Försäljningsschema",
      "schedule_open": "Visa försäljningsschema",
      "schedule_pending": "Försäljningsschemat visas här när mandatet kan förhandsgranskas.",
      "schedule_empty": "Inget är utbjudet för de kommande produktionsåren ännu.",
      "schedule_timeline": "Försäljningsplan för {year}",
      "schedule_production": "Produktion",
      "schedule_auction": "Auktion Q{quarter}",
      "schedule_total": "Totalt",
      "schedule_opens_on": "Öppnar {date}",
      "schedule_group_early": "Produktion {year} · tidig andel {percent}%",
      "schedule_group_early_note": "(resterande {percent}% under {year})",
      "schedule_group_rest": "Produktion {year} · resterande {percent}%",
      "schedule_group_rest_note": "({percent}% släpptes {year})",
      "commitments_stand_inline": "Vissa åtaganden ligger över det som strategin släpper i dag. De står kvar; strategin gäller nya försäljningar.",
      "held_back": "{mwh} MWh hålls tillbaka av försäljningsstrategin ({strategy}).",
      "held_back_next_release": "{mwh} MWh hålls tillbaka av försäljningsstrategin ({strategy}); ytterligare {next} MWh släpps den {date}.",
      "held_back_reason": "hålls tillbaka av försäljningsstrategin",
      "held_back_reason_until": "hålls tillbaka av försäljningsstrategin till {date}",
      "override": {
        "label": "Ignorera alla försäljningsstrategier (FARLIGT)",
        "banner_title": "Försäljning utöver producentens försäljningsstrategi",
        "subject": "{mandate}: {period}",
        "beyond_line": "{subject} — {mwh} MWh utöver försäljningsstrategin ({strategy}).",
        "beyond_line_next_release": "{subject} — {mwh} MWh utöver försäljningsstrategin ({strategy}); nästa släpp den {date}.",
        "ignored_nothing_beyond": "Försäljningsstrategin ignoreras — inget uttag överskrider den ännu",
        "ignored_figures_unknown": "Försäljningsstrategin ignoreras — dess siffror kunde inte läsas; sparandet redovisar volym utöver den"
      }
    },
    "picker": {
      "mode": {
        "existing_inventory": "Befintligt lager",
        "future_inventory": "Framtida produktion"
      },
      "new_pap_deal": "Ny affär efter produktion →",
      "deal": {
        "title": "Affär",
        "description": "Köparen, priserna och leveransplanen sätts på affärssidan när det här utkastet finns."
      },
      "filters": {
        "title": "Produktionsperiod och snabbfilter"
      },
      "mandates": {
        "title": "Välj mandat"
      },
      "cancel": "Avbryt",
      "confirm": "Skapa affärsutkast",
      "confirming": "Skapar…",
      "footer_note": "Att skapa affären sparar ett utkast med ett åtagande per mandat och ett leveransutkast. Köparuppgifter, priser och leveransplan sätts på affärssidan.",
      "criteria": {
        "description": "Vad köparen binder sig till. Affären hålls till dessa kriterier under hela sin livstid.",
        "name": "Affärens namn",
        "name_placeholder": "t.ex. Nordic buyer 2026",
        "description_label": "Beskrivning",
        "description_placeholder": "Valfri text för fakturaraden",
        "countries": "Länder",
        "countries_all": "Alla länder",
        "countries_hint": "Förifyllt med standardländerna för AIB GC. Töm fältet för att tillåta alla länder.",
        "technologies": "Tekniker",
        "technologies_all": "Alla tekniker",
        "technologies_advanced": "Avancerat",
        "cod_from": "Driftsatt från",
        "cod_until": "Driftsatt till",
        "cod_hint": "Begränsar affären till anläggningar vars driftsättningsdatum ligger i intervallet.",
        "support": "Produktionsstöd",
        "support_any": "Spelar ingen roll",
        "support_no": "Endast utan stöd",
        "ecolabels": "Miljömärkningar",
        "ecolabels_all": "Inget krav på miljömärkning",
        "ecolabels_hint": "OK-power new löper ut med anläggningens ålder, så ett mandat kan klara ett tidigt produktionsår och falla på ett senare.",
        "min_price_filter": "Dölj mandat dyrare än",
        "min_price_filter_hint": "Endast ett vyfilter. Det sparas inte med affären.",
        "quick_filters": "Snabbfilter",
        "quick_aib_gc": "Standard AIB GC",
        "quick_hsw": "HSW",
        "quick_biomass": "@:common.technology.biomass",
        "quick_nuclear": "Kärnkraft",
        "name_required": "Ge affären ett namn."
      },
      "ecolabel": {
        "ekoenergy": "EKOenergy förgodkänd",
        "okpower": "OK-power-kompatibel",
        "okpower_new": "OK-power new-kompatibel"
      },
      "period": {
        "title": "Produktionskvartal",
        "from": "Från",
        "until": "Till",
        "invalid_range": "Intervallet slutar före det börjar.",
        "selected": "{count} kvartal: {periods}",
        "cover_note": "Varje mandat säljer intervallet i sin egen bredd: per kvartal där dess utbud och register tillåter det, annars per halvår eller år. Ett mandat som inte kan täcka hela intervallet utelämnas. Varje del levereras efter kvartalet den slutar i."
      },
      "take": {
        "filter_mandate": "Mandat eller bolag",
        "auto_distribute": "Fördela automatiskt",
        "spread": "Sprid över mandat",
        "target": "MWh",
        "target_label": "Målvolym",
        "clear": "Rensa",
        "hidden_takes": "Valda mandat dolda av filtren: {count} ({mwh} MWh).",
        "show_hidden_takes": "Visa dem",
        "remove_hidden_takes": "Ta bort deras volymer",
        "mandate": "Mandat",
        "technology": "Teknik",
        "country": "Land",
        "cod": "Äldsta driftsättning",
        "ecolabels": "Miljömärkningar",
        "support": "Stöd",
        "conditions": "Villkor",
        "take": "Ta (MWh)",
        "no_floor": "Inget golv",
        "floor_value": "{value} €/MWh",
        "contango": {
          "any": "säljer bara vid contango",
          "at_least_20_percent": "säljer bara ≥ 20 % över spot"
        },
        "contango_filter": {
          "none": "Inget contangovillkor",
          "any": "Valfri contango",
          "at_least_20_percent": "Contango ≥ 20 %"
        },
        "cadence": "Dessa anläggningar utfärdar i bredare perioder än mandatets delar i detta intervall.",
        "allocation_not_ready": "Allokeringen är avstängd för {companies}, så inget läggs i depå för dem.",
        "capacity_cap": "Högst {value} MWh över det valda intervallet.",
        "capacity_period": "{period}: {value}",
        "row_subtitle": "{companies} · {devices}",
        "empty": "Inget mandat kan täcka den här produkten i det här intervallet.",
        "loading": "Söker mandat",
        "refreshing": "Uppdaterar",
        "refresh_pending": "Vänta tills uttagstabellen har uppdaterats innan affären skapas.",
        "load_failed": "Uttagstabellen kunde inte laddas.",
        "hint_floor": "En leverans ur det här urvalet får inte prissättas under {value} €/MWh.",
        "warnings_title": "Värt att kontrollera",
        "contango_check": {
          "any": "Kontrollera spotpriset manuellt (contango)",
          "at_least_20_percent": "Kontrollera spotpriset manuellt (contango 20 %)"
        },
        "ineligible_title": "Uteslutna ({count})",
        "ineligible_hint": "Mandat du får använda men som den här produkten eller perioden utesluter."
      },
      "summary": {
        "all": "Alla mandat",
        "taken": "Taget",
        "mandates_count": "{count} mandat",
        "by_period": "Per produktionsperiod",
        "by_period_estimate": "Uppskattad fördelning. Den exakta bestäms när affären skapas.",
        "by_country": "Per land",
        "by_price": "Per prisvillkor",
        "by_technology": "Per teknik",
        "by_cod": "Driftsättningsdatum",
        "re100": "RE100-tillämplighet",
        "by_ecolabel": "Miljömärkningsstatus",
        "by_support": "Stödstatus",
        "cod_young": "COD ≤5 år",
        "cod_middle": "COD 6–15 år",
        "cod_old": "COD >15 år",
        "mandate_qualifications": "Egenskaperna beskriver hela mandat, inte tilldelade certifikat. COD utgår från den äldsta anläggningen; RE100 och miljömärkningar kräver att alla anläggningar uppfyller kraven under hela perioden.",
        "judged_at": "bedömt per {date}",
        "nothing_taken": "Inget taget ännu."
      },
      "errors": {
        "no_takes": "Ta volym ur minst ett mandat.",
        "create_failed": "Affären kunde inte skapas.",
        "over_capacity": "Ett uttag överstiger vad mandatet får sälja. Sänk det först till mandatets tak."
      }
    },
    "pap": {
      "title": "Ny affär efter produktion",
      "description": "En affär efter produktion köper ett mandats hela produktion, månad för månad, mot ett avtalat schema.",
      "mandate": "Mandat efter produktion",
      "mandate_hint": "Bara mandat efter produktion kan täcka affären; deras anläggningar tillhör inget annat mandat.",
      "mandate_empty": "Det finns inget mandat efter produktion ännu. Skapa ett i producentens översikt först.",
      "mandate_devices": "{devices} anläggningar · {companies} bolag",
      "mandate_blocked_choose_another": "Välj ett annat mandat för att skapa affären.",
      "name": "Affärens namn",
      "name_placeholder": "t.ex. Vattenkraft 2027",
      "description_label": "Beskrivning",
      "description_placeholder": "Valfri text för fakturaraden",
      "unit_price": "Enhetspris",
      "unit_price_hint": "Varje avtalsmånad faktureras till det här priset.",
      "window": "Avtalsperiod",
      "window_start": "Första månaden",
      "window_end": "Sista månaden",
      "window_invalid": "Perioden slutar före den börjar.",
      "window_missing": "Välj periodens första och sista månad.",
      "window_too_long": "En avtalsperiod omfattar högst {count} månader.",
      "schedule": "Avtalat schema",
      "schedule_hint": "Ett mål per månad i perioden. Produktionen jämförs med det månad för månad.",
      "schedule_total": "{value} MWh över {count} månader",
      "tolerance": "Volymtolerans",
      "tolerance_hint": "Hur mycket en månad får avvika från sitt mål innan den flaggas.",
      "context_failed": "Ägaralternativen kunde inte läsas in.",
      "create": "Skapa affär",
      "creating": "Skapar…",
      "cancel": "Avbryt",
      "create_failed": "Affären kunde inte skapas.",
      "load_failed": "Mandaten kunde inte laddas.",
      "loading": "Laddar mandat",
      "production_range_from_until": "Det här mandatet säljer bara produktion från {from} till och med {until}.",
      "production_range_from": "Det här mandatet säljer bara produktion från {from}.",
      "production_range_until": "Det här mandatet säljer bara produktion till och med {until}.",
      "window_outside_range": "Avtalsperioden måste ligga inom den produktion som mandatet säljer."
    },
    "transaction_header": {
      "title": "Terminsleverans",
      "deal": "Affär",
      "window_open": "Leverera senast {date}",
      "window_range": "Leverera mellan {start} och {end}",
      "escrowed_of_planned": "{escrowed} av {planned} MWh i depå",
      "managed_note": "Poster, volymer, köparuppgifter och priser kommer från affären och ändras där.",
      "open_deal": "Öppna affären",
      "deal_notes": "Affärens interna anteckningar",
      "delivery_notes": "Leveransens interna anteckningar"
    },
    "deals": {
      "loading": "Laddar affären…",
      "not_found_title": "Affären hittades inte",
      "not_found_body": "Affären finns inte, eller så har du inte behörighet till den.",
      "load_failed_title": "Affären kunde inte laddas",
      "load_failed_body": "Något gick fel hos oss. Försök igen om en stund.",
      "draft_warning": "Affärsutkast: leveranserna visas inte under Kommande leveranser och inga certifikat tilldelas förrän affären har bekräftats.",
      "common": {
        "cancel": "Avbryt",
        "close": "Stäng",
        "commitment_gone": "Det här åtagandet finns inte längre i affären."
      },
      "header": {
        "back": "← Terminsaffärer",
        "buyer": "Köpare: {buyer}",
        "buyer_missing": "Ingen köpare angiven ännu",
        "signed_at": "signerad {date}"
      },
      "badges": {
        "escrow_shortfall": "{mwh} MWh saknas i depå",
        "infeasible": "{mandate} täcker inte {period} — {mwh} MWh saknas",
        "stale_draft": "Gammalt utkast",
        "drift_report": "{count} anläggningar passar inte längre | {count} anläggning passar inte längre | {count} anläggningar passar inte längre",
        "drift_report_line": "{device}: {reasons}",
        "device_number": "Anläggning {id}",
        "free_escrow": "{mwh} MWh i depå väntar på återlämning"
      },
      "metadata": {
        "title": "Köpare och avtal",
        "edit": "Redigera",
        "edit_title": "Köpar- och avtalsuppgifter",
        "save": "Spara",
        "name": "Affärens namn",
        "description": "Beskrivning",
        "buyer": "Köpare",
        "emails": "Köparens e-postadresser",
        "registration_authority": "Registerhållare",
        "billing_country": "Faktureringsland",
        "deal_volume": "Affärsvolym",
        "signed_at": "Signerad",
        "created_at": "Skapad",
        "confirmed_at": "Bekräftad",
        "links": "Länkar",
        "contract_links": "Avtal",
        "transaction_link": "Transaktion",
        "offering_sheets": "Offertblad",
        "offering_sheets_help": "Kommaseparerade länkar, äldst först. Ett genererat blad läggs till här; ta bort gamla här när listan är full.",
        "transaction_link_invalid": "Ange en enda länk som börjar med http:// eller https://.",
        "shipped_keep_details": "Den här affären har skickat {count} leveranser. Deras transaktioner och fakturor behåller köpar- och avtalsuppgifterna de skickades med; en ändring här når bara leveranser som inte skickats än. | Den här affären har skickat {count} leverans. Dess transaktion och fakturor behåller köpar- och avtalsuppgifterna den skickades med; en ändring här når bara leveranser som inte skickats än. | Den här affären har skickat {count} leveranser. Deras transaktioner och fakturor behåller köpar- och avtalsuppgifterna de skickades med; en ändring här når bara leveranser som inte skickats än.",
        "not_set": "Ej angivet"
      },
      "criteria": {
        "title": "Behörighetskrav",
        "edit": "Redigera",
        "save": "Spara krav",
        "locked": "Låst",
        "countries": "Länder",
        "technologies": "Tekniker",
        "cod": "Driftsättningsdatum",
        "cod_from": "Driftsatt från",
        "cod_until": "Driftsatt till",
        "cod_range": "{from} — {until}",
        "any": "valfritt",
        "support": "Produktionsstöd",
        "support_any": "Båda",
        "support_unsupported_only": "Endast utan stöd",
        "ecolabels": "Miljömärkningar",
        "unrestricted": "Utan begränsning",
        "conflicts_help": "Ändringen kontrolleras först när du sparar. En ändring som strider mot täckning eller depå som affären fortfarande levererar avvisas; inget frigörs eller återlämnas för den.",
        "conflicts_blocking": "Ändringen strider mot det som affären fortfarande levererar. Åtgärda detta först och spara igen:",
        "conflicts_warning": "Redan levererat enligt nuvarande krav. Att spara lämnar detta som det är:",
        "save_anyway": "Spara ändå",
        "ecolabel": {
          "ekoenergy": "EKOenergy förgodkänd",
          "okpower": "OK-power-kompatibel",
          "okpower_new": "OK-power new-kompatibel"
        }
      },
      "plan": {
        "title": "Leveransplan",
        "generate_offering_sheet": "Skapa erbjudandeblad",
        "offering_sheet_link": "Öppna senaste erbjudandebladet",
        "edit_plan": "Redigera plan",
        "empty": "Affären har inga leveranser ännu.",
        "delivery": "Leverans",
        "period": "Produktionsperiod",
        "escrowed_of": "I depå / planerat",
        "backed_by": "Täcks av",
        "backed_by_commitment": "Täcks av åtagande {id}. Se tabellen Åtaganden.",
        "open_volume": "Otäckt",
        "no_slices": "Inget är planerat i den här leveransen ännu.",
        "n_short": "{mwh} saknas",
        "n_open": "{mwh} otäckt",
        "remove": "Ta bort",
        "actions": {
          "menu": "Åtgärder för {period}",
          "resize": "Ändra volym",
          "resize_tooltip": "Ändra den bundna volymen för den här produktionsperioden. Den kan inte minskas under volymen som redan ligger i depå.",
          "split_move": "Dela och flytta",
          "split_move_tooltip": "Flytta hela eller delar av den bundna volymen till en annan leverans; depån följer med.",
          "narrow": "Smalna av",
          "narrow_tooltip": "Dela den bundna produktionsperioden i kortare perioder, till exempel ett år i kvartal, utan att ändra den totala volymen.",
          "remove_backing": "Ta bort täckning",
          "remove_backing_tooltip": "Ta bort mandatets täckning från volymen och lämna den öppen för ett annat mandat.",
          "remove_backing_escrowed_tooltip": "{mwh} MWh är deponerade mot den här volymen. Återlämna dem till ägaren innan täckningen tas bort.",
          "pull_to_escrow": "Dra in till depå…",
          "pull_to_escrow_tooltip": "Välj tillgängliga certifikat från mandatet och flytta dem till depå för åtagandet.",
          "back": "Täck…",
          "back_tooltip": "Täck den här öppna volymen med ett åtagande från ett kvalificerat mandat."
        },
        "window_on_or_before": "Senast {end}",
        "window_range": "{start} — {end}",
        "unit_price": "{price} €/MWh",
        "no_price": "Inget pris angivet",
        "delivery_shortfall": "{mwh} MWh saknas",
        "deliver": "Leverera →",
        "deliver_anyway": "Leverera ändå",
        "transaction_link": "Transaktion #{id}",
        "outside_window_title": "Utanför leveransfönstret",
        "outside_window_body": "Dagens datum ligger utanför leveransens fönster ({window}). Leverera ändå?",
        "summary_open": "{mwh} MWh otäckt",
        "summary_fully_committed": "Hela den planerade volymen är bunden",
        "summary_totals": "{planned} planerat · {committed} bundet · {escrowed} i depå",
        "summary_deal_volume": "affärsvolym {mwh} MWh",
        "summary_no_deal_volume": "ingen affärsvolym sparad",
        "confirm": "Bekräfta affären",
        "cancel_deal": "Annullera affären",
        "cancel_title": "Annullera den här affären?",
        "cancel_body": "Annullering frigör alla åtaganden och makulerar alla oleverade utkast. Volym som redan ligger i depå stannar kvar tills den återlämnas till ägarna.",
        "cancel_body_pap": "Annullering makulerar alla månader som ännu inte levererats. Certifikat som redan ligger i depå för de månaderna väntar sedan på återlämning: återlämna dem till ägarna från kortet ”Depå väntar på återlämning”. Månader som redan levererats ligger kvar.",
        "unconfirm": "Tillbaka till utkast",
        "unconfirm_title": "Återställa affären till utkast?",
        "unconfirm_body": "Affären lämnar fördelningskön, så inga fler certifikat läggs i depå för den, och dess kriterier kan redigeras igen. Åtagandena står kvar, så volymen förblir reserverad. Utan signeringsdatum förlorar leveranserna sitt prisdatum. Bekräftas den igen hamnar den sist i kön."
      },
      "editor": {
        "title": "Redigera plan",
        "discard": "Kasta",
        "save": "Spara plan",
        "window_start": "Fönstrets start · valfritt",
        "window_end": "Fönstrets slut",
        "unit_price": "Enhetspris",
        "remove_delivery": "Ta bort leverans",
        "add_period": "Lägg till period",
        "add_delivery": "Lägg till leverans",
        "period_placeholder": "2026-Q1, 2026-04 eller 2026",
        "planned_for": "Planerad volym för {period}",
        "backed_caption": "{mwh} MWh täckta",
        "below_backed": "{mwh} MWh är täckta här. Planera minst så mycket.",
        "remove_row_backed": "{mwh} MWh är täckta. Ta bort täckningen i planen först.",
        "duplicate_period": "Den här produktionsperioden finns redan i den här leveransen."
      },
      "correction": {
        "editor_hint": "Levererade och makulerade leveranser behåller sina perioder. Som superadministratör kan du ändå korrigera deras fönster och pris; redan skapade fakturor behåller sina belopp.",
        "schedule_hint": "Priset för en levererad månad kan korrigeras. Redan skapade fakturor behåller det gamla priset.",
        "voided_delivery": "Den här leveransen är makulerad: ändringen visas bara på affärens sida, och ingen faktura eller rapport läser den.",
        "buyer_invoice_replaceable": "Köparfakturan {number} behåller det gamla priset. Skapa den på nytt om den inte har skickats än.",
        "buyer_invoice_sent": "Köparfakturan {number} har skickats och behåller det gamla priset. Den kan inte längre skapas på nytt.",
        "completion_invoices_issued": "Producentutbetalningen och eventuell provision som fakturerades vid slutförandet behåller det gamla priset.",
        "dashboard_period_moves": "Ingen faktura läser leveransfönstret. Bara den finansiella översikten flyttar försäljningen till perioden för det nya fönstrets slut."
      },
      "commitments": {
        "title": "Åtaganden",
        "empty": "Inget täcker den här affären ännu.",
        "description": "Varje rad är ett uttag av volym från ett mandat. Volymen och prisvillkoren låstes när uttaget gjordes; mandatets utbud och priser kan ha ändrats sedan dess.",
        "granularity": "Granularitet: {width}",
        "id_header": "ID",
        "mandate_header": "Mandat",
        "pulled_on": "Taget",
        "volume": "I depå / bundet",
        "price_conditions": "Prisvillkor",
        "released": "Frigjord",
        "released_tooltip": "Dagen då denna backning togs bort helt: volymen gick tillbaka till mandatets tillgänglighet och åtagandet gör inte längre anspråk på dess lager.",
        "floor": "golv {price} €/MWh",
        "no_floor": "inget golv",
        "contango": {
          "any": "bara vid contango",
          "at_least_20_percent": "bara ≥ 20 % över spot"
        },
        "show_escrow": "Deponerat…",
        "show_escrow_tooltip": "Visa vilka företags certifikat som täcker det här åtagandet; en superadministratör kan återlämna dem till ägarna härifrån.",
        "contributions": "Bidrag · depå per bolag",
        "escrow_title": "{mandate} · uttaget {date}",
        "company": "Bolag",
        "no_escrow": "Inget ligger i depå mot det här åtagandet ännu.",
        "entry_width": {
          "quarter": "kvartalsvis",
          "month": "månadsvis",
          "half_year": "halvårsvis",
          "year": "årsvis"
        },
        "pay_as_produced": "efter produktion",
        "strategy_overridden": "Såld utöver försäljningsstrategin",
        "sold_beyond_strategy": "{mandate} — {mwh} MWh såldes utöver försäljningsstrategin."
      },
      "free_escrow": {
        "title": "Depå väntar på återlämning",
        "subtitle": "{mwh} MWh utan någon aktiv leverans bakom sig",
        "return": "Återlämna till ägaren…",
        "company": "Bolag",
        "period": "Produktionsperiod"
      },
      "add_commitment": {
        "title_back": "Täck {period}",
        "submit": "Lägg till åtagande",
        "search": "Sök mandat",
        "search_placeholder": "Skriv en del av ett mandatnamn",
        "searching": "Söker mandat…",
        "no_mandates": "Inget mandat du får dra från matchar sökningen.",
        "listed": "{mwh} MWh utbjudet",
        "no_availability": "inget tillgängligt i {period}",
        "takes_title": "Hur mycket som ska tas från perioden",
        "open": "Otäckt",
        "take": "Ta",
        "take_for": "Volym att ta för {period}",
        "max": "max {mwh}",
        "over_max": "högst {mwh} MWh kan tas här",
        "impact": "Den otäckta volymen minskar från {from} MWh till {to} MWh.",
        "submit_beyond_strategy": "Lägg till utöver försäljningsstrategin"
      },
      "resize": {
        "title": "Ändra åtagandets volym",
        "submit": "Ändra",
        "body": "{period} · {mandate} · {mwh} MWh bundet i dag.",
        "new_volume": "Ny bunden volym",
        "escrow_floor": "{mwh} MWh ligger redan i depå mot den här delen, så volymen kan inte gå under det.",
        "shrink_warning": "De {mwh} MWh du avstår blir öppna och går tillbaka till mandatets tillgängliga volym. Åtagandet behåller sina sparade prisvillkor för resten; att täcka den volymen igen senare är ett nytt åtagande på den dagens villkor.",
        "submit_beyond_strategy": "Ändra utöver försäljningsstrategin"
      },
      "move": {
        "title": "Flytta eller dela",
        "submit": "Flytta",
        "body": "{period} · {mwh} MWh. Volymen som redan ligger i depå följer med.",
        "target": "Målleverans",
        "target_placeholder": "Välj en leverans",
        "volume": "Volym att flytta",
        "volume_placeholder": "Hela delen",
        "volume_hint": "Lämna tomt för att flytta hela delen.",
        "volume_out_of_range": "mellan 1 och {mwh} MWh, delens volym"
      },
      "narrow": {
        "title": "Smalna av perioden",
        "submit": "Smalna av",
        "body": "{period} · {mwh} MWh. Volymen fördelas över delperioderna i proportion till vad mandatet bjuder ut i var och en av dem.",
        "width": "Smalna av till",
        "already_narrowest": "Perioden är redan så smal den kan bli.",
        "hint": "Volym som redan ligger i depå knyts om till den delperiod varje certifikat hör till."
      },
      "remove_backing": {
        "title": "Ta bort mandatets täckning?",
        "pull": "Taget {date} · {conditions}",
        "released_whole": "De {mwh} MWh går tillbaka till {mandate}s tillgängliga volym och åtagandet frigörs helt eftersom det här är dess sista bundna volym.",
        "released_part": "De {mwh} MWh går tillbaka till {mandate}s tillgängliga volym och åtagandet frigörs delvis eftersom dess övriga bundna volym behåller det.",
        "snapshot_lost": "Prisvillkoren som sparades vid uttaget går förlorade. Att täcka volymen igen senare är ett nytt åtagande på den dagens mandatvillkor, och bara om volymen fortfarande finns kvar.",
        "confirm": "Ta bort täckning"
      },
      "return_escrow": {
        "section_title": "Återlämna till ägaren",
        "title": "Återlämna depå till ägaren",
        "submit": "Återlämna valda",
        "loading": "Laddar certifikat i depå…",
        "body": "De valda certifikaten stannar på Solderas registerkonto och tilldelas en ny virtuell portfölj hos varje ägare. Varje rad kan återlämnas delvis.",
        "nothing": "Inget ligger i depå för den här affären.",
        "company": "Bolag",
        "device": "Anläggning",
        "month": "Produktionsmånad",
        "escrowed": "I depå",
        "return_count": "Återlämna",
        "select_all": "Välj alla rader",
        "select_row": "Välj {device}",
        "count_for": "Antal att återlämna för {device}",
        "over_count": "högst {mwh} MWh är i depå på denna rad",
        "summary_title": "Återlämnas",
        "results_title": "{moved} MWh återlämnade, {failed} rad(er) misslyckades.",
        "result_line": "{count} MWh från post {item}"
      },
      "pull_escrow": {
        "title": "Dra in till depå",
        "submit": "Dra in till depå",
        "body": "Flytta certifikat som passerade terminssteget in i det här åtagandets depå. Producenten behåller ägandet.",
        "company": "Bolag",
        "company_placeholder": "Välj en medlem i mandatet",
        "source_portfolio": "Källportfölj",
        "portfolio_placeholder": "Välj en portfölj",
        "allowed_sources": "Bara oallokerade, hållna, spot- och virtuella portföljer går att dra från.",
        "loading_items": "Laddar certifikat…",
        "no_items": "Portföljen innehåller inget som går att dra in.",
        "items_failed": "Certifikaten kunde inte läsas in. Stäng formuläret och öppna det igen för att försöka på nytt.",
        "after_move": "Depån på det här åtagandet går från {from} MWh till {to} MWh av {total} MWh bundet.",
        "results_title": "{moved} rad(er) flyttade, {failed} rad(er) misslyckades.",
        "result_line": "{count} MWh från post {item}"
      },
      "producer_prices": {
        "button": "Producentpriser…",
        "title": "Producentpriser · {window}",
        "body": "Vad varje mandats producenter fakturerar för den här leveransen. Det här är Solderas inköpspriser och visas aldrig för affärens ägare.",
        "amount": "MWh",
        "price": "Enhetspris",
        "price_for": "Enhetspris för {mandate}",
        "delivery_price_note": "Ett mandat som lämnas tomt betalar leveransens eget pris: {price}.",
        "trade_owner": "Affärsförmedlare",
        "trade_owner_help": "Får provision på swapmarginalen.",
        "trade_owner_placeholder": "Välj affärsförmedlare…",
        "trade_owner_none": "Ingen",
        "submit": "Spara",
        "shipped_meanwhile": "Den här leveransen skickades medan du redigerade. Dess priser är nu historik, så dina ändringar sparades inte.",
        "delivery_gone": "Den här leveransen finns inte längre i affären, så dina ändringar sparades inte.",
        "blank_price": "tomt (leveransens pris)",
        "default_price": "Producentens standardpris",
        "default_price_help": "Varje mandat som lämnas tomt betalar detta pris. Lämna tomt för att använda leveransens eget pris.",
        "default_price_note": "Ett mandat som lämnas tomt betalar producentens standardpris: {price}.",
        "default_price_none": "Inget (leveransens eget pris)",
        "blank_follows_default": "tomt (producentens standardpris)",
        "no_escrow_yet": "Ingen escrow än: producenternas rader visas här när certifikaten kommer.",
        "mandate_floor": "Minst {price}",
        "no_mandates": "Inget mandat stödjer leveransen än. Stöd dess öppna volym för att prissätta producenterna.",
        "mandate": "Mandat",
        "mandates_removed": "{count} mandat slutade stödja leveransen under tiden och togs bort | {count} mandat slutade stödja leveransen under tiden och togs bort | {count} mandat slutade stödja leveransen under tiden och togs bort",
        "kept_price": "Stödjer inte längre",
        "kept_price_help": "Sparat från innan mandatet slutade stödja leveransen. Det gäller igen om mandatet stödjer leveransen igen; ta bort det om det inte ska gälla.",
        "remove_mandate_price": "Ta bort priset för {mandate}",
        "conflict": "{company} säljer genom {mandates}, men dess enda rad kan bära ett pris. Prissätt mandaten lika, eller flytta det ena mandatets delar till en egen leverans: leveransen kan inte skickas förrän dess.",
        "foreseen_conflict": "{company} kan sälja genom {mandates}, men dess enda rad kan bära ett pris. Inget hålls tillbaka än: när dess depå kommer genom två av dem kan leveransen inte skickas förrän mandaten har samma pris eller det ena mandatets delar flyttas till en egen leverans.",
        "conflict_badge": "Priskonflikt"
      },
      "price_conflict": {
        "warning": "Producentpriserna står i konflikt · {window}: {company} säljer genom {mandates}, men dess enda rad kan bära ett pris. Leveransen kan inte skickas förrän mandaten har samma pris eller det ena mandatets delar flyttas till en egen leverans.",
        "foreseen_warning": "Möjlig konflikt mellan producentpriser · {window}: {company} kan sälja genom {mandates}, men dess enda rad kan bära ett pris. När dess depå kommer genom två av dem kan leveransen inte skickas förrän mandaten har samma pris eller det ena mandatets delar flyttas till en egen leverans.",
        "mandate_at": "{mandate} till {price}",
        "no_price": "leveransens pris (inte satt än)",
        "and": " och "
      },
      "delivery_notes": {
        "button": "Anteckningar…",
        "title": "Interna anteckningar · {window}",
        "label": "Interna anteckningar",
        "help": "Endast för personal: kopieras aldrig till leveransens transaktion och visas aldrig för producenter eller köpare.",
        "submit": "Spara",
        "heading": "Interna anteckningar",
        "default_producer_price": "Producenternas standardpris: {price}"
      },
      "pap": {
        "schedule_title": "Nominerat schema och tolerans",
        "edit_schedule": "Redigera schema",
        "save_schedule": "Spara schema",
        "window": "{start} — {end}",
        "no_window": "Inget avtalsfönster angivet",
        "no_schedule": "Ingen månad är nominerad ännu.",
        "tolerance": "Tolerans ± {percent} %",
        "mandates": "Mandat | Mandat | Mandat",
        "tolerance_label": "Tolerans ± %",
        "tolerance_hint": "Hur mycket en månad får över- eller understiga sin nominering innan den flaggas.",
        "month": "Månad",
        "nominated": "Nominerat",
        "target_for": "Nominerad volym för {month}",
        "monitoring_title": "Månadsuppföljning",
        "monitoring_loading": "Laddar uppföljningen…",
        "monitoring_empty": "Det finns inget att följa upp ännu.",
        "nominated_vs_escrowed": "Nominerat mot depå",
        "delta": "Avvikelse mot nominerat",
        "status": "Status",
        "status_pending": "Väntar",
        "status_within": "Inom bandet",
        "status_over": "Över bandet",
        "status_under": "Under bandet",
        "status_delivered": "Levererat",
        "ship_early_title": "Leverera den här månaden nu?",
        "ship_early_body": "Månaden är inte klar än: produktionen kan fortsätta, och bara det som ligger i depå just nu levereras. Leveransen fryser månaden, så certifikat som utfärdas för den efteråt blir fri depå som måste återlämnas för hand.",
        "ship_early_confirm": "Leverera ändå",
        "sell_price": "Försäljningspris",
        "sell_price_for": "Försäljningspris för {month}",
        "sell_price_invalid": "Ange ett pris över 0 med högst 3 decimaler.",
        "months_shipped": "{months} levererades under tiden; dina ändringar för de månaderna togs bort | {months} levererades under tiden; dina ändringar för den månaden togs bort | {months} levererades under tiden; dina ändringar för de månaderna togs bort"
      },
      "transaction_status": {
        "DRAFT": "Utkast",
        "PENDING_BUYER_DETAILS": "Köparuppgifter saknas",
        "PENDING_CONTRACTS": "Avtal saknas",
        "READY_TO_TRANSFER": "Klar för överföring",
        "DELIVERED": "Levererad",
        "COMPLETED": "Slutförd",
        "voided": "Makulerad"
      },
      "merge": {
        "changed_meanwhile": "Någon annan sparade ändringar medan du redigerade. Dina ändringar finns kvar och har slagits ihop med deras. Kontrollera resultatet och spara igen.",
        "unaffected": "Någon annan sparade affären medan du redigerade, men inget av det som visas här ändrades. Spara igen för att tillämpa dina ändringar.",
        "taken_over": "{count} sparade ändringar togs över | {count} sparad ändring togs över | {count} sparade ändringar togs över",
        "conflicts": "{count} fält ändrades på båda sidor; välj ett värde för vart och ett nedan | {count} fält ändrades på båda sidor; välj ett värde för det nedan | {count} fält ändrades på båda sidor; välj ett värde för vart och ett nedan",
        "yours": "Ditt: {value}",
        "saved_now": "Sparat nu: {value}",
        "keep_yours": "Behåll ditt",
        "use_saved": "Använd sparat"
      }
    }
  },
  "soldera_inventory": {
    "title": "Soldera-lager",
    "description": "Ursprungsgarantier som Soldera kan leverera nu eller från framtida produktion. Välj volym och skicka ditt erbjudande till Soldera.",
    "not_enabled": "Soldera-lagret är inte aktiverat för ditt konto. Kontakta {email} för åtkomst.",
    "purchase_details": "Köpuppgifter",
    "counterparty_emails": "E-postadresser för faktura",
    "counterparty_emails_hint": "Separera flera adresser med kommatecken.",
    "price": "Pris",
    "price_hint": "Ditt pris per certifikat (1 MWh). Certifikat vars producent begär mer visas inte.",
    "select_certificates": "Välj certifikat",
    "create_purchase": "Skicka bindande erbjudande",
    "regions": "Regioner",
    "blocked": {
      "no_selection": "Välj de certifikat du vill köpa.",
      "no_price": "Ange ett pris över noll.",
      "mixed_authorities": "Välj certifikat från ett och samma certifikatsystem.",
      "no_company": "Välj företaget du köper för."
    },
    "created_title": "Bindande erbjudande skickat",
    "created_description": "Ditt bindande erbjudande på {mwh} MWh har skickats till Soldera. Vi kontaktar dig för bekräftelse.",
    "billing_country": "Faktureringsland",
    "generate_breakdown": "Skapa Excel-översikt",
    "open_breakdown": "Öppna översikt",
    "breakdown_ready_title": "Översikten är klar",
    "breakdown_ready_description": "Översikten öppnades i en ny flik och delades med {email}.",
    "tabs": {
      "spot": "Tillgängligt nu",
      "forward": "Framtida produktion"
    },
    "forward": {
      "select_mandates": "Välj framtida produktion",
      "price_hint": "Ditt pris per MWh, för varje leverans. Produktion där producenterna begär mer visas inte.",
      "no_mandates": "Ingen framtida produktion erbjuds för dessa perioder till detta pris.",
      "spread_over_mandates": "@:forwards.picker.take.spread",
      "by_period": "@:forwards.picker.summary.by_period",
      "all_technologies": "Alla tekniker",
      "all_countries": "Alla länder",
      "columns": {
        "technology": "@:forwards.picker.take.technology",
        "country": "@:forwards.picker.take.country",
        "scheme": "System",
        "cod_age": "Äldsta COD (år)",
        "support": "@:forwards.picker.take.support",
        "ecolabels": "@:forwards.picker.take.ecolabels",
        "capacity": "Tillgängliga MWh",
        "take": "Dina MWh"
      },
      "blocked": {
        "no_takes": "Ange de MWh du vill ha från minst ett mandat."
      },
      "warnings": {
        "pl_be_mixed": "Ditt urval blandar {flagged} med {others}, som vanligtvis köps som separata produkter.",
        "standard_aib_gc_mixed": "Ditt urval blandar Standard AIB GC-länder ({standard}) med länder utanför standardlistan ({outside}).",
        "technology_mixed": "Ditt urval blandar {advanced} med {hsw}; HSW-produkter (vatten, sol, vind) utesluter det vanligtvis."
      }
    }
  },
  "inventory_selection": {
    "quick_filters": "@:forwards.picker.criteria.quick_filters",
    "standard_aib_gc": "@:forwards.mandates.eligibility.tier.standard_aib_gc",
    "vintage": "Produktionsår",
    "tech_filters": {
      "hsw": "Vatten, sol, vind",
      "biomass": "@:common.technology.biomass",
      "nuclear": "Kärnkraft"
    },
    "auto_select": "Automatiskt urval",
    "target": "@:forwards.picker.take.target",
    "target_label": "@:forwards.picker.take.target_label",
    "spread_over_companies": "Fördela över företag",
    "clear": "@:forwards.picker.take.clear",
    "available": "Tillgängligt",
    "selected": "Valt",
    "row_count": "{count} rad | {count} rader",
    "breakdowns": {
      "production_months": "Produktionsmånader",
      "support_status": "@:forwards.picker.summary.by_support",
      "technology": "@:forwards.picker.take.technology",
      "commercial_operations_date": "@:forwards.picker.summary.by_cod",
      "re100_applicable": "@:forwards.picker.summary.re100",
      "ecolabel_status": "@:forwards.picker.summary.by_ecolabel",
      "supported": "Med stöd",
      "unsupported": "Utan stöd",
      "unknown": "@:common.unknown",
      "cod_le_5": "@:forwards.picker.summary.cod_young",
      "cod_6_15": "@:forwards.picker.summary.cod_middle",
      "cod_gt_15": "@:forwards.picker.summary.cod_old",
      "ekoenergy_pre_approved": "@:forwards.picker.ecolabel.ekoenergy",
      "okpower_new_compatible": "@:forwards.picker.ecolabel.okpower_new"
    }
  },
  "device_groups": {
    "group_devices": "Gruppera anläggningar",
    "new_group": "Ny grupp",
    "edit_group": "Redigera grupp",
    "groups_title": "Anläggningsgrupper",
    "all_devices": "Alla anläggningar",
    "ungrouped": "Ogrupperade",
    "suggested_from_address": "Förslag utifrån adress",
    "create_group": "Skapa grupp",
    "save_group": "Spara grupp",
    "delete_group": "Ta bort grupp",
    "delete_confirm": "Ta bort gruppen \"{name}\"? Dess anläggningar blir ogrupperade.",
    "dismiss": "Dölj",
    "dismiss_suggestion": "Dölj {name}",
    "devices_count": "Inga anläggningar | {count} anläggning | {count} anläggningar",
    "devices_and_power": "Inga anläggningar | {count} anläggning · {power} kW | {count} anläggningar · {power} kW",
    "name_label": "Namn",
    "name_placeholder": "Gruppnamn",
    "pick_devices": "Välj anläggningar",
    "paste_device_ids": "Klistra in anläggnings-ID",
    "start_from_address": "Utgå från adress",
    "search_placeholder": "Sök på anläggnings-ID, namn eller adress",
    "all_technologies": "Alla tekniker",
    "select_matching": "Välj {count}",
    "deselect": "Avmarkera",
    "paste_placeholder": "Ett anläggnings-ID per rad",
    "paste_found": "{found} av {total} hittade",
    "paste_not_found": "{id} hittades inte",
    "paste_in_group": "{id} i {group}",
    "add_devices": "Lägg till anläggningar | Lägg till {count} anläggning | Lägg till {count} anläggningar",
    "modal_hint": "Gruppen visas i anläggningsväljarna i handelsstrategin och i inventariets anläggningsfilter.",
    "device_column": "Anläggning",
    "group_column": "Grupp",
    "in_group": "I {group}",
    "selected_summary": "{count} valda · {power} kW",
    "add_to_group": "Lägg till i grupp",
    "new_group_from_selection": "Ny grupp av markerade",
    "remove_from_group": "Ta bort från grupp",
    "clear_selection": "Rensa val",
    "hint_select_ungrouped": "Markera ogrupperade anläggningar för att lägga till dem i en grupp",
    "hint_select_to_remove": "Markera anläggningar för att ta bort dem från gruppen",
    "select_all_shown": "Markera alla visade anläggningar",
    "select_device": "Markera {device}",
    "group_created": "Gruppen \"{name}\" skapad",
    "group_saved": "Gruppen \"{name}\" sparad",
    "group_deleted": "Gruppen \"{name}\" borttagen",
    "picker": {
      "select_by_group": "Välj efter grupp",
      "hint": "Att välja en grupp lägger till dess nuvarande anläggningar. Anläggningar som läggs till i gruppen senare läggs inte till här.",
      "group_partial_count": "{selected} av {count} anläggningar",
      "other_devices": "Övriga anläggningar",
      "more": "+{count} till",
      "show_less": "Visa färre"
    },
    "filter": {
      "groups": "Grupper",
      "devices": "Anläggningar",
      "n_groups": "Inga grupper | {count} grupp | {count} grupper"
    },
    "errors": {
      "name_taken": "Det finns redan en grupp med det namnet.",
      "limit_reached": "Företaget har redan det högsta tillåtna antalet anläggningsgrupper.",
      "unknown_devices": "Vissa anläggningar är inte längre tillgängliga. Ladda om sidan och försök igen.",
      "devices_in_other_group": "Vissa anläggningar tillhör redan en annan grupp: {devices}"
    }
  }
}
